/* eslint-disable */
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("underscore"), require("jquery"), require("backbone"), require("bluebird"), require("backbone-virtualized-listview"));
	else if(typeof define === 'function' && define.amd)
		define(["underscore", "jquery", "backbone", "bluebird", "backbone-virtualized-listview"], factory);
	else if(typeof exports === 'object')
		exports["projection-grid"] = factory(require("underscore"), require("jquery"), require("backbone"), require("bluebird"), require("backbone-virtualized-listview"));
	else
		root["projection-grid"] = factory(root["underscore"], root["jquery"], root["backbone"], root["bluebird"], root["backbone-virtualized-listview"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_7__, __WEBPACK_EXTERNAL_MODULE_8__, __WEBPACK_EXTERNAL_MODULE_33__, __WEBPACK_EXTERNAL_MODULE_93__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _gridFactory = __webpack_require__(2);

	var _gridFactory2 = _interopRequireDefault(_gridFactory);

	var _package = __webpack_require__(102);

	var _package2 = _interopRequireDefault(_package);

	var _dataSource = __webpack_require__(64);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = {
	  version: _package2.default.version,
	  GridView: __webpack_require__(58),
	  projections: __webpack_require__(18),
	  layout: __webpack_require__(5),
	  factory: _gridFactory2.default,
	  popupEditorPrompt: __webpack_require__(32),
	  dataSource: {
	    Base: _dataSource.DataSource,
	    Memory: _dataSource.MemoryDataSource,
	    OData: _dataSource.ODataDataSource,
	    JSData: _dataSource.JSDataDataSource
	  }
	};

/***/ }),
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	exports.default = function (options) {
	  return new GridFactory(options);
	};

	var _underscore = __webpack_require__(3);

	var _underscore2 = _interopRequireDefault(_underscore);

	var _renderersPlugin = __webpack_require__(4);

	var _renderersPlugin2 = _interopRequireDefault(_renderersPlugin);

	var _projectionPlugin = __webpack_require__(17);

	var _projectionPlugin2 = _interopRequireDefault(_projectionPlugin);

	var _gridViewPlugin = __webpack_require__(57);

	var _gridViewPlugin2 = _interopRequireDefault(_gridViewPlugin);

	var _dataSourcePlugin = __webpack_require__(63);

	var _dataSourcePlugin2 = _interopRequireDefault(_dataSourcePlugin);

	var _gridViewPlugin3 = __webpack_require__(69);

	var _gridViewPlugin4 = _interopRequireDefault(_gridViewPlugin3);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var configPlugin = function configPlugin(definePlugin) {
	  return definePlugin('config', [], function () {
	    return this.config;
	  });
	};

	var GridFactory = function () {
	  function GridFactory() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$vnext = _ref.vnext,
	        vnext = _ref$vnext === undefined ? false : _ref$vnext;

	    _classCallCheck(this, GridFactory);

	    this.pluginIndex = {};
	    this.plugins = [];
	    if (vnext) {
	      this.use(configPlugin).use(_dataSourcePlugin2.default).use(_gridViewPlugin4.default);
	    } else {
	      this.use(configPlugin).use(_projectionPlugin2.default).use(_renderersPlugin2.default).use(_gridViewPlugin2.default);
	    }
	  }

	  _createClass(GridFactory, [{
	    key: 'definePlugin',
	    value: function definePlugin(name, deps, callback) {
	      var _this = this;

	      var plugin = { name: name, deps: deps, callback: callback };

	      this.pluginIndex[name] = plugin;
	      this.plugins.push(plugin);
	      _underscore2.default.each(deps, function (dep) {
	        if (!_underscore2.default.has(_this.pluginIndex, dep)) {
	          throw new Error('unresolved plugin dependency ' + name + ' -> ' + dep);
	        }
	      });
	    }
	  }, {
	    key: 'use',
	    value: function use(callback) {
	      callback(this.definePlugin.bind(this));
	      return this;
	    }
	  }, {
	    key: 'create',
	    value: function create(config) {
	      return _underscore2.default.reduce(this.plugins, function (result, _ref2) {
	        var name = _ref2.name,
	            deps = _ref2.deps,
	            callback = _ref2.callback;
	        return _underscore2.default.extend(result, _defineProperty({}, name, callback.apply(result, _underscore2.default.map(deps, function (dep) {
	          return result[dep];
	        }))));
	      }, { config: config });
	    }
	  }]);

	  return GridFactory;
	}();

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _index = __webpack_require__(5);

	var _index2 = _interopRequireDefault(_index);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = function (definePlugin) {
	  return definePlugin('renderers', ['config'], function (config) {
	    var renderers = [];

	    if (config.scrollable) {
	      if (config.scrollable.virtual) {
	        renderers.push(_index2.default.renderers.Virtualization);
	      }
	      if (config.scrollable.fixedHeader) {
	        renderers.push(_index2.default.renderers.FixedHeader);
	      }
	    }

	    return renderers;
	  });
	};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	module.exports = {
	  TableLayout: __webpack_require__(6),
	  templates: {
	    table: __webpack_require__(9)
	  },
	  renderers: __webpack_require__(12)
	};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(7), __webpack_require__(8)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, $, Backbone) {
	  var View = Backbone.View.extend({
	    events: {
	      'click th': 'thClick',
	      'click td': 'tdClick',
	      'change td>input.grid-text-input': 'editableStringChange'
	    },

	    initialize: function initialize(options) {
	      _.bindAll(this, 'update', 'thClick', 'tdClick', 'dataFor');

	      this.options = _.extend(this.options, options);

	      // TODO [akamel] rename? this isn't a backbone data obj?
	      this.data = undefined;

	      this.container = options.container;
	      this.grid = options.grid;

	      this.renderers = _.map(this.options.renderers, function (Renderer) {
	        return new Renderer({ layout: this });
	      }.bind(this));

	      this.subviews = [];

	      this.onChange = this.onViewPortChange.bind(this);

	      if (!_.isEmpty(this.renderers)) {
	        this.listenTo(this.container, 'scroll:container', this.onViewPortChange);
	        this.listenTo(this.container, 'resize:container', this.onViewPortChange);
	      }

	      this.on('change:viewport', function () {
	        if (this.$el.is(':visible')) {
	          this.scheduleDraw();
	        }
	      });
	    },

	    onViewPortChange: function onViewPortChange() {
	      this.trigger('change:viewport');
	    },

	    monitorViewportChange: function monitorViewportChange(timeout, interval) {
	      timeout = timeout || 1000;
	      interval = interval || 100;

	      var rect = this.el.getBoundingClientRect();
	      var id = window.setInterval(function () {
	        var rectNew = this.el.getBoundingClientRect();

	        if (_.some(['left', 'top', 'width', 'height'], function (key) {
	          return Math.abs(rectNew[key] - rect[key]) > 0.5;
	        })) {
	          this.onViewPortChange();
	        }
	      }.bind(this), interval);

	      window.setTimeout(function () {
	        window.clearInterval(id);
	      }, timeout);
	    },

	    removeSubviews: function removeSubviews() {
	      _.each(this.subviews, function (subview) {
	        subview.remove();
	      });
	      this.subviews = [];
	    },

	    remove: function remove() {
	      this.removeSubviews();
	      this.container.stopListening(this.container);
	      _.each(this.renderers, function (renderer) {
	        return renderer.remove();
	      });
	      Backbone.View.prototype.remove.apply(this, arguments);
	    },

	    thClick: function thClick(e) {
	      var arg = this.dataFor(e.currentTarget);

	      if (arg.column) {
	        this.trigger('click:header', e, arg);
	      }
	    },

	    tdClick: function tdClick(e) {
	      var arg = this.dataFor(e.currentTarget);

	      if (arg.column) {
	        this.trigger('click:cell', e, arg);
	      }
	    },

	    editableStringChange: function editableStringChange(e) {
	      var arg = this.dataFor(e.currentTarget);
	      var colEditableStr = this.grid.projection.get('column.editable.string');

	      if (arg.column) {
	        if (_.isObject(colEditableStr) && !_.isUndefined(colEditableStr[arg.property])) {
	          this.grid.projection.get('projection:column-editable-string').trigger('change:string', e, arg);
	        } else {
	          this.trigger('change:editable.string', e, arg);
	        }
	      }
	    },

	    dataFor: function dataFor(el) {
	      if (!$.contains(this.el, el)) {
	        return undefined;
	      }

	      var $el = $(el);
	      // TODO [akamel] can we use target instead?
	      var $tr = $el.closest('tr', this.el);
	      var $closestTD = $el.closest('td', this.el);
	      var $closestTH = $el.closest('th', this.el);
	      var $td = _.size($closestTD) ? $closestTD : $closestTH;
	      var virtualizer = this.getRenderer('virtualization');
	      var i = $tr.index();
	      var j = $td.index();
	      // TODO [akamel] 1- check if $td is th; 2- throw if el is neither th or td as it is assumed in this function
	      var isHeader = $td.closest('thead', this.el).length;
	      var ret = { header: isHeader };

	      // we are not in header
	      if (isHeader) {
	        if (i === 0) {
	          ret.property = this.data.select[j];
	        } else if (i === 1) {
	          ret.property = this.data.subSelect[j];
	        } else {
	          ret.property = this.data.selectExpand[j];
	        }
	      } else {
	        i += virtualizer ? virtualizer.first : 0;
	        ret.model = this.data.value[i];
	        if (this.data.selectExpand) {
	          ret.property = this.data.selectExpand[j];
	        } else {
	          ret.property = this.data.select[j];
	        }
	      }

	      ret.column = this.data.columns[ret.property];
	      if (ret.property === this.grid.projection.get('column.checked')) {
	        // TODO [akamel] this shouldn't be here
	        var checkbox = $el.find('.column-selection');
	        if (checkbox.length) {
	          ret.checked = checkbox[0].checked;
	        }
	      }
	      ret.grid = this.grid;

	      return ret;
	    },

	    // TODO [akamel] [perf] 8.5%
	    toHTML: function toHTML(value) {
	      var data = _.defaults({
	        value: value.rows,
	        isSticky: value.isSticky
	      }, this.data);

	      _.each(data.columns, function (col) {
	        if (_.isObject(col.$metadata)) {
	          if (_.has(col.$metadata['attr.head'], 'class') && _.isArray(col.$metadata['attr.head'].class)) {
	            col.$metadata['attr.head'].class = col.$metadata['attr.head'].class.join(' ');
	          }

	          if (_.has(col.$metadata['attr.body'], 'class') && _.isArray(col.$metadata['attr.body'].class)) {
	            col.$metadata['attr.body'].class = col.$metadata['attr.body'].class.join(' ');
	          }

	          // TODO [akamel] merge attr that are on $metadata['attr']
	        }
	      });

	      return this.options.template(data);
	    },

	    update: function update(model) {
	      _.each(this.renderers, function (renderer) {
	        renderer.update && renderer.update();
	      });

	      var value = model.get('value');
	      var columns = model.get('columns');
	      var columnsDelta = {};
	      var colOptions = this.options.columns || {};
	      var orderby = {};

	      _.each(this.grid.projection.get('orderby'), function (element, index) {
	        var key = _.first(_.keys(element));
	        orderby[key] = {
	          dir: element[key],
	          index: index
	        };
	      });

	      _.each(columns, function (col, property) {
	        // TODO [akamel] consider filtering which props to copy/override
	        var delta = {};
	        var colOption = colOptions[property];
	        var orderName = property;

	        if (colOption && _.isString(colOption.sortable)) {
	          orderName = colOption.sortable;
	        } else if (col && _.isString(col.sortable)) {
	          orderName = col.sortable;
	        }

	        if (orderby[orderName]) {
	          delta.$orderby = orderby[orderName];
	        }

	        columnsDelta[property] = _.defaults(delta, colOption, col);
	      });

	      if (_.has(this.options.$metadata, 'class') && _.isArray(this.options.$metadata.class)) {
	        this.options.$metadata.class = this.options.$metadata.class.join(' ');
	      }

	      var delta = {
	        'value': value,
	        'columns': columnsDelta,
	        'columns.lookup': _.indexBy(columns, function (col) {
	          return col.property;
	        }),
	        '$metadata': this.options.$metadata,
	        'hideHeaders': this.options.hideHeaders
	      };

	      this.data = _.defaults(delta, model.toJSON());

	      this.draw({ canSkipDraw: false });
	    },

	    scheduleDraw: function scheduleDraw() {
	      if (!this.scheduledDraw) {
	        this.scheduledDraw = true;

	        window.requestAnimationFrame(function () {
	          this.scheduledDraw = false;
	          this.draw();
	        }.bind(this));
	      }
	    },

	    drawable: function drawable() {
	      return this.data;
	    },

	    getRenderer: function getRenderer(name) {
	      return _.find(this.renderers, function (r) {
	        return r.name === name;
	      });
	    },

	    draw: function draw(options) {
	      if (!this.drawable()) {
	        return;
	      }

	      this.trigger('render:beginning');

	      var renderers = this.renderers;
	      var i = 0;

	      var middleware = function middleware(data, cb) {
	        var r = renderers[i++];
	        if (r) {
	          var clone = _.defaults({}, data, { css: {} });
	          delete clone.canSkipDraw;

	          r.draw(clone, _.once(function (err, res) {
	            res.canSkipDraw = data.canSkipDraw === true && res.canSkipDraw === true;
	            if (err) {
	              cb(err);
	            } else {
	              middleware(res || clone, cb);
	            }
	          }));
	        } else {
	          cb(undefined, data);
	        }
	      };

	      var canSkipDraw = _.has(options, 'canSkipDraw') ? options.canSkipDraw : true;

	      // this is _not_ and _cannot_ be async
	      middleware({ rows: this.data.value, canSkipDraw: canSkipDraw }, function (err, res) {
	        res.css && this.$el.css(res.css);

	        if (err) {
	          throw err;
	        }

	        this.removeSubviews();

	        if (res.canSkipDraw !== true) {
	          this.el.innerHTML = this.toHTML(res);
	        }

	        _.each(this.data.columns, function (column) {
	          if (column.config) {
	            if (_.isFunction(column.config.View)) {
	              this.$('td.col-' + column.config.name).each(function (index, el) {
	                var cellView = new column.config.View({ model: this.dataFor(el).model });
	                this.$(el).html(cellView.render().el);
	                this.subviews.push(cellView);
	              }.bind(this));
	            }
	            if (_.isFunction(column.config.HeaderView)) {
	              this.$('th.col-' + column.config.name).each(function (index, el) {
	                var headerView = new column.config.HeaderView();
	                this.$(el).html(headerView.render().el);
	                this.subviews.push(headerView);
	              }.bind(this));
	            }
	          }
	        }, this);
	      }.bind(this));

	      this.trigger('render:finished');
	    },

	    render: function render() {
	      this.grid.on('change:data', this.update);

	      // this.grid.projection.data.on('change', this.update);
	    },

	    rerender: function rerender() {
	      this.scheduleDraw();
	    }
	  });

	  View.partial = function (options) {
	    return View.extend({ options: options });
	  };

	  return View;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_7__;

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_8__;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(10);

	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	;var locals_for_with = (locals || {});(function ($metadata, columns, hideHeaders, isApplyGroup, isSticky, subSelect, undefined, value) {
	jade_mixins["columnHeader"] = jade_interp = function(column, isSubHeader){
	var block = (this && this.block), attributes = (this && this.attributes) || {};
	if ( column.headerBuilder)
	{
	buf.push(null == (jade_interp = column.headerBuilder(column, isSubHeader)) ? "" : jade_interp);
	}
	else
	{
	if ( column.$orderby)
	{
	if ( column.$orderby.dir > 0)
	{
	buf.push("<span class=\"grid-asc\"></span>");
	}
	else
	{
	buf.push("<span class=\"grid-des\"></span>");
	}
	}
	if ( (column && column.$html))
	{
	buf.push(null == (jade_interp = column.$html) ? "" : jade_interp);
	}
	else
	{
	if ( isSubHeader && column.config.subColTitle)
	{
	buf.push(jade.escape(null == (jade_interp = column.config.subColTitle) ? "" : jade_interp));
	}
	else
	{
	buf.push(jade.escape(null == (jade_interp = (typeof column.$text != 'undefined')? column.$text : (column.property || column)) ? "" : jade_interp));
	}
	}
	}
	};
	jade_mixins["th"] = jade_interp = function(column, hasGroup, isSubColumn){
	var block = (this && this.block), attributes = (this && this.attributes) || {};
	var attr = (column.$metadata || {})['attr.head'] || {}
	var colName = column.config && column.config.name || '';
	var cls = [];
	if ( (colName))
	{
	cls.push('col-' + colName);
	}
	if ( column.sortable)
	{
	cls.push('sortable');
	}
	if ( column.$orderby)
	{
	cls.push('orderby');
	}
	cls = cls.join(' ');
	if ( isSubColumn )
	{
	var colspan = 1, rowspan = 1;
	buf.push("<th" + (jade.attrs(jade.merge([{"colspan": jade.escape(colspan),"rowspan": jade.escape(rowspan),"class": (jade_interp = [true], jade.joinClasses([cls].map(jade.joinClasses).map(function (cls, i) {   return jade_interp[i] ? jade.escape(cls) : cls })))},attributes,attr]), true)) + ">");
	jade_mixins["columnHeader"](column, true);
	buf.push("</th>");
	}
	else if ( hasGroup && column.groupExpansion)
	{
	var colspan = column.group.length, rowspan = 1;
	buf.push("<th" + (jade.attrs(jade.merge([{"colspan": jade.escape(colspan),"rowspan": jade.escape(rowspan),"class": (jade_interp = [true], jade.joinClasses([cls].map(jade.joinClasses).map(function (cls, i) {   return jade_interp[i] ? jade.escape(cls) : cls })))},attributes,attr]), true)) + "><span class=\"pop-collapse glyphicon glyphicon-minus\"></span><div>");
	jade_mixins["columnHeader"](column);
	buf.push("</div></th>");
	}
	else if ( hasGroup && column.group)
	{
	var colspan = 1, rowspan = 2;
	buf.push("<th" + (jade.attrs(jade.merge([{"colspan": jade.escape(colspan),"rowspan": jade.escape(rowspan),"class": (jade_interp = [true], jade.joinClasses([cls].map(jade.joinClasses).map(function (cls, i) {   return jade_interp[i] ? jade.escape(cls) : cls })))},attributes,attr]), true)) + "><span class=\"pop-expand glyphicon glyphicon-plus\"></span><div>");
	jade_mixins["columnHeader"](column);
	buf.push("</div></th>");
	}
	else
	{
	var colspan = 1, rowspan = 2;
	buf.push("<th" + (jade.attrs(jade.merge([{"colspan": jade.escape(colspan),"rowspan": jade.escape(rowspan),"class": (jade_interp = [true], jade.joinClasses([cls].map(jade.joinClasses).map(function (cls, i) {   return jade_interp[i] ? jade.escape(cls) : cls })))},attributes,attr]), true)) + ">");
	jade_mixins["columnHeader"](column);
	buf.push("</th>");
	}
	};
	jade_mixins["td"] = jade_interp = function(row, column){
	var block = (this && this.block), attributes = (this && this.attributes) || {};
	var attr = (column.$metadata || {})['attr.body'] || {}
	var colName = column.config && column.config.name || '';
	var cls = colName ? 'col-' + colName : '';
	buf.push("<td" + (jade.attrs(jade.merge([{"class": (jade_interp = [true], jade.joinClasses([cls].map(jade.joinClasses).map(function (cls, i) {   return jade_interp[i] ? jade.escape(cls) : cls })))},attributes,attr]), true)) + ">");
	var res = row[column.property]
	if ( (res && res.$html))
	{
	buf.push(null == (jade_interp = res.$html) ? "" : jade_interp);
	}
	else
	{
	buf.push(jade.escape(null == (jade_interp = res) ? "" : jade_interp));
	}
	buf.push("</td>");
	};
	jade_mixins["thead"] = jade_interp = function(isApplyGroup, subSelect, locals, columns){
	var block = (this && this.block), attributes = (this && this.attributes) || {};
	buf.push("<thead>");
	if ( isApplyGroup && subSelect.length === 0)
	{
	buf.push("<tr class=\"table__row--header\">");
	// iterate locals['select'] || []
	;(function(){
	  var $$obj = locals['select'] || [];
	  if ('number' == typeof $$obj.length) {

	    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
	      var columnName = $$obj[$index];

	jade_mixins["th"](columns[columnName], true);
	    }

	  } else {
	    var $$l = 0;
	    for (var $index in $$obj) {
	      $$l++;      var columnName = $$obj[$index];

	jade_mixins["th"](columns[columnName], true);
	    }

	  }
	}).call(this);

	buf.push("</tr>");
	}
	else if ( isApplyGroup)
	{
	buf.push("<tr class=\"table__row--header\">");
	// iterate locals['select'] || []
	;(function(){
	  var $$obj = locals['select'] || [];
	  if ('number' == typeof $$obj.length) {

	    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
	      var columnName = $$obj[$index];

	jade_mixins["th"](columns[columnName], true);
	    }

	  } else {
	    var $$l = 0;
	    for (var $index in $$obj) {
	      $$l++;      var columnName = $$obj[$index];

	jade_mixins["th"](columns[columnName], true);
	    }

	  }
	}).call(this);

	buf.push("</tr><tr class=\"table__row--header table__row--sub-header\">");
	// iterate locals['subSelect']
	;(function(){
	  var $$obj = locals['subSelect'];
	  if ('number' == typeof $$obj.length) {

	    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
	      var columnName = $$obj[$index];

	jade_mixins["th"](columns[columnName], true, true);
	    }

	  } else {
	    var $$l = 0;
	    for (var $index in $$obj) {
	      $$l++;      var columnName = $$obj[$index];

	jade_mixins["th"](columns[columnName], true, true);
	    }

	  }
	}).call(this);

	buf.push("</tr>");
	}
	else
	{
	buf.push("<tr class=\"table__row--header\">");
	// iterate locals['select'] || []
	;(function(){
	  var $$obj = locals['select'] || [];
	  if ('number' == typeof $$obj.length) {

	    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
	      var columnName = $$obj[$index];

	jade_mixins["th"](columns[columnName]);
	    }

	  } else {
	    var $$l = 0;
	    for (var $index in $$obj) {
	      $$l++;      var columnName = $$obj[$index];

	jade_mixins["th"](columns[columnName]);
	    }

	  }
	}).call(this);

	buf.push("</tr>");
	}
	buf.push("</thead>");
	};
	if ( isSticky)
	{
	buf.push("<table" + (jade.attrs(jade.merge([{"class": "table table-hover grid grid-sticky-header"},$metadata || {}]), true)) + ">");
	jade_mixins["thead"](isApplyGroup, subSelect, locals, columns);
	buf.push("</table><div class=\"sticky-header-filler\"></div>");
	}
	buf.push("<table" + (jade.attrs(jade.merge([{"role": "grid","class": "table table-hover grid grid-content"},$metadata || {}]), true)) + ">");
	if ( !hideHeaders && !isSticky)
	{
	jade_mixins["thead"](isApplyGroup, subSelect, locals, columns);
	}
	buf.push("<tbody>");
	// iterate value
	;(function(){
	  var $$obj = value;
	  if ('number' == typeof $$obj.length) {

	    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
	      var row = $$obj[i];

	var attr = (row.$metadata || {}).attr || {}
	buf.push("<tr" + (jade.attrs(jade.merge([{"class": "table__row--body"},attr]), true)) + ">");
	// iterate locals['selectExpand'] || locals.select
	;(function(){
	  var $$obj = locals['selectExpand'] || locals.select;
	  if ('number' == typeof $$obj.length) {

	    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
	      var columnName = $$obj[$index];

	jade_mixins["td"](row, columns[columnName]);
	    }

	  } else {
	    var $$l = 0;
	    for (var $index in $$obj) {
	      $$l++;      var columnName = $$obj[$index];

	jade_mixins["td"](row, columns[columnName]);
	    }

	  }
	}).call(this);

	buf.push("</tr>");
	    }

	  } else {
	    var $$l = 0;
	    for (var i in $$obj) {
	      $$l++;      var row = $$obj[i];

	var attr = (row.$metadata || {}).attr || {}
	buf.push("<tr" + (jade.attrs(jade.merge([{"class": "table__row--body"},attr]), true)) + ">");
	// iterate locals['selectExpand'] || locals.select
	;(function(){
	  var $$obj = locals['selectExpand'] || locals.select;
	  if ('number' == typeof $$obj.length) {

	    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
	      var columnName = $$obj[$index];

	jade_mixins["td"](row, columns[columnName]);
	    }

	  } else {
	    var $$l = 0;
	    for (var $index in $$obj) {
	      $$l++;      var columnName = $$obj[$index];

	jade_mixins["td"](row, columns[columnName]);
	    }

	  }
	}).call(this);

	buf.push("</tr>");
	    }

	  }
	}).call(this);

	buf.push("</tbody></table>");}.call(this,"$metadata" in locals_for_with?locals_for_with.$metadata:typeof $metadata!=="undefined"?$metadata:undefined,"columns" in locals_for_with?locals_for_with.columns:typeof columns!=="undefined"?columns:undefined,"hideHeaders" in locals_for_with?locals_for_with.hideHeaders:typeof hideHeaders!=="undefined"?hideHeaders:undefined,"isApplyGroup" in locals_for_with?locals_for_with.isApplyGroup:typeof isApplyGroup!=="undefined"?isApplyGroup:undefined,"isSticky" in locals_for_with?locals_for_with.isSticky:typeof isSticky!=="undefined"?isSticky:undefined,"subSelect" in locals_for_with?locals_for_with.subSelect:typeof subSelect!=="undefined"?subSelect:undefined,"undefined" in locals_for_with?locals_for_with.undefined: false?undefined:undefined,"value" in locals_for_with?locals_for_with.value:typeof value!=="undefined"?value:undefined));;return buf.join("");
	}

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	/**
	 * Merge two attribute objects giving precedence
	 * to values in object `b`. Classes are special-cased
	 * allowing for arrays and merging/joining appropriately
	 * resulting in a string.
	 *
	 * @param {Object} a
	 * @param {Object} b
	 * @return {Object} a
	 * @api private
	 */

	exports.merge = function merge(a, b) {
	  if (arguments.length === 1) {
	    var attrs = a[0];
	    for (var i = 1; i < a.length; i++) {
	      attrs = merge(attrs, a[i]);
	    }
	    return attrs;
	  }
	  var ac = a['class'];
	  var bc = b['class'];

	  if (ac || bc) {
	    ac = ac || [];
	    bc = bc || [];
	    if (!Array.isArray(ac)) ac = [ac];
	    if (!Array.isArray(bc)) bc = [bc];
	    a['class'] = ac.concat(bc).filter(nulls);
	  }

	  for (var key in b) {
	    if (key != 'class') {
	      a[key] = b[key];
	    }
	  }

	  return a;
	};

	/**
	 * Filter null `val`s.
	 *
	 * @param {*} val
	 * @return {Boolean}
	 * @api private
	 */

	function nulls(val) {
	  return val != null && val !== '';
	}

	/**
	 * join array as classes.
	 *
	 * @param {*} val
	 * @return {String}
	 */
	exports.joinClasses = joinClasses;
	function joinClasses(val) {
	  return (Array.isArray(val) ? val.map(joinClasses) :
	    (val && typeof val === 'object') ? Object.keys(val).filter(function (key) { return val[key]; }) :
	    [val]).filter(nulls).join(' ');
	}

	/**
	 * Render the given classes.
	 *
	 * @param {Array} classes
	 * @param {Array.<Boolean>} escaped
	 * @return {String}
	 */
	exports.cls = function cls(classes, escaped) {
	  var buf = [];
	  for (var i = 0; i < classes.length; i++) {
	    if (escaped && escaped[i]) {
	      buf.push(exports.escape(joinClasses([classes[i]])));
	    } else {
	      buf.push(joinClasses(classes[i]));
	    }
	  }
	  var text = joinClasses(buf);
	  if (text.length) {
	    return ' class="' + text + '"';
	  } else {
	    return '';
	  }
	};


	exports.style = function (val) {
	  if (val && typeof val === 'object') {
	    return Object.keys(val).map(function (style) {
	      return style + ':' + val[style];
	    }).join(';');
	  } else {
	    return val;
	  }
	};
	/**
	 * Render the given attribute.
	 *
	 * @param {String} key
	 * @param {String} val
	 * @param {Boolean} escaped
	 * @param {Boolean} terse
	 * @return {String}
	 */
	exports.attr = function attr(key, val, escaped, terse) {
	  if (key === 'style') {
	    val = exports.style(val);
	  }
	  if ('boolean' == typeof val || null == val) {
	    if (val) {
	      return ' ' + (terse ? key : key + '="' + key + '"');
	    } else {
	      return '';
	    }
	  } else if (0 == key.indexOf('data') && 'string' != typeof val) {
	    if (JSON.stringify(val).indexOf('&') !== -1) {
	      console.warn('Since Jade 2.0.0, ampersands (`&`) in data attributes ' +
	                   'will be escaped to `&amp;`');
	    };
	    if (val && typeof val.toISOString === 'function') {
	      console.warn('Jade will eliminate the double quotes around dates in ' +
	                   'ISO form after 2.0.0');
	    }
	    return ' ' + key + "='" + JSON.stringify(val).replace(/'/g, '&apos;') + "'";
	  } else if (escaped) {
	    if (val && typeof val.toISOString === 'function') {
	      console.warn('Jade will stringify dates in ISO form after 2.0.0');
	    }
	    return ' ' + key + '="' + exports.escape(val) + '"';
	  } else {
	    if (val && typeof val.toISOString === 'function') {
	      console.warn('Jade will stringify dates in ISO form after 2.0.0');
	    }
	    return ' ' + key + '="' + val + '"';
	  }
	};

	/**
	 * Render the given attributes object.
	 *
	 * @param {Object} obj
	 * @param {Object} escaped
	 * @return {String}
	 */
	exports.attrs = function attrs(obj, terse){
	  var buf = [];

	  var keys = Object.keys(obj);

	  if (keys.length) {
	    for (var i = 0; i < keys.length; ++i) {
	      var key = keys[i]
	        , val = obj[key];

	      if ('class' == key) {
	        if (val = joinClasses(val)) {
	          buf.push(' ' + key + '="' + val + '"');
	        }
	      } else {
	        buf.push(exports.attr(key, val, false, terse));
	      }
	    }
	  }

	  return buf.join('');
	};

	/**
	 * Escape the given string of `html`.
	 *
	 * @param {String} html
	 * @return {String}
	 * @api private
	 */

	var jade_encode_html_rules = {
	  '&': '&amp;',
	  '<': '&lt;',
	  '>': '&gt;',
	  '"': '&quot;'
	};
	var jade_match_html = /[&<>"]/g;

	function jade_encode_char(c) {
	  return jade_encode_html_rules[c] || c;
	}

	exports.escape = jade_escape;
	function jade_escape(html){
	  var result = String(html).replace(jade_match_html, jade_encode_char);
	  if (result === '' + html) return html;
	  else return result;
	};

	/**
	 * Re-throw the given `err` in context to the
	 * the jade in `filename` at the given `lineno`.
	 *
	 * @param {Error} err
	 * @param {String} filename
	 * @param {String} lineno
	 * @api private
	 */

	exports.rethrow = function rethrow(err, filename, lineno, str){
	  if (!(err instanceof Error)) throw err;
	  if ((typeof window != 'undefined' || !filename) && !str) {
	    err.message += ' on line ' + lineno;
	    throw err;
	  }
	  try {
	    str = str || __webpack_require__(11).readFileSync(filename, 'utf8')
	  } catch (ex) {
	    rethrow(err, null, lineno)
	  }
	  var context = 3
	    , lines = str.split('\n')
	    , start = Math.max(lineno - context, 0)
	    , end = Math.min(lines.length, lineno + context);

	  // Error context
	  var context = lines.slice(start, end).map(function(line, i){
	    var curr = i + start + 1;
	    return (curr == lineno ? '  > ' : '    ')
	      + curr
	      + '| '
	      + line;
	  }).join('\n');

	  // Alter exception message
	  err.path = filename;
	  err.message = (filename || 'Jade') + ':' + lineno
	    + '\n' + context + '\n\n' + err.message;
	  throw err;
	};

	exports.DebugItem = function DebugItem(lineno, filename) {
	  this.lineno = lineno;
	  this.filename = filename;
	}


/***/ }),
/* 11 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _fixedHeader = __webpack_require__(13);

	var _fixedHeader2 = _interopRequireDefault(_fixedHeader);

	var _virtualization = __webpack_require__(16);

	var _virtualization2 = _interopRequireDefault(_virtualization);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = {
	  FixedHeader: _fixedHeader2.default,
	  Virtualization: _virtualization2.default
	};

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _jquery = __webpack_require__(7);

	var _jquery2 = _interopRequireDefault(_jquery);

	var _underscore = __webpack_require__(3);

	var _underscore2 = _interopRequireDefault(_underscore);

	var _measure = __webpack_require__(14);

	var _measure2 = _interopRequireDefault(_measure);

	var _px = __webpack_require__(15);

	var _px2 = _interopRequireDefault(_px);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var FixedHeaderRenderer = function () {
	  function FixedHeaderRenderer() {
	    var _this = this;

	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	    _classCallCheck(this, FixedHeaderRenderer);

	    this.name = 'fixed-header';
	    this.state = 'normal';

	    this.options = options;
	    this.layout = this.options.layout;
	    this.columnWidth = null;
	    this.windowWidth = (0, _jquery2.default)(window).width();

	    this.onViewPortChange = function () {
	      if (_underscore2.default.isFunction(_this.freezeColumnWidth)) {
	        _this.freezeColumnWidth();
	      }
	    };

	    this.layout.on('change:viewport', this.onViewPortChange);
	  }

	  _createClass(FixedHeaderRenderer, [{
	    key: 'draw',
	    value: function draw(data, cb) {
	      var _this2 = this;

	      data.vpMeasures = _measure2.default.viewport.call(this.layout);

	      var $el = this.layout.$el;
	      var offset = _underscore2.default.result(this.layout, 'top', 0);
	      var isSticky = data.vpMeasures.viewportTop + offset > data.vpMeasures.boundsTop;
	      var newState = isSticky ? 'sticky' : 'normal';

	      data.canSkipDraw = newState === this.state;
	      data.isSticky = isSticky;

	      cb(undefined, data);

	      $el.find('table.grid').css({ tableLayout: 'fixed' });

	      if (isSticky) {
	        var $tableStickyHeader = $el.find('table.grid-sticky-header');
	        var $tableContent = $el.find('table.grid-content');
	        var $thLastRow = $tableStickyHeader.find('thead > tr:last-child').children();
	        var $tdFirstRow = $tableContent.find('tbody > tr:first-child').children();

	        if (this.state === 'normal') {
	          var $stickyHeaderFiller = $el.find('.sticky-header-filler');
	          $stickyHeaderFiller.css({
	            height: $tableStickyHeader.outerHeight()
	          });
	        }

	        var setColumnWidth = function setColumnWidth(tableWidth, columnWidth) {
	          _underscore2.default.each([$thLastRow, $tdFirstRow], function ($elems) {
	            return _underscore2.default.each($elems, function (el, index) {
	              (0, _jquery2.default)(el).css({
	                width: _underscore2.default.result(columnWidth, index, '')
	              });
	            });
	          });

	          $el.find('table.grid').css({
	            width: tableWidth
	          });
	        };

	        var unfreezeColumnWidth = function unfreezeColumnWidth() {
	          setColumnWidth('', null);
	        };

	        var freezeColumnWidth = this.freezeColumnWidth = function () {
	          if (!_this2.columnWidth || Math.abs((0, _jquery2.default)(window).width() - _this2.windowWidth) >= 1) {
	            unfreezeColumnWidth();
	            _this2.windowWidth = (0, _jquery2.default)(window).width();
	            _this2.tableWidth = $tableContent.outerWidth();
	            _this2.columnWidth = _underscore2.default.map($tdFirstRow, function (td) {
	              return (0, _jquery2.default)(td).outerWidth();
	            });
	          }

	          setColumnWidth(_this2.tableWidth, _this2.columnWidth);
	        };

	        freezeColumnWidth();
	        $tableStickyHeader.css({
	          top: offset,
	          left: $tableContent.offset().left - window.scrollX,
	          position: 'fixed'
	        });
	      } else {
	        this.freezeColumnWidth = null;
	      }

	      if (this.state !== newState) {
	        this.layout.grid.trigger('change:header-state', newState);
	        this.state = newState;
	      }
	    }
	  }, {
	    key: 'remove',
	    value: function remove() {}
	  }], [{
	    key: 'partial',
	    value: function partial(options) {
	      return function (o) {
	        return new Renderer(_underscore2.default.defaults({}, o, options));
	      };
	    }
	  }]);

	  return FixedHeaderRenderer;
	}();

	exports.default = FixedHeaderRenderer;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(7), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, _) {
	    function viewport(el, container) {
	        var $el = el ? $(el) : this.$el;

	        container = container || this.container;
	        var $viewport = container.$el;

	        var viewportTop = $viewport.scrollTop();
	        var viewportBottom = viewportTop + $viewport.height();
	        var viewportLeft = $viewport.scrollLeft();

	        var boundsTop = container.offset($el).top;
	        var boundsBottom = boundsTop + $el.innerHeight();
	        // var boundsLeft = $el.offset().left;

	        var visibleTop = Math.max(boundsTop, viewportTop);
	        var visibleBottom = Math.min(boundsBottom, viewportBottom);
	        // var visibleLeft = Math.max(boundsLeft, viewportLeft);

	        return {
	            boundsTop: boundsTop,
	            viewportTop: viewportTop,
	            top: visibleTop - boundsTop,
	            bottom: visibleBottom - boundsTop,
	            offsetLeft: viewportLeft
	        };
	    }

	    function dimensions(el) {
	        var $el = el ? $(el) : this.$el;

	        // calculate heights
	        // a. header
	        var ret = {
	            rows: [],
	            thead: $el.find('thead > tr').outerHeight()
	        };

	        // b. keep row info
	        $el.find('tbody').children('tr').each(function () {
	            ret.rows.push($(this).outerHeight());
	        });

	        // c. update average row height
	        var avg = _.reduce(ret.rows, function (memo, num) {
	            return memo + num;
	        }, 0) / (ret.rows.length === 0 ? 1 : ret.rows.length);

	        ret.avgRowHeight = avg;
	        ret.estimateHeight = _.size(this.data.value) * avg + ret.thead;

	        return ret;
	    }

	    function sample() {
	        // a. render test pass
	        var $tmpEl = $('<div style="visibility:hidden" />');
	        var sample = _.first(this.data.value, 20);

	        this.$el.append($tmpEl);

	        $tmpEl[0].innerHTML = this.toHTML({ rows: sample });

	        // b. take measures
	        var ret = dimensions.call(this, $tmpEl);

	        // c. clean-up
	        $tmpEl.remove();

	        return ret;
	    }

	    return {
	        viewport: viewport,
	        dimensions: dimensions,
	        sample: sample
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	// todo [akamel] move to /component
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_) {
	  function parse(a) {
	    return abs(parseFloat(a));
	  }

	  function abs(a) {
	    return _.isFinite(a) ? a : 0;
	  }

	  function pixelify(a) {
	    return abs(a) + 'px';
	  }

	  return {
	    parse: parse,
	    pixelify: pixelify
	  };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	// TODO [akamel] [bug] with large data set, jitters when scrolling to bottom

	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(7), __webpack_require__(3), __webpack_require__(14), __webpack_require__(15)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, _, measure, px) {
	  function rowHeight(row) {
	    return _.isNumber(row.__height) ? row.__height : this.__measures.avgRowHeight;
	  }

	  function estimateHeight(first, last) {
	    var rows = this.layout.data.value;

	    var ret = 0;
	    for (var i = first; i <= last; i++) {
	      ret += rowHeight.call(this, rows[i]);
	    }

	    return ret;
	  }

	  function rowAtOffset(offset) {
	    var rem = offset;

	    if (rem <= 0) {
	      return 0;
	    }

	    var ret = -1;
	    var count = _.size(this.layout.data.value);

	    while (rem > 0 && ret < count - 1) {
	      ret++;
	      rem -= rowHeight.call(this, ret);
	    }

	    return ret < count ? ret : -1;
	  }

	  function Renderer(options) {
	    this.options = options || {};

	    this.name = 'virtualization';
	    this.layout = this.options.layout;
	  }

	  Renderer.prototype.draw = function (data, cb) {
	    // a. define data set
	    var value = this.layout.data.value;
	    var count = _.size(value);
	    var first = 0;
	    var last = count - 1;

	    // b. render test pass / take initial measures
	    if (!this.__measures) {
	      var smpl = measure.sample.call(this.layout);
	      this.__measures = _.pick(smpl, 'avgRowHeight', 'estimateHeight', 'thead');

	      // b.1 set height based on measures estimate
	      this.layout.$el.css({
	        'padding-top': px.pixelify(this.__measures.estimateHeight)
	      });
	    }

	    // c. find visible viewport
	    data.vpMeasures = data.vpMeasures || measure.viewport.call(this.layout);

	    // d. find rendable rows
	    first = rowAtOffset.call(this, data.vpMeasures.top - this.__measures.thead);
	    last = rowAtOffset.call(this, data.vpMeasures.bottom - this.__measures.thead);

	    // d.1 add a few rows before and after our calculations to account for measurment estimation err
	    var errMarginRowCount = 5;

	    first -= errMarginRowCount;
	    last += errMarginRowCount;

	    first = Math.max(0, first);
	    last = Math.min(last < 0 ? count - 1 : last, count - 1);

	    var pTop = estimateHeight.call(this, 0, first - 1);
	    var pBottom = estimateHeight.call(this, last + 1, count - 1);

	    data.rows = value.slice(first, last + 1);

	    _.extend(data.css, {
	      'padding-top': px.pixelify(pTop + px.parse(data.css['padding-top'])),
	      'padding-bottom': px.pixelify(pBottom + px.parse(data.css['padding-bottom']))
	    });

	    if (this.first === first && this.last === last) {
	      data.canSkipDraw = true;
	    }

	    // e. yield to render
	    cb(undefined, data);

	    // f. take new measures and update avg row height
	    // todo [akamel] [perf] 7.5%
	    var tblMeasure = measure.dimensions.call(this.layout);
	    _.each(tblMeasure.rows, function (height, i) {
	      value[i + first].__height = height;
	    });

	    var heights = _.chain(value).map(function (row) {
	      return row.__height;
	    }).compact().value();

	    if (_.size(heights)) {
	      this.__measures.avgRowHeight = _.reduce(heights, function (memo, num) {
	        return memo + num;
	      }, 0) / _.size(heights);
	    }

	    this.first = first;
	    this.last = last;
	  };

	  Renderer.prototype.update = function () {
	    delete this.__measures;
	  };

	  Renderer.prototype.remove = _.noop;

	  Renderer.partial = function (options) {
	    return function (o) {
	      return new Renderer(_.defaults({}, o, options));
	    };
	  };

	  return Renderer;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _underscore = __webpack_require__(3);

	var _underscore2 = _interopRequireDefault(_underscore);

	var _backbone = __webpack_require__(8);

	var _backbone2 = _interopRequireDefault(_backbone);

	var _index = __webpack_require__(18);

	var _index2 = _interopRequireDefault(_index);

	var _utility = __webpack_require__(56);

	var _index3 = __webpack_require__(32);

	var _index4 = _interopRequireDefault(_index3);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var projectionConfigs = {
	  A11y: function A11y(config) {
	    var accConfig = {};

	    // temp config to fix a11y bug of latency projection grid, should not to reuse it.
	    if (_underscore2.default.has(config.a11y, 'selection') && _underscore2.default.has(config.a11y.selection, 'selectAllLabel')) {
	      accConfig['a11y.selection.selectAllLabel'] = config.a11y.selection.selectAllLabel;
	    }

	    return accConfig;
	  },
	  AggregateRow: function AggregateRow(config) {
	    var configAgg = {};

	    if (_underscore2.default.has(config.aggregate, 'top')) {
	      configAgg['aggregate.top'] = config.aggregate.top;
	    }

	    if (_underscore2.default.has(config.aggregate, 'bottom')) {
	      configAgg['aggregate.bottom'] = config.aggregate.bottom;
	    }

	    return configAgg;
	  },
	  JSData: function JSData(config) {
	    return _underscore2.default.extend(_underscore2.default.pick(config.dataSource, ['skip', 'take', 'filter', 'orderby', 'select']), {
	      'jsdata.entity': config.dataSource.resource,
	      'jsdata.query': config.dataSource.query,
	      'jsdata.options': config.dataSource.options
	    });
	  },
	  Map: function Map(config) {
	    var properties = _underscore2.default.reduce(config.columns, function (memo, _ref) {
	      var name = _ref.name,
	          value = _ref.value,
	          field = _ref.field;

	      memo[name] = value || function (item) {
	        return _underscore2.default.reduce((field || name).split('/'), function (memo, prop) {
	          return _underscore2.default.result(memo, prop);
	        }, item);
	      };
	      return memo;
	    }, {});

	    return {
	      map: function map(item) {
	        return _underscore2.default.reduce(config.columns, function (memo, _ref2) {
	          var name = _ref2.name;

	          memo[name] = properties[name](item);
	          return memo;
	        }, {});
	      }
	    };
	  },
	  Columns: function Columns(config) {
	    var columns = _underscore2.default.reduce(config.columns, function (columns, column) {
	      var $metadata = {};

	      if (column.attributes) {
	        $metadata['attr.body'] = column.attributes;
	      }

	      if (column.headerAttributes) {
	        $metadata['attr.head'] = column.headerAttributes;
	      }

	      columns[column.name] = {
	        sortable: column.sortable,
	        $metadata: $metadata,
	        headerBuilder: column.headerBuilder,
	        config: column
	      };

	      return columns;
	    }, {});

	    if (config.selectable) {
	      columns.checkbox = {
	        config: { name: 'selection' }
	      };
	    }

	    if (_underscore2.default.has(config.columnShifter, 'totalColumns')) {
	      columns['column.skip.less'] = {
	        config: { name: 'skip-less' }
	      };
	      columns['column.skip.more'] = {
	        config: { name: 'skip-more' }
	      };
	    }

	    return { columns: columns };
	  },
	  ColumnI18n: function ColumnI18n(config) {
	    return _underscore2.default.reduce(config.columns, function (columnI18n, column) {
	      columnI18n['column.i18n'][column.name] = column.title || column.name;
	      columnI18n['subColumn.i18n'][column.name] = column.subColTitle;
	      return columnI18n;
	    }, { 'column.i18n': {}, 'subColumn.i18n': {} });
	  },
	  ColumnQueryable: function ColumnQueryable(config) {
	    var columnIn = _underscore2.default.chain(config.columns).reject(_underscore2.default.property('hidden')).map(_underscore2.default.property('name')).value();
	    var columnLock = _underscore2.default.chain(config.columns).filter(_underscore2.default.property('locked')).map(_underscore2.default.property('name')).value();
	    var colqConfig = {
	      'column.lock': columnLock,
	      'column.in': columnIn
	    };

	    if (config.selectable) {
	      columnIn.unshift('checkbox');
	      columnLock.unshift('checkbox');
	    }

	    if (_underscore2.default.has(config.columnShifter, 'totalColumns')) {
	      colqConfig['column.take'] = config.columnShifter.totalColumns;
	    }
	    return colqConfig;
	  },


	  // Todo[hezhan]: deprecated?
	  // ColumnGroup(config) {
	  //   return {
	  //     'column.group': config.columnGroup,
	  //   };
	  // },

	  ColumnShifter: function ColumnShifter() {},
	  ColumnTemplate: function ColumnTemplate(config) {
	    return {
	      'column.template': _underscore2.default.reduce(config.columns, function (columnTmpl, column) {
	        if (column.headerTemplate) {
	          columnTmpl[column.name] = column.headerTemplate;
	        }
	        return columnTmpl;
	      }, {})
	    };
	  },
	  ColumnHoverText: function ColumnHoverText() {},
	  Editable: function Editable(config) {
	    var editableOptions = {};

	    _underscore2.default.each(config.columns, function (column) {
	      if (column.editable) {
	        var options = editableOptions[column.name] = {
	          condition: function condition() {
	            return true;
	          },
	          editor: _index4.default
	        };

	        if (_underscore2.default.isFunction(column.editable)) {
	          options.condition = column.editable;
	        } else if (_underscore2.default.isObject(column.editable)) {
	          _underscore2.default.extend(options, column.editable);
	        }
	      }
	    });

	    var tooltipText = _underscore2.default.result(config.editable, 'tooltipText', 'Edit');
	    var iconClasses = _underscore2.default.result(config.editable, 'iconClasses', ['glyphicon', 'glyphicon-pencil']);

	    return {
	      'column.editable': editableOptions,
	      'editable.tooltip.text': tooltipText,
	      'editable.icon.class': iconClasses
	    };
	  },
	  MemoryQueryable: function MemoryQueryable(config) {
	    return {
	      'column.sortable': _underscore2.default.reduce(config.columns, function (columnSortable, column) {
	        if (column.sortable) {
	          columnSortable[column.name] = column.sortable;
	        }
	        return columnSortable;
	      }, {})
	    };
	  },
	  Odata: function Odata(config) {
	    return _underscore2.default.extend(_underscore2.default.pick(config.dataSource, ['url', 'skip', 'take', 'filter', 'orderby', 'select']));
	  },
	  PropertyTemplate: function PropertyTemplate(config) {
	    return {
	      'property.template': _underscore2.default.reduce(config.columns, function (propTmpl, column) {
	        if (column.template) {
	          propTmpl[column.name] = column.template;
	        }
	        return propTmpl;
	      }, {})
	    };
	  },
	  RowIndex: function RowIndex() {},
	  Row: function Row(config) {
	    return {
	      'row.classes': _underscore2.default.result(config.rows, 'classes')
	    };
	  },
	  RowCheckbox: function RowCheckbox(config) {
	    return {
	      'row.check.id': _underscore2.default.chain(config).result('dataSource').result('schema').result('key', 'rowIndex').value(),
	      'row.check.single': config.selectable === 'single',
	      'column.checked': 'checkbox',
	      'row.check.allow': function rowCheckAllow(model) {
	        var type = _underscore2.default.chain(model).result('$metadata').result('type').value();

	        return !_underscore2.default.contains(['segmentation', 'aggregate'], type);
	      }
	    };
	  },
	  Page: function Page(config) {
	    return {
	      'page.size': config.pageable.pageSize,
	      'page.number': 0
	    };
	  },
	  Sink: function Sink(config) {
	    var data = _underscore2.default.result(config.dataSource, 'data', []);

	    if (_underscore2.default.isArray(data)) {
	      return { seed: data };
	    } else if (data instanceof _backbone2.default.Collection) {
	      return { seed: data.toJSON() };
	    }
	  }
	};

	exports.default = function (definePlugin) {
	  return definePlugin('projection', ['config'], function (config) {
	    var projection = null;

	    function pipeProjection(name) {
	      var Projection = _index2.default[name];
	      var configProj = projectionConfigs[name](config);
	      var projectionDest = new Projection(configProj);

	      if (projection) {
	        projection = projection.pipe(projectionDest);
	      } else {
	        projection = projectionDest;
	      }
	    }

	    var dataSourceType = config.dataSource.type || 'memory';
	    if (dataSourceType === 'js-data') {
	      pipeProjection('JSData');
	    } else if (dataSourceType === 'memory') {
	      pipeProjection('Sink');
	      pipeProjection('MemoryQueryable');
	      if (config.dataSource.data instanceof _backbone2.default.Collection) {
	        var updating = false;
	        var scheduleUpdate = function scheduleUpdate() {
	          if (!updating) {
	            updating = true;
	            window.setTimeout(function () {
	              projection.set('seed', config.dataSource.data.toJSON());
	              updating = false;
	            }, 0);
	          }
	        };
	        config.dataSource.data.on('all', scheduleUpdate);
	      }
	    } else if (dataSourceType === 'odata') {
	      pipeProjection('Odata');
	    } else {
	      throw new Error('dataSource.type "' + config.dataSource.type + '" is not supported');
	    }

	    var dataSourceProjection = projection;

	    pipeProjection('A11y');
	    pipeProjection('Columns');
	    pipeProjection('Map');
	    if (config.aggregate) {
	      pipeProjection('AggregateRow');
	    }
	    pipeProjection('ColumnQueryable');
	    pipeProjection('ColumnI18n');
	    // Todo[hezhan]: deprecated?
	    // if (config.enablePoP) {
	    //   pipeProjection('ColumnGroup');
	    // }
	    if (_underscore2.default.has(config.columnShifter, 'totalColumns')) {
	      pipeProjection('ColumnShifter');
	    }
	    pipeProjection('ColumnTemplate');
	    pipeProjection('ColumnHoverText');
	    pipeProjection('PropertyTemplate');
	    if (config.selectable) {
	      pipeProjection('RowIndex');
	      pipeProjection('RowCheckbox');
	    }
	    if (config.rows || config.selectable) {
	      pipeProjection('Row');
	    }
	    if (_underscore2.default.has(config.pageable, 'pageSize')) {
	      pipeProjection('Page');
	    }
	    if (_underscore2.default.find(config.columns, _underscore2.default.property('editable'))) {
	      pipeProjection('Editable');
	    }

	    (0, _utility.delegateEvents)({
	      from: dataSourceProjection,
	      to: projection,
	      events: ['update:beginning', 'update:finished']
	    });

	    return projection;
	  });
	};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	module.exports = {
	  A11y: __webpack_require__(19),
	  AggregateRow: __webpack_require__(22),
	  Base: __webpack_require__(20),
	  ColumnI18n: __webpack_require__(23),
	  ColumnQueryable: __webpack_require__(25),
	  ColumnShifter: __webpack_require__(26),
	  ColumnTemplate: __webpack_require__(27),
	  EditableString: __webpack_require__(28),
	  Editable: __webpack_require__(30),
	  JSData: __webpack_require__(39),
	  Map: __webpack_require__(40),
	  MemoryQueryable: __webpack_require__(41),
	  Memory: __webpack_require__(42),
	  Mock: __webpack_require__(43),
	  Odata: __webpack_require__(44),
	  Page: __webpack_require__(45),
	  PropertyTemplate: __webpack_require__(46),
	  RowCheckbox: __webpack_require__(47),
	  Row: __webpack_require__(49),
	  RowTriStateCheckboxProjection: __webpack_require__(50),
	  RowIndex: __webpack_require__(52),
	  Sink: __webpack_require__(53),
	  // Todo[hezhan]: deprecated?
	  // ColumnGroup: require('./column-group'),
	  ColumnHoverText: __webpack_require__(54),
	  Columns: __webpack_require__(55).default
	};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(8), __webpack_require__(20)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, Backbone, BaseProjection /* , schemaProperties, Response */) {
	  var defaultselectAllLabel = 'Select All';
	  var Model = BaseProjection.extend({
	    defaults: {
	      'a11y.selection.selectAllLabel': 'Select All'
	    },
	    name: 'a11y',
	    update: function update(options) {
	      var selectAllLabel = this.get('a11y.selection.selectAllLabel');
	      if (Model.__super__.update.call(this, options)) {
	        this.patch({
	          'a11y.selection.uniqueId': _.uniqueId().concat('-'),
	          'a11y.selection.selectAllLabel': _.isString(selectAllLabel) ? selectAllLabel : defaultselectAllLabel
	        });
	      }
	    }
	  });
	  return Model;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(8), __webpack_require__(21)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, Backbone, Response) {
	  var Model = Backbone.Model.extend({
	    initialize: function initialize() {
	      _.bindAll(this, 'onSrcUpdate', 'beforeSet', 'afterSet', 'update');
	      this.data = new Response();
	      this.src = undefined;
	      this.on('change', function (model) {
	        // todo [akamel] the model here is the settings model
	        this.update({ model: model });
	      }.bind(this));
	    },

	    constructor: function constructor() {
	      // used to figure out which options to set localy and which ones to pass down the pipe
	      this.localKeys = _.keys(this.defaults);
	      // todo [akamel] this might prevent us from overriding initialize
	      Model.__super__.constructor.apply(this, arguments);
	    },

	    pipe: function pipe(to) {
	      if (to) {
	        to.setSrc(this);
	      }

	      return to;
	    },

	    setSrc: function setSrc(src) {
	      this.src = src;
	      if (this.src) {
	        this.src.data.off('change', this.onSrcUpdate);
	        this.src.off('all', this.bubble);
	      }

	      if (this.src) {
	        this.src.data.on('change', this.onSrcUpdate);
	        this.src.on('all', this.bubble);
	      }

	      this.update();
	    },

	    patch: function patch(delta) {
	      var src = this.src ? this.src.data.toJSON() : {};
	      delta = _.isObject(delta) ? delta : {};

	      if (delta.error) {
	        console.warn(delta.error.stack || delta.error);
	      }

	      this.data.set(_.defaults(delta, this.attributes, src));
	    },

	    beforeSet: function beforeSet() /* local, other */{},
	    afterSet: function afterSet() {},

	    onSrcUpdate: function onSrcUpdate() /* model */{
	      this.update();
	    },
	    bubble: function bubble() {
	      var key = _.first(arguments);

	      if (_.has(this.events, key)) {
	        var fct = this[this.events[key]];
	        if (_.isFunction(fct)) {
	          fct.apply(this, _.rest(arguments));
	        }
	      }

	      // todo [akamel] can this result in multiple redraw calls?
	      if (this.src) {
	        this.src.bubble.apply(this.src, _.toArray(arguments));
	      }
	    },

	    update: function update(options) {
	      options = options || {};

	      if (this.src) {
	        if (options.deep) {
	          this.src.update(options);
	          return false;
	        }

	        return true;
	      }

	      return false;
	    }
	  });

	  Model.prototype.set = function (key, value, options) {
	    var obj = {};

	    if (_.isString(key)) {
	      obj[key] = value;
	    } else {
	      obj = key;
	      options = value;
	    }

	    var local = _.pick(obj, this.localKeys);
	    var other = _.omit(obj, this.localKeys);

	    this.beforeSet(local, other);

	    var ret = Model.__super__.set.call(this, local, options);

	    // todo [akamel] if we set options that span multiple data sources we will trigger change multiple times in the chain??
	    // pass along non-local options
	    if (_.size(other)) {
	      if (this.src) {
	        this.src.set(other, options);
	      }
	    }
	    this.afterSet();

	    return ret;
	  };

	  Model.keyRegex = /^([\w_\-$]+):(.+)$/;

	  Model.prototype.get = function (key) {
	    var match = Model.keyRegex.exec(key);

	    if (match) {
	      var type = match[1];
	      var name = match[2];

	      switch (type) {
	        case 'projection':
	          {
	            var p = this;
	            do {
	              if (p.name === name) {
	                return p;
	              }
	              p = p.src;
	            } while (p);
	            break;
	          }
	        default:
	          {
	            throw new Error('unknown special get key type');
	          }
	      }
	    } else {
	      var ret = Model.__super__.get.apply(this, arguments);

	      if (_.isUndefined(ret)) {
	        if (this.src) {
	          ret = this.src.get.apply(this.src, arguments);
	        }
	      }

	      return ret;
	    }
	  };

	  return Model;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(8)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, Backbone) {
	  return Backbone.Model.extend({
	    defaults: {
	      value: [],
	      select: null,
	      count: 0,
	      aggregate: []
	    }
	  });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(8), __webpack_require__(20)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, Backbone, BaseProjection) {
	  var createRows = function createRows(fn, data) {
	    var rows = fn(data);

	    _.each(rows, function (row) {
	      row.$metadata = _.extend({}, row.$metadata, { type: 'aggregate' });
	    });

	    return rows;
	  };

	  var Model = BaseProjection.extend({

	    defaults: {
	      'aggregate.top': null,
	      'aggregate.bottom': null
	    },

	    name: 'aggregate-row',

	    update: function update(options) {
	      var value, topFn, rowTop, bottomFn, rowBottom;

	      if (Model.__super__.update.call(this, options)) {
	        value = this.src.data.get('value');

	        if (value) {
	          topFn = this.get('aggregate.top');
	          bottomFn = this.get('aggregate.bottom');
	          rowTop = _.isFunction(topFn) ? createRows(topFn, this.src.data) : null;
	          rowBottom = _.isFunction(bottomFn) ? createRows(bottomFn, this.src.data) : null;

	          if (rowTop) {
	            value = _.flatten(rowTop).concat(value);
	          }

	          if (rowBottom) {
	            value = value.concat(_.flatten(rowBottom));
	          }

	          this.patch({
	            value: value
	          });
	        }
	      }
	    }

	  });

	  return Model;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(8), __webpack_require__(20), __webpack_require__(24), __webpack_require__(21)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, Backbone, BaseProjection /* , schemaProperties, Response */) {
	  var Model = BaseProjection.extend({
	    defaults: {
	      'column.i18n': {
	        '': function _(name) {
	          return name;
	        }
	      },
	      'subColumn.i18n': {}
	    },
	    name: 'column-i18n',
	    beforeSet: function beforeSet(local) {
	      if (_.has(local, 'column.i18n')) {
	        if (!_.isObject(local['column.i18n'])) {
	          local['column.i18n'] = this.defaults['column.i18n'];
	        }
	      }
	    },
	    update: function update(options) {
	      // todo [akamel] when calling a deep update; suppress onchange event based updates
	      // Model.__super__.update.call(this, options);

	      if (Model.__super__.update.call(this, options)) {
	        var model = this.src.data;
	        var colOptions = this.get('column.i18n');
	        var subColOptions = this.get('subColumn.i18n');
	        var columns = model.get('columns') || {};
	        var $default = colOptions[''];

	        var i18nColumns = {};
	        _.each(_.keys(columns), function (element) {
	          var opt = colOptions[element];
	          if (_.isUndefined(opt)) {
	            opt = $default;
	          }

	          i18nColumns[element] = _.defaults({
	            $text: _.isFunction(opt) ? opt(element) : opt,
	            property: element
	          }, columns[element]);

	          i18nColumns[element].config = i18nColumns[element].config || {};
	          i18nColumns[element].config.subColTitle = subColOptions[element];
	        });

	        this.patch({
	          columns: i18nColumns
	        });
	      } else {
	        // todo [akamel] unset our properties only
	        // this.unset();
	      }
	    }
	  });

	  return Model;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_) {
	  function from(arr) {
	    var obj = _.first(arr);

	    return _.keys(obj || {});
	  }

	  return { from: from };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(8), __webpack_require__(20), __webpack_require__(24), __webpack_require__(21)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, Backbone, BaseProjection /* , schemaProperties, Response */) {
	  var Model = BaseProjection.extend({
	    defaults: {
	      'column.skip': 0,
	      'column.take': Number.MAX_VALUE,
	      'column.lock': [],
	      'column.filter': function columnFilter() {
	        return true;
	      },
	      'column.in': undefined
	    },
	    name: 'column-queryable',
	    update: function update(options) {
	      if (Model.__super__.update.call(this, options)) {
	        var model = this.src.data;
	        var take = this.get('column.take');
	        var skip = this.get('column.skip');
	        var lock = this.get('column.lock') || [];
	        var filter = this.get('column.filter');
	        // todo [akamel] consider renaming to column.select
	        var $in = this.get('column.in');
	        var select = _.size(model.get('columns')) ? _.map(model.get('columns'), function (i) {
	          return i.property;
	        }) : model.get('select');
	        var unlocked = _.isFunction(filter) ? _.filter($in || select, filter) : $in || select;
	        var lookup = model.get('columns');
	        var set = _.chain(unlocked).difference(lock).value();
	        var col = set;

	        if (!_.isNumber(take)) {
	          take = Number.MAX_VALUE;
	        }

	        take = Math.max(take - _.size(lock), 0);
	        if (_.size(set) < skip) {
	          skip = 0;
	          // this.set({ 'columns.skip' : 0 }, { silent : true });
	        }

	        // start query
	        var skipped = _.first(set, skip);

	        if (skip) {
	          col = _.rest(set, skip);
	        }

	        var remaining = _.rest(col, take);

	        col = _.union(lock, _.first(col, take));
	        // end query

	        _.each(col, function (element) {
	          if (!lookup[element]) {
	            lookup[element] = { property: element };
	          }
	          lookup[element].$lock = _.contains(lock, element);
	        });

	        this.patch({
	          'select': col,
	          // todo [akamel] rename to column.in???
	          // , 'columns.select'  : set
	          'columns.skipped': skipped,
	          'columns.remaining': remaining,
	          // , 'columns.count'   : _.size(res)
	          // todo [akamel] do we still need to update skip?
	          'column.skip': skip
	        });
	      } else {
	        // todo [akamel] unset our properties only
	        // this.unset();
	      }
	    }
	  });

	  return Model;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(8), __webpack_require__(20), __webpack_require__(24), __webpack_require__(21)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, Backbone, BaseProjection /* , schemaProperties, Response */) {
	  var Model = BaseProjection.extend({
	    defaults: {},
	    name: 'column-shifter',
	    events: {
	      'layout:click:header': 'thClick'
	    },
	    update: function update(options) {
	      // todo [akamel] when calling a deep update; suppress onchange event based updates
	      if (Model.__super__.update.call(this, options)) {
	        var model = this.src.data;
	        // todo [akamel] have 'columns' crated at the source so we don't have to put this all over the place
	        var columns = model.get('columns');
	        var select = model.get('select');
	        var colSkipped = model.get('columns.skipped');
	        var colRemaining = model.get('columns.remaining');

	        var unlockedAt = Math.max(_.findIndex(select, function (col) {
	          return columns[col] && !columns[col].$lock;
	        }), 0);

	        var hasLess = _.size(colSkipped);
	        var hasMore = _.size(colRemaining);

	        var colLess = {
	          property: 'column.skip.less',
	          $metadata: {
	            'attr.head': { class: ['skip-less'] },
	            'enabled': hasLess
	          },
	          $html: '<span class="glyphicon glyphicon-triangle-left" />'
	        };
	        var colMore = {
	          property: 'column.skip.more',
	          $metadata: {
	            'attr.head': { class: ['skip-more'] },
	            'enabled': hasMore
	          },
	          $html: '<span class="glyphicon glyphicon-triangle-right" />'
	        };

	        if (!hasLess) {
	          colLess.$metadata['attr.head'].class.push('disabled');
	        }

	        if (!hasMore) {
	          colMore.$metadata['attr.head'].class.push('disabled');
	        }

	        select.splice(unlockedAt, 0, colLess.property);
	        columns[colLess.property] = _.defaults(colLess, columns[colLess.property]);
	        select.push(colMore.property);
	        columns[colMore.property] = _.defaults(colMore, columns[colMore.property]);

	        this.patch({
	          columns: columns,
	          select: select
	        });
	      } else {
	        // todo [akamel] unset our properties only
	        // this.unset();
	      }
	    },
	    thClick: function thClick(e, arg) {
	      if (_.has(arg.column, '$metadata') && arg.column.$metadata.enabled) {
	        var ret = 0;
	        var skip = this.get('column.skip');

	        // todo [akamel] is this logic solid?
	        switch (arg.property) {
	          case 'column.skip.less':
	            {
	              ret = _.isNumber(skip) ? Math.max(skip - 1, 0) : 0;
	              break;
	            }
	          case 'column.skip.more':
	            {
	              ret = _.isNumber(skip) ? skip + 1 : 0;
	              break;
	            }
	          default:
	        }

	        this.set({ 'column.skip': ret });
	      }
	    }
	  });

	  return Model;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(20)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, BaseProjection) {
	  'use strict';

	  var Model = BaseProjection.extend({
	    defaults: {
	      'column.template': {}
	    },
	    name: 'column-template',
	    update: function update(options) {
	      // todo [akamel] when calling a deep update; suppress onchange event based updates
	      // Model.__super__.update.call(this, options);

	      // TODO [imang]: columns: ideally we should not need to read from select.
	      if (Model.__super__.update.call(this, options)) {
	        var model = this.src.data;
	        var colTemplate = this.get('column.template');
	        var columns = model.get('columns');
	        _.each(columns, function (item, property) {
	          var ret = _.clone(item);
	          var templateValue = colTemplate[property];

	          if (_.has(colTemplate, property)) {
	            ret.$html = _.isFunction(templateValue) ? templateValue(ret) : templateValue;
	          }

	          columns[property] = ret;
	        });

	        this.patch({ columns: columns });
	      } else {
	        // todo [akamel] unset our properties only
	        // this.unset();
	      }
	    }
	  });

	  return Model;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	/**
	 *
	 * Important!!!
	 *
	 * The initial check-in is for unblock the simple grid in advanced campaign creation and
	 * may cause bugs if you try to use it with some more complex grid. Please DO NOT use this
	 * projection until we update this and remove the comments here.
	 *
	 * todo [yucongj, wewei] add the model to maintail the input data.
	 *
	 */

	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(7), __webpack_require__(20), __webpack_require__(29)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, jquery, BaseProjection, editableTemplate) {
	  'use strict';

	  var Model = BaseProjection.extend({
	    defaults: {
	      'column.editable.string': {}
	    },
	    name: 'column-editable-string',
	    update: function update(options) {
	      if (Model.__super__.update.call(this, options)) {
	        var model = this.src.data;
	        var columnEditable = this.get('column.editable.string');
	        var value = _.map(model.get('value'), function (item) {
	          var ret = _.clone(item);

	          _.each(columnEditable, function (value, key) {
	            if (_.has(ret, key)) {
	              if (!_.isObject(ret[key])) {
	                var obj = new Object(ret[key]); //eslint-disable-line

	                if (_.isUndefined(ret[key])) {
	                  obj.$undefined = true;
	                }

	                if (_.isNull(ret[key])) {
	                  obj.$null = true;
	                }

	                ret[key] = obj;
	              }

	              var defaultValue = ret[key].$undefined || ret[key].$null ? value.defaultValue : ret[key];

	              ret[key].$html = editableTemplate({ defaultValue: defaultValue });
	            }
	          });

	          return ret;
	        });

	        this.patch({ value: value });
	      }
	    }
	  });

	  return Model;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(10);

	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	;var locals_for_with = (locals || {});(function (defaultValue) {
	buf.push("<input type=\"text\"" + (jade.attr("value", defaultValue, true, true)) + " style=\"width:100%\" class=\"grid-text-input\">");}.call(this,"defaultValue" in locals_for_with?locals_for_with.defaultValue:typeof defaultValue!=="undefined"?defaultValue:undefined));;return buf.join("");
	}

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(7), __webpack_require__(20), __webpack_require__(31), __webpack_require__(32), __webpack_require__(35)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, $, BaseProjection, defaultEditableTemplate, prompt) {
	  'use strict';

	  function isReadonlyRow(item) {
	    return !item || item.$metadata && _.contains(['aggregate', 'segmentation'], item.$metadata.type);
	  }

	  return BaseProjection.extend({
	    defaults: {
	      'column.editable': [],
	      'editable.icon.class': ['glyphicon', 'glyphicon-pencil'],
	      'editable.tooltip.text': 'Edit',
	      'editable.template': defaultEditableTemplate
	    },
	    name: 'column-editable',
	    events: {
	      'layout:click:cell': 'tdClick'
	    },

	    beforeSet: function beforeSet(local) {
	      var editable = function editable() {
	        return true;
	      };

	      if (_.has(local, 'column.editable')) {
	        var editableOptions = local['column.editable'];
	        var viewConfig = {};
	        var conditions = {};

	        if (_.isArray(editableOptions)) {
	          _.each(editableOptions, function (editableColumn) {
	            if (_.isString(editableColumn)) {
	              conditions[editableColumn] = editable;
	            } else if (_.isObject(editableColumn) && _.isString(editableColumn.name)) {
	              conditions[editableColumn.name] = _.isFunction(editableColumn.condition) ? editableColumn.condition : editable;
	            }
	            viewConfig[editableColumn] = null;
	          });
	        } else {
	          _.each(editableOptions, function (options, columnName) {
	            if (_.isFunction(options)) {
	              conditions[columnName] = editable;
	              viewConfig[columnName] = options;
	            } else if (_.isObject(options)) {
	              conditions[columnName] = options.condition;
	              viewConfig[columnName] = options.editor;
	            }
	          });
	        }

	        this.viewConfig = viewConfig;
	        this.isEditable = function (key, item) {
	          return _.isFunction(conditions[key]) && conditions[key](item);
	        };
	      }
	    },

	    update: function update(options) {
	      if (BaseProjection.prototype.update.call(this, options)) {
	        var model = this.src.data;
	        var columns = model.get('columns');
	        var iconClasses = this.get('editable.icon.class');
	        var tooltipText = this.get('editable.tooltip.text');
	        var editableTemplate = this.get('editable.template');

	        _.each(this.viewConfig, function (view, key) {
	          var column = columns[key] || { property: key };
	          var $metadata = column.$metadata = column.$metadata || {};
	          var attrBody = $metadata['attr.body'] = $metadata['attr.body'] || {};
	          var className = attrBody.class || [];

	          if (_.isString(className)) {
	            className = className.split(/\s+/);
	          }
	          attrBody.class = _.union(className, ['grid-editable-cell']);

	          columns[key] = column;
	        });

	        var value = _.map(model.get('value'), function (item) {
	          return isReadonlyRow(item) ? item : _.mapObject(item, function (value, key) {
	            if (this.isEditable(key, item)) {
	              var $html = null;
	              var text = null;

	              if (_.isObject(value)) {
	                $html = value.$html;
	              } else {
	                text = value;
	                value = {};
	              }

	              value.$html = editableTemplate({
	                $html: $html,
	                text: text,
	                tooltipText: tooltipText,
	                classes: iconClasses
	              });
	            }
	            return value;
	          }, this);
	        }, this);

	        this.patch({ value: value });
	      }
	    },

	    tdClick: function tdClick(e, arg) {
	      var _this = this;

	      var schema = null;
	      var metadata = arg.column.$metadata;
	      // TODO: wewei
	      // let's rethink this
	      var property = metadata && metadata.map || arg.property;

	      if (!isReadonlyRow(arg.model) && this.isEditable(arg.property, arg.model) && e.target.tagName !== 'A' && $(e.target).closest('.is-not-trigger').length === 0) {
	        schema = arg.grid.options.get('schema');
	        var editor = this.viewConfig[arg.property] || prompt;
	        var position = arg.grid.layout.container.offset(e.currentTarget);
	        var $td = $(e.currentTarget);

	        position.right = position.left + $td.outerWidth();
	        position.bottom = position.top + $td.outerHeight();
	        editor({
	          model: arg.model,
	          schema: schema,
	          position: position,
	          property: property,
	          onSubmit: function onSubmit(model) {
	            _this.trigger('edit', model, property);
	          }
	        });
	      }
	    }

	  });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(10);

	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	;var locals_for_with = (locals || {});(function ($html, classes, text, tooltipText) {
	buf.push("<div" + (jade.attr("title", tooltipText, true, true)) + (jade.cls(['grid-edit-icon',classes], [null,true])) + "></div>" + (null == (jade_interp = $html) ? "" : jade_interp) + (jade.escape(null == (jade_interp = text) ? "" : jade_interp)));}.call(this,"$html" in locals_for_with?locals_for_with.$html:typeof $html!=="undefined"?$html:undefined,"classes" in locals_for_with?locals_for_with.classes:typeof classes!=="undefined"?classes:undefined,"text" in locals_for_with?locals_for_with.text:typeof text!=="undefined"?text:undefined,"tooltipText" in locals_for_with?locals_for_with.tooltipText:typeof tooltipText!=="undefined"?tooltipText:undefined));;return buf.join("");
	}

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(7), __webpack_require__(33), __webpack_require__(8), __webpack_require__(3), __webpack_require__(34)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, Promise, Backbone, _, template) {
	  var PopupEditor = Backbone.View.extend({
	    events: {
	      'click .save': function clickSave() {
	        this.trigger('save', this.model);
	      },
	      'click .cancel': function clickCancel() {
	        this.trigger('cancel');
	      },
	      'change .editor': function changeEditor(e) {
	        this.setValue(e.target.value);
	      },
	      'click form': function clickForm(e) {
	        e.stopPropagation();
	      },
	      'submit form': function submitForm() {
	        this.trigger('save', this.model);
	        return false;
	      }
	    },

	    initialize: function initialize(options) {
	      this.position = options.position;
	      this.model = options.model;
	      this.property = options.property;
	      this.saveButtonText = options.saveButtonText || 'Save';
	      this.cancelButtonText = options.cancelButtonText || 'Cancel';
	    },

	    getValue: function getValue() {
	      if (this.property && _.isObject(this.property)) {
	        var _property = this.property,
	            name = _property.name,
	            value = _property.value;

	        return value(this.model)[name];
	      }

	      return (this.model || {})[this.property];
	    },

	    setValue: function setValue(val) {
	      if (this.property && _.isObject(this.property)) {
	        var _property2 = this.property,
	            name = _property2.name,
	            value = _property2.value;

	        value(this.model)[name] = val;
	      } else {
	        this.model[this.property] = val;
	      }
	    },

	    render: function render() {
	      var _this = this;

	      var val = this.getValue();

	      this.$el.html(template({
	        value: val,
	        saveButtonText: this.saveButtonText,
	        cancelButtonText: this.cancelButtonText
	      }));
	      this.$el.css({ position: 'absolute' });

	      if (this.position.left) {
	        this.$el.css({ left: this.position.left });
	      } else {
	        this.$el.css({ right: this.position.right });
	      }
	      if (this.position.top) {
	        this.$el.css({ top: this.position.top });
	      } else {
	        this.$el.css({ bottom: this.position.bottom });
	      }

	      this.dismiss = function () {
	        this.trigger('cancel');
	      }.bind(this);

	      window.setTimeout(function () {
	        $(window).on('click', _this.dismiss);
	      }, 0);

	      return this;
	    },

	    remove: function remove() {
	      $(window).off('click', this.dismiss);
	      Backbone.View.prototype.remove.apply(this, arguments);
	    },

	    focus: function focus() {
	      var input = this.$el.find('.editor');
	      input.select();
	    }

	  });

	  return function (options) {
	    var editor = new PopupEditor(options);

	    document.body.appendChild(editor.render().el);

	    editor.focus();

	    editor.on('save', function (model) {
	      editor.remove();
	      options.onSubmit && options.onSubmit(model);
	    });

	    editor.on('cancel', function () {
	      editor.remove();
	      options.onCancel && options.onCancel();
	    });
	  };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 33 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_33__;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(10);

	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	;var locals_for_with = (locals || {});(function (cancelButtonText, saveButtonText, value) {
	buf.push("<form role=\"dialog\" class=\"form-inline grid-popup-editor\"><input type=\"text\"" + (jade.attr("value", value, true, true)) + " class=\"form-control editor\">&nbsp<button type=\"button\" class=\"btn btn-primary save\">" + (jade.escape(null == (jade_interp = saveButtonText) ? "" : jade_interp)) + "</button>&nbsp<button type=\"button\" class=\"btn btn-default cancel\">" + (jade.escape(null == (jade_interp = cancelButtonText) ? "" : jade_interp)) + "</button></form>");}.call(this,"cancelButtonText" in locals_for_with?locals_for_with.cancelButtonText:typeof cancelButtonText!=="undefined"?cancelButtonText:undefined,"saveButtonText" in locals_for_with?locals_for_with.saveButtonText:typeof saveButtonText!=="undefined"?saveButtonText:undefined,"value" in locals_for_with?locals_for_with.value:typeof value!=="undefined"?value:undefined));;return buf.join("");
	}

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(36);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(38)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./editable.less", function() {
				var newContent = require("!!../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./editable.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(37)();
	// imports


	// module
	exports.push([module.id, "table.grid td.grid-editable-cell {\n  position: relative;\n}\ntable.grid td.grid-editable-cell .grid-edit-icon {\n  display: none;\n  position: absolute;\n  top: 2px;\n  right: 2px;\n  font-size: 10px;\n}\ntable.grid td.grid-editable-cell:hover .grid-edit-icon {\n  display: block;\n}\n", ""]);

	// exports


/***/ }),
/* 37 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];

		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};

		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];

	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}

		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();

		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";

		var styles = listToStyles(list);
		addStylesToDom(styles, options);

		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}

	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}

	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}

	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}

	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}

	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}

	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}

	function addStyle(obj, options) {
		var styleElement, update, remove;

		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}

		update(obj);

		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}

	var replaceText = (function () {
		var textStore = [];

		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();

	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;

		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}

	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;

		if(media) {
			styleElement.setAttribute("media", media)
		}

		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}

	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;

		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}

		var blob = new Blob([css], { type: "text/css" });

		var oldSrc = linkElement.href;

		linkElement.href = URL.createObjectURL(blob);

		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(33), __webpack_require__(3), __webpack_require__(20), __webpack_require__(24)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Promise, _, BaseProjection, schemaProperties) {
	  var Model = BaseProjection.extend({
	    defaults: {
	      'jsdata.query': undefined,
	      'jsdata.entity': undefined,
	      'jsdata.options': undefined,
	      'skip': undefined,
	      'take': undefined,
	      'filter': undefined,
	      'orderby': [],
	      'select': []
	    },
	    name: 'jsdata',

	    update: function update() {
	      var entity = this.get('jsdata.entity');
	      var options = _.defaults(this.get('jsdata.options'), { all: true });
	      var op = {};

	      this.p$fetchData || this.trigger('update:beginning');

	      var take = this.get('take');

	      if (take) {
	        op.limit = take;
	      }

	      var skip = this.get('skip');

	      if (skip) {
	        op.offset = skip;
	      }

	      var filter = this.get('filter');

	      if (filter) {
	        op.where = filter;
	      }

	      var query = this.get('jsdata.query');

	      if (query) {
	        op.query = query;
	      }

	      var orderby = this.get('orderby');

	      if (orderby && orderby.length) {
	        op.orderBy = _.reduce(orderby, function (arr, obj) {
	          _.each(obj, function (value, key) {
	            arr.push([key, value > 0 ? 'ASC' : 'DESC']);
	          });
	          return arr;
	        }, []);
	      }

	      var p$fetchData = this.p$fetchData = entity.findAll(op, options).then(function (data) {
	        if (this.p$fetchData === p$fetchData) {
	          var delta = {
	            value: data,
	            count: data.totalCount,
	            select: schemaProperties.from(data),
	            error: undefined
	          };
	          if (_.has(data, 'raw')) {
	            delta.rawValue = data.raw;
	          }
	          this.patch(delta);
	        }
	      }.bind(this)).catch(function (error) {
	        if (this.p$fetchData === p$fetchData) {
	          this.patch({ error: error });
	        }
	      }.bind(this)).finally(function () {
	        if (this.p$fetchData === p$fetchData) {
	          this.trigger('update:finished', this.data.get('error'));
	          this.p$fetchData = null;
	        }
	      }.bind(this));
	    }
	  });

	  return Model;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(8), __webpack_require__(20), __webpack_require__(24), __webpack_require__(21)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, Backbone, BaseProjection, schemaProperties /* , Response */) {
	  var Model = BaseProjection.extend({
	    defaults: {
	      // todo [akamel] consider supporting a select on this level?
	      map: _.identity
	    },
	    name: 'map',
	    update: function update(options) {
	      // Model.__super__.update.call(this, options);

	      if (Model.__super__.update.call(this, options)) {
	        var model = this.src.data;
	        var map = this.get('map');
	        var value = _.isFunction(map) ? _.map(model.get('value'), map) : model.get('value');

	        value = _.flatten(value);

	        this.patch({
	          value: value,
	          select: _.without(schemaProperties.from(value), '$metadata')
	        });
	      } else {
	        // todo [akamel] unset our properties only
	        // this.unset();
	      }
	    }
	  });

	  return Model;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(8), __webpack_require__(20), __webpack_require__(24), __webpack_require__(21)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, Backbone, BaseProjection, schemaProperties /* , Response */) {
	  var Model = BaseProjection.extend({
	    defaults: {
	      'skip': 0,
	      'take': Number.MAX_VALUE,
	      'filter': function filter() {
	        return true;
	      },
	      'orderby': [],
	      'select': [],
	      'column.sortable': {}
	    },
	    name: 'map-queryable',
	    beforeSet: function beforeSet(local) {
	      if (_.has(local, 'filter')) {
	        if (!_.isFunction(local.filter)) {
	          local.filter = this.defaults.filter;
	        }
	      }
	    },
	    update: function update(options) {
	      // Model.__super__.update.call(this, options);

	      if (Model.__super__.update.call(this, options)) {
	        var model = this.src.data;
	        var order = _.chain(this.get('orderby')).first().pairs().first().value();

	        var orderKey = _.first(order);
	        var orderDir = _.last(order);

	        var value = _.chain(model.get('value')).filter(this.get('filter'));
	        var sortFunc = this.get('column.sortable')[orderKey];

	        if (orderKey) {
	          if (_.isFunction(sortFunc)) {
	            value = _.chain(sortFunc(value.value(), orderDir));
	          } else {
	            value = value.sortBy(orderKey);
	            if (orderDir === -1) {
	              value = value.reverse();
	            }
	          }
	        }

	        value = value.rest(this.get('skip')).first(this.get('take')).value();

	        var select = this.get('select');
	        if (!_.size(select)) {
	          select = schemaProperties.from(value);
	        }

	        this.patch({
	          value: value,
	          select: select
	        });
	      } else {
	        // todo [akamel] unset our properties only
	        // this.unset();
	      }
	    }
	  });

	  return Model;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(20)], __WEBPACK_AMD_DEFINE_RESULT__ = function (BaseProjection) {
	  var Model = BaseProjection.extend({
	    defaults: {
	      seed: []
	    },
	    update: function update() {
	      this.trigger('update:beginning');

	      var value = this.get('seed');

	      this.data.set({
	        value: value,
	        count: value.length
	      });

	      this.trigger('update:finished');
	    }
	  });

	  return Model;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(8), __webpack_require__(20)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, Backbone, BaseProjection) {
	  var wrds = ['troubles', 'kahlua', 'poncho', 'suzie', 'baheyya'];
	  var idx = 0;

	  function randomRow() {
	    var wrd1 = wrds[_.random(0, wrds.length - 1)];
	    var wrd2 = wrds[_.random(0, wrds.length - 1)];

	    return {
	      index: idx++,
	      name: wrd1 + ' ' + wrd2,
	      age: _.random(0, 22)
	    };
	  }

	  var Model = BaseProjection.extend({
	    defaults: {
	      n: 5000
	    },
	    name: 'mock',
	    update: function update() {
	      this.trigger('update:beginning');
	      var value = [];

	      _(this.get('n')).times(function () {
	        value.push(randomRow());
	      });

	      this.data.set({
	        value: value,
	        count: value.length
	      });
	      this.trigger('update:finished');
	    }
	  });

	  return Model;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(33), __webpack_require__(3), __webpack_require__(8), __webpack_require__(7), __webpack_require__(20), __webpack_require__(24)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Promise, _, Backbone, $, BaseProjection, schemaProperties) {
	  var Model = BaseProjection.extend({
	    defaults: {
	      verb: 'get',
	      url: undefined,
	      skip: undefined,
	      take: undefined,
	      filter: undefined,
	      orderby: [],
	      select: []
	    },
	    name: 'odata',
	    update: function update() {
	      this.p$fetchData || this.trigger('update:beginning');

	      var url = this.get('url');

	      url = _.isFunction(url) ? url() : url;
	      var op = {
	        url: url,
	        $format: 'json',
	        // todo [akamel] this is odata v3 specific
	        $count: true
	      };

	      var take = this.get('take');
	      if (take) {
	        op.$top = take;
	      }

	      var skip = this.get('skip');
	      if (skip) {
	        op.$skip = skip;
	      }

	      // todo [akamel] only supports one order column
	      var orderby = this.get('orderby');
	      if (_.size(orderby)) {
	        var col = _.first(orderby);
	        var key = _.keys(col)[0];
	        var dir = col[key];

	        op.$orderby = key + ' ' + (dir > 0 ? 'asc' : 'desc');
	      }

	      var p$fetchData = this.p$fetchData = new Promise(function (resolve, reject) {
	        $.getJSON(op.url, _.omit(op, 'url')).success(resolve).error(function (jqXHR, textStatus, errorThrown) {
	          reject(new Error(errorThrown));
	        });
	      }).then(function (data) {
	        if (p$fetchData === this.p$fetchData) {
	          var delta = {
	            value: data.value,
	            rawValue: data,
	            select: schemaProperties.from(data.value),
	            count: data['@odata.count'],
	            error: undefined
	          };
	          this.patch(delta);
	        }
	      }.bind(this)).catch(function (error) {
	        if (p$fetchData === this.p$fetchData) {
	          this.patch({ error: error });
	        }
	      }.bind(this)).finally(function () {
	        if (p$fetchData === this.p$fetchData) {
	          this.trigger('update:finished', this.data.get('error'));
	          this.p$fetchData = null;
	        }
	      }.bind(this));
	    }
	  });

	  return Model;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(8), __webpack_require__(20), __webpack_require__(24), __webpack_require__(21)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, Backbone, BaseProjection /* , schemaProperties, Response */) {
	  var Model = BaseProjection.extend({
	    defaults: {
	      'page.size': 20,
	      'page.number': 0 // zero based
	    },
	    name: 'page',
	    // todo [akamel] what if we piped after the data was set?
	    beforeSet: function beforeSet(local, other) {
	      var size = _.has(local, 'page.size') ? local['page.size'] : this.get('page.size');
	      var number = _.has(local, 'page.number') ? local['page.number'] : this.get('page.number');

	      // todo [akamel] sanetize size and number here
	      size = Math.max(size, 0);
	      number = Math.max(number, 0);

	      _.extend(other, {
	        take: size,
	        skip: size * number
	      });
	    },
	    update: function update(options) {
	      var model = this.src.data;
	      var size = Math.max(this.get('page.size'), 0);
	      var count = Math.max(1, model.get('count'));
	      var number = Math.max(this.get('page.number'), 0);
	      var pageCount = Math.ceil(count / size);
	      var pageNumber = Math.min(number, pageCount - 1);

	      options = options || {};

	      if (options.deep) {
	        if (this.src) {
	          this.src.set({
	            take: size,
	            skip: size * pageNumber
	          }, { silent: true });
	        }
	      }

	      // Model.__super__.update.call(this, options);

	      // if we came in with an update:deep
	      if (Model.__super__.update.call(this, options)) {
	        this.patch({ 'page.count': pageCount });
	      } else {
	        // todo [akamel] unset our properties only
	        // this.unset();
	      }
	    }
	  });

	  return Model;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(8), __webpack_require__(20), __webpack_require__(24), __webpack_require__(21)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, Backbone, BaseProjection /* , schemaProperties, Response */) {
	  var Model = BaseProjection.extend({
	    defaults: {
	      'property.template': {}
	    },
	    name: 'property-template',
	    update: function update(options) {
	      // Model.__super__.update.call(this, options);

	      if (Model.__super__.update.call(this, options)) {
	        var model = this.src.data;
	        var opt = this.get('property.template');
	        var value = _.map(model.get('value'), function (item) {
	          var ret = _.clone(item);

	          _.each(opt, function (value, key) {
	            if (_.has(ret, key)) {
	              var res = value({
	                model: item,
	                property: key
	              });

	              if (!_.isObject(ret[key])) {
	                var obj = new Object(ret[key]); // eslint-disable-line

	                if (_.isUndefined(ret[key])) {
	                  obj.$undefined = true;
	                }

	                if (_.isNull(ret[key])) {
	                  obj.$null = true;
	                }

	                ret[key] = obj;
	              }

	              ret[key].$html = res;
	            }
	          });

	          return ret;
	        });

	        this.patch({ value: value });
	      } else {
	        // todo [akamel] unset our properties only
	        // this.unset();
	      }
	    }
	  });

	  return Model;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(8), __webpack_require__(20), __webpack_require__(48)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, Backbone, BaseProjection, selectableTemplate) {
	  'use strict';

	  var Model = BaseProjection.extend({
	    defaults: {
	      'column.checked': 'checkbox', // the checkbox column
	      'row.check.id': 'Id',
	      'row.check.list': [],
	      'row.check.checked.all': false, // used to store user's check value for the special case no rows or all rows is disabled
	      'row.check.single': false,
	      'row.check.allow': function rowCheckAllow() {
	        return true;
	      }
	    },
	    name: 'row-check',
	    events: {
	      'layout:click:cell': 'tdClick',
	      'layout:click:header': 'thClick'
	    },
	    reset: function reset() {
	      this.set({
	        'row.check.checked.all': false,
	        'row.check.list': []
	      });
	    },
	    update: function update(options) {
	      // Model.__super__.update.call(this, options);

	      if (Model.__super__.update.call(this, options)) {
	        var model = this.src.data;
	        var checkId = this.get('row.check.id');
	        var value = model.get('value');
	        var ids = _.pluck(value, checkId);
	        var checked = _.intersection(this.get('row.check.list'), ids);
	        var checkedLookup = _.object(checked, []);
	        var col = this.get('column.checked');
	        var columns = _.clone(model.get('columns'));
	        var checkedAll = value.length > 0;
	        var hasCheckboxable = false;
	        var checkboxAllow = this.get('row.check.allow');
	        var checkboxColumn = _.find(columns, function (item) {
	          return item.property === col;
	        });
	        var isSingle = this.get('row.check.single');

	        this.set('row.check.list', checked, { silent: true });

	        // todo [akamel] it is not clear how 'hasCheckboxable' is used
	        value = _.map(value, function (item) {
	          var ret = _.clone(item);
	          var checked = false;
	          var disabled = true;
	          var isAllowed = _.isFunction(checkboxAllow) ? checkboxAllow(ret) : checkboxAllow;

	          if (isAllowed) {
	            checked = _.has(checkedLookup, ret[checkId]);
	            checkedAll = checkedAll && checked;
	            disabled = false;
	            hasCheckboxable = true;

	            var uniqueId = model.get('a11y.selection.uniqueId');
	            var labelledId = (uniqueId || '').concat(ret[checkId]);

	            ret[col] = _.extend({}, ret[col], {
	              $html: selectableTemplate(_.pick({
	                type: isSingle ? 'radio' : 'checkbox',
	                checked: checked,
	                disabled: disabled,
	                labelledId: labelledId
	              }, Boolean))
	            });
	          }

	          return ret;
	        });

	        // set the checkbox in th
	        if (!_.isUndefined(checkboxColumn)) {
	          if (isSingle) {
	            checkboxColumn.$html = '<span/>';
	          } else {
	            var disabled = _.size(ids) === 0;
	            var labelString = model.get('a11y.selection.selectAllLabel');
	            if (hasCheckboxable) {
	              checkboxColumn.$html = selectableTemplate(_.pick({
	                type: 'checkbox',
	                checked: checkedAll,
	                disabled: disabled,
	                labelString: labelString
	              }, Boolean));
	              if (!checkedAll) {
	                this.attributes['row.check.checked.all'] = false;
	              }
	            } else {
	              checkboxColumn.$html = selectableTemplate(_.pick({
	                type: 'checkbox',
	                checked: this.get('row.check.checked.all'),
	                disabled: disabled,
	                labelString: labelString
	              }, Boolean));
	            }
	          }
	        }

	        this.patch({
	          value: value,
	          columns: columns,
	          'row.check.allow': checkboxAllow
	        });
	      } else {
	        // todo [akamel] unset our properties only
	        // this.unset();
	      }
	    },
	    tdClick: function tdClick(e, arg) {
	      var checkboxProperty = this.get('column.checked');
	      var isSingle = this.get('row.check.single');

	      if (arg.property === checkboxProperty) {
	        var list = this.get('row.check.list');
	        var id = arg.model[this.get('row.check.id')];

	        if (isSingle) {
	          this.set({ 'row.check.list': [id] });
	        } else {
	          this.set({
	            'row.check.list': arg.checked ? list.concat([id]) : _.without(list, id)
	          });
	        }

	        this.update();
	      }
	    },
	    thClick: function thClick(e, arg) {
	      var checkboxProperty = this.get('column.checked');

	      if (arg.property === checkboxProperty) {
	        var list = [];

	        if (arg.checked) {
	          var checkId = this.get('row.check.id');
	          // TODO [akamel] this concept of check allow is strange
	          var checkboxAllow = this.get('row.check.allow');

	          // get the list of allowed rows' id
	          list = _.chain(this.data.get('value')).filter(function (item) {
	            return (_.isFunction(checkboxAllow) ? checkboxAllow(item) : checkboxAllow) && !_.isUndefined(item[checkId]);
	          }).map(function (item) {
	            return item[checkId];
	          }).value();
	        }

	        this.set({
	          'row.check.list': list,
	          'row.check.checked.all': arg.checked
	        });

	        this.update();
	      }
	    }
	  });

	  return Model;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(10);

	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	;var locals_for_with = (locals || {});(function (checked, disabled, labelString, labelledId, type) {
	buf.push("<input" + (jade.attr("type", type, true, true)) + (jade.attr("checked", checked, true, true)) + (jade.attr("disabled", disabled, true, true)) + (jade.attr("aria-labelledby", labelledId, true, true)) + (jade.attr("aria-label", labelString, true, true)) + " class=\"column-selection\">");}.call(this,"checked" in locals_for_with?locals_for_with.checked:typeof checked!=="undefined"?checked:undefined,"disabled" in locals_for_with?locals_for_with.disabled:typeof disabled!=="undefined"?disabled:undefined,"labelString" in locals_for_with?locals_for_with.labelString:typeof labelString!=="undefined"?labelString:undefined,"labelledId" in locals_for_with?locals_for_with.labelledId:typeof labelledId!=="undefined"?labelledId:undefined,"type" in locals_for_with?locals_for_with.type:typeof type!=="undefined"?type:undefined));;return buf.join("");
	}

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(8), __webpack_require__(20)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, Backbone, BaseProjection) {
	  var Model = BaseProjection.extend({
	    defaults: {
	      'row.classes': {}
	    },
	    name: 'row',
	    update: function update(options) {
	      var _this = this;

	      if (Model.__super__.update.call(this, options)) {
	        var selectedMap = {};

	        _.each(this.get('row.check.list'), function (selectedIndex) {
	          selectedMap[selectedIndex] = true;
	        });

	        var model = this.src.data;
	        var rows = model.get('value');

	        _.each(rows, function (row) {
	          var type = _.chain(row).result('$metadata').result('type').value();

	          if (_.isUndefined(type)) {
	            row.$metadata = _.extend({}, row.$metadata, {
	              type: 'row'
	            });
	          }
	        });

	        _.each(rows, function (row) {
	          var classesRule = _this.get('row.classes');
	          var checkId = _this.get('row.check.id');
	          var checkboxAllow = model.get('row.check.allow');
	          var classArr = [];

	          if (selectedMap[row[checkId]]) {
	            classArr.push('row-selected');
	          }

	          var originClass = _.chain(row).result('$metadata').result('attr').result('class').value();

	          if (originClass) {
	            classArr.push(originClass);
	          }

	          _.each(classesRule, function (func, key) {
	            var type = _.chain(row).result('$metadata').result('type').value();

	            if (_.isFunction(func) && func(row, type)) {
	              classArr.push(key);
	            }
	          });

	          //attr info from meta
	          var originId = _.chain(row).result('$metadate').result('attr').result('id').value();

	          if (_.isFunction(checkboxAllow) ? checkboxAllow(row) : checkboxAllow) {
	            var uniqueId = model.get('a11y.selection.uniqueId');
	            var id = row[checkId] || originId;
	            var a11yId = uniqueId.concat(id);
	            var role = 'row';
	          }

	          _.extend(row, {
	            $metadata: {
	              attr: _.pick({
	                class: _.flatten(classArr).join(' '),
	                id: a11yId,
	                role: role
	              }, Boolean)
	            }
	          });
	        });

	        this.patch({ value: rows });
	      }
	    }
	  });

	  return Model;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(8), __webpack_require__(20), __webpack_require__(51)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, Backbone, BaseProjection, defaultRowCheckTemp) {
	  'use strict';

	  var CheckTransitionRule = {};

	  // CheckTransitionRule functions determine the state transition of a checkbox.
	  // State transition depends on the current state and wheather a short or full cycle is requested.
	  // When the short  cycle is requested the checkbox cannot return to the indeterminate state,
	  // event if it started in this state.
	  // Two directions of transition are available:
	  // ... -> indeterminate -> checked -> unchecked -> ...
	  // ... -> indeterminate -> unchecked -> checked -> ...
	  CheckTransitionRule.indeterminateToChecked = function () {
	    var nextState = {
	      unchecked: function unchecked(shortCycle) {
	        return shortCycle ? 'checked' : 'indeterminate';
	      },
	      checked: _.constant('unchecked'),
	      indeterminate: _.constant('checked')
	    };

	    return function (shortCycle, currentState) {
	      return _.has(nextState, currentState) && nextState[currentState](shortCycle) || 'unchecked';
	    };
	  }();

	  CheckTransitionRule.indeterminateToUnchecked = function () {
	    var nextState = {
	      unchecked: _.constant('checked'),
	      checked: function checked(shortCycle) {
	        return shortCycle ? 'unchecked' : 'indeterminate';
	      },
	      indeterminate: _.constant('unchecked')
	    };

	    return function (shortCycle, currentState) {
	      return _.has(nextState, currentState) && nextState[currentState](shortCycle) || 'unchecked';
	    };
	  }();

	  CheckTransitionRule.indeterminateToCheckedFullCycle = function (currentState) {
	    return CheckTransitionRule.indeterminateToChecked(false, currentState);
	  };

	  CheckTransitionRule.indeterminateToUncheckedFullCycle = function (currentState) {
	    return CheckTransitionRule.indeterminateToUnchecked(false, currentState);
	  };

	  CheckTransitionRule.indeterminateToCheckedShortCycle = function (currentState) {
	    return CheckTransitionRule.indeterminateToChecked(true, currentState);
	  };

	  CheckTransitionRule.indeterminateToUncheckedShortCycle = function (currentState) {
	    return CheckTransitionRule.indeterminateToUnchecked(true, currentState);
	  };

	  function getAllCheckState(checkStateCounters, count) {
	    return _.findKey(checkStateCounters, function (c) {
	      return c === count;
	    }) || 'unchecked';
	  }

	  var Model = BaseProjection.extend({
	    defaults: {
	      'column.checked': 'checkbox', // the checkbox column
	      'row.check.id': 'Id',
	      'row.check.map': {},
	      'row.check.all': { state: 'unchecked' }, // used to store user's check value for the special case no rows or all rows is disabled
	      'row.check.allow': function rowCheckAllow() {
	        return true;
	      },
	      'row.check.click-anywhere': false,
	      'row.check.transition': CheckTransitionRule.indeterminateToCheckedShortCycle,
	      'row.check.all.transition': CheckTransitionRule.indeterminateToCheckedShortCycle,
	      'row.check.template': defaultRowCheckTemp
	    },
	    name: 'row-check',
	    events: {
	      'layout:click:cell': 'tdClick',
	      'layout:click:header': 'thClick'
	    },
	    reset: function reset() {
	      this.set({
	        'row.check.checked.all': false,
	        'row.check.map': {}
	      });
	    },
	    update: function update(options) {
	      if (!Model.__super__.update.call(this, options)) {
	        return;
	      }

	      var checkId = this.get('row.check.id');
	      var ids = _.pluck(this.src.data.get('value'), checkId);
	      var checkMap = this.get('row.check.map');
	      var col = this.get('column.checked');
	      var columns = _.clone(this.src.data.get('columns'));
	      var checkStateCounters = _.object(['unchecked', 'checked', 'indeterminate'], [0, 0, 0]);
	      var hasCheckboxable = false;
	      var checkboxAllow = this.get('row.check.allow');
	      var checkboxColumn = _.find(columns, function (item) {
	        return item.property === col;
	      });
	      var rowCheckTemp = this.get('row.check.template');

	      var value = _.map(this.src.data.get('value'), function (item) {
	        var ret = _.clone(item);
	        var check = checkMap[ret[checkId]] || { state: 'unchecked' };
	        var disabled = true;
	        var isAllowed = _.isFunction(checkboxAllow) ? checkboxAllow(ret) : checkboxAllow;

	        checkStateCounters[check.state]++;

	        if (isAllowed) {
	          disabled = false;
	          hasCheckboxable = true;
	        }

	        ret[col] = _.extend({}, ret[col], {
	          $html: rowCheckTemp({ checkState: check.state, disabled: disabled })
	        });

	        return ret;
	      });

	      // set the checkbox in th
	      if (!_.isUndefined(checkboxColumn)) {
	        var disabledAllCheck = _.size(ids) === 0;

	        if (hasCheckboxable) {
	          var checkState = getAllCheckState(checkStateCounters, ids.length);

	          checkboxColumn.$html = rowCheckTemp({ checkState: checkState, disabled: disabledAllCheck });
	          this.attributes['row.check.all'] = _.extend(this.attributes['row.check.all'], { state: checkState });
	        } else {
	          checkboxColumn.$html = rowCheckTemp({ checkState: this.get('row.check.all').state, disabled: disabledAllCheck });
	        }
	      }

	      this.patch({
	        value: value,
	        columns: columns
	      });
	    },
	    tdClick: function tdClick(e, arg) {
	      var checkboxProperty = this.get('column.checked');
	      var clickAnywhere = this.get('row.check.click-anywhere');

	      if (arg.property === checkboxProperty || clickAnywhere) {
	        var checkMap = _.clone(this.get('row.check.map'));
	        var id = arg.model[this.get('row.check.id')];
	        var defaultTransition = this.get('row.check.transition');
	        var check = _.extend({
	          id: id,
	          transition: defaultTransition,
	          state: 'unchecked'
	        }, checkMap[id]);

	        check.state = check.transition(check.state);
	        checkMap[id] = check;

	        this.set({
	          'row.check.map': checkMap
	        });

	        e.preventDefault();
	        e.stopImmediatePropagation();
	      }
	    },
	    thClick: function thClick(e, arg) {
	      var checkboxProperty = this.get('column.checked');

	      if (arg.property === checkboxProperty) {
	        var checkMap = _.clone(this.get('row.check.map'));
	        var checkId = this.get('row.check.id');
	        var allCheck = this.get('row.check.all');
	        var checkState = allCheck.state;
	        var allCheckTransitionRule = this.get('row.check.all.transition');
	        var CheckTransitionRule = this.get('row.check.transition');

	        allCheck.state = allCheckTransitionRule(checkState);

	        checkMap = _.object(this.data.get('value').map(function (item) {
	          var id = item[checkId];
	          var check = _.extend({
	            id: id,
	            transition: CheckTransitionRule
	          }, checkMap[id], { state: allCheck.state });

	          return [id, check];
	        }));

	        this.set({
	          'row.check.map': checkMap,
	          'row.check.all': allCheck
	        });

	        e.stopImmediatePropagation();
	      }
	    }
	  });

	  function CheckDiff(added, changed, removed, unchanged) {
	    this.added = added || {};
	    this.changed = changed || {};
	    this.removed = removed || {};
	    this.unchanged = unchanged || {};
	  }

	  CheckDiff.prototype.hasChanges = function () {
	    return _.keys(this.changed).length + _.keys(this.added).length > 0;
	  };

	  function diffCheckMap(before, after, defaultState) {
	    defaultState = defaultState || { state: 'unchecked' };

	    var checkDiff = new CheckDiff();

	    _.keys(before).forEach(function (key) {
	      var beforeState = before[key];
	      var afterState = after[key];

	      if (!afterState) {
	        checkDiff.removed[key] = beforeState;
	      } else if (beforeState.state === afterState.state) {
	        checkDiff.unchanged[key] = afterState;
	      } else {
	        checkDiff.changed[key] = { before: beforeState, after: afterState };
	      }
	    });

	    _.keys(after).forEach(function (key) {
	      var afterState = after[key];
	      var beforeState = before[key];

	      if (!beforeState && defaultState.state !== afterState.state) {
	        checkDiff.added[key] = afterState;
	      }
	    });

	    return checkDiff;
	  }

	  function statCheckMap(checkMap, defaultState) {
	    defaultState = defaultState || { state: 'unchecked' };
	    var checked = [];
	    var indeterminate = [];
	    var unchecked = [];

	    _.keys(checkMap).forEach(function (key) {
	      var check = checkMap[key];

	      if (check.state === 'checked' && check.state !== defaultState.state) {
	        checked.push(check);
	      } else if (check.state === 'unchecked' && check.state !== defaultState.state) {
	        unchecked.push(check);
	      } else if (check.state !== defaultState.state) {
	        indeterminate.push(check);
	      }
	    });

	    return {
	      checked: checked,
	      unchecked: unchecked,
	      indeterminate: indeterminate
	    };
	  }

	  function fullStatCheckMap(before, after, defaultState) {
	    return _.extend(statCheckMap(after, defaultState), diffCheckMap(before, after, defaultState));
	  }

	  Model.CheckTransitionRule = CheckTransitionRule;
	  Model.fullStatCheckMap = fullStatCheckMap;
	  Model.statCheckMap = statCheckMap;
	  Model.diffCheckMap = diffCheckMap;

	  return Model;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(10);

	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	;var locals_for_with = (locals || {});(function (checkState) {
	var classes = [].concat(checkState === 'indeterminate' ? ['glyphicon', 'glyphicon-minus'] : checkState === 'checked' ? ['glyphicon', 'glyphicon-ok'] : [])
	buf.push("<div class=\"column-tri-state-checkbox\"><span" + (jade.cls([classes], [true])) + "></span></div>");}.call(this,"checkState" in locals_for_with?locals_for_with.checkState:typeof checkState!=="undefined"?checkState:undefined));;return buf.join("");
	}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(8), __webpack_require__(20), __webpack_require__(24), __webpack_require__(21)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, Backbone, BaseProjection /* , schemaProperties, Response */) {
	  var Model = BaseProjection.extend({
	    defaults: {},
	    name: 'row-index',
	    update: function update(options) {
	      if (Model.__super__.update.call(this, options)) {
	        var model = this.src.data;
	        var skip = this.get('skip');
	        var value = _.map(model.get('value'), function (i, idx) {
	          var ret = _.clone(i);
	          ret.rowIndex = idx + (_.isFinite(skip) ? skip : 0) + 1;
	          return ret;
	        });

	        this.patch({ value: value });
	      } else {
	        // todo [akamel] unset our properties only
	        // this.unset();
	      }
	    }
	  });

	  return Model;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(20), __webpack_require__(24)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, BaseProjection, schemaProperties) {
	  var Model = BaseProjection.extend({

	    defaults: {
	      seed: null
	    },

	    name: 'sink',

	    update: function update() {
	      var value;

	      value = this.get('seed');

	      if (value) {
	        var select = schemaProperties.from(value);
	        this.patch({
	          value: value,
	          select: select,
	          count: _.size(value)
	        });
	      }
	    }

	  });

	  return Model;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(8), __webpack_require__(20)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, Backbone, BaseProjection) {
	  var Model = BaseProjection.extend({
	    name: 'column-hovertext',
	    update: function update(options) {
	      if (Model.__super__.update.call(this, options)) {
	        var model = this.src.data;
	        var columns = model.get('columns');

	        _.each(columns, function (column) {
	          column.$metadata = _.result(column, '$metadata', {});
	          column.$metadata['attr.head'] = _.result(column.$metadata, 'attr.head', {});
	          column.$metadata['attr.head'].title = _.result(column.config, 'hoverText') || _.result(column.config, 'title') || '';
	        });

	        this.patch({ columns: columns });
	      }
	    }
	  });

	  return Model;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _base = __webpack_require__(20);

	var _base2 = _interopRequireDefault(_base);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var ColumnsProjection = _base2.default.extend({
	  defaults: {
	    columns: {}
	  },

	  name: 'columns',

	  update: function update(options) {
	    if (_base2.default.prototype.update.call(this, options)) {
	      this.patch({
	        columns: this.get('columns')
	      });
	    }
	  }
	});

	exports.default = ColumnsProjection;

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.delegateEvents = delegateEvents;

	var _underscore = __webpack_require__(3);

	var _underscore2 = _interopRequireDefault(_underscore);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function delegateEvents(_ref) {
	  var from = _ref.from,
	      to = _ref.to,
	      events = _ref.events;

	  _underscore2.default.each(events, function (event) {
	    return from.on(event, function () {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }

	      return to.trigger.apply(to, [event].concat(args));
	    });
	  });
	}

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _underscore = __webpack_require__(3);

	var _underscore2 = _interopRequireDefault(_underscore);

	var _gridView = __webpack_require__(58);

	var _gridView2 = _interopRequireDefault(_gridView);

	var _index = __webpack_require__(5);

	var _index2 = _interopRequireDefault(_index);

	var _utility = __webpack_require__(56);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = function (definePlugin) {
	  return definePlugin('gridView', ['config', 'projection', 'renderers'], function (config, projection, renderers) {
	    var gridView = new _gridView2.default({
	      projection: projection,
	      el: config.el,
	      container: _underscore2.default.chain(config).result('scrollable').result('fixedHeader').result('container').value(),
	      schema: config.dataSource.schema,
	      Layout: _index2.default.TableLayout.partial({
	        renderers: renderers,
	        template: _index2.default.templates.table,
	        hideHeaders: config.hideHeaders,
	        $metadata: config.layoutOptions || {}
	      })
	    });

	    (0, _utility.delegateEvents)({
	      from: projection,
	      to: gridView,
	      events: ['update:beginning', 'update:finished']
	    });

	    return gridView;
	  });
	};

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(8), __webpack_require__(59), __webpack_require__(60), __webpack_require__(62)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, Backbone, Options, WindowContainer, ElementContainer) {
	  var GridView = Backbone.View.extend({
	    // todo [akamel] document available options
	    initialize: function initialize(options) {
	      options = options || {};

	      this.options = new Options(options);

	      var container = selectContainer(options.container);

	      // todo [akamel] assert that layout is a ctor
	      this.layout = new options.Layout({
	        el: this.el,
	        grid: this,
	        container: container
	      });

	      this.projection = options.projection;

	      this.projection.data.on('change', function () {
	        this.trigger.apply(this, ['change:data'].concat(_.toArray(arguments)));
	      }.bind(this));

	      this.options.on('change', function () {
	        this.trigger.apply(this, ['change:options'].concat(_.toArray(arguments)));
	      }.bind(this));

	      this.projection.on('all', function () {
	        this.trigger.apply(this, ['data:' + _.first(arguments)].concat(_.rest(arguments)));
	      }.bind(this));

	      this.layout.on('all', function () {
	        var key = 'layout:' + _.first(arguments);
	        var arg = [key].concat(_.rest(arguments));

	        this.projection.bubble.apply(this.projection, arg);
	        this.trigger.apply(this, arg);
	      }.bind(this));

	      // todo [akamel] this is a temporary implementation of orderby; should be in layout not in grid
	      this.on('layout:click:header', function (e, arg) {
	        var column = arg.column;

	        if (column.sortable) {
	          var orderby = this.projection.get('orderby') || [];
	          orderby = _.filter(orderby, function (item) {
	            return item.scope === 'global';
	          });

	          var key = _.isString(column.sortable) ? column.sortable : column.property;

	          var orderItem = {};
	          orderItem[key] = column.$orderby ? column.$orderby.dir * -1 : 1;
	          orderby.push(orderItem);

	          this.projection.set({ 'orderby': orderby, 'page.number': 0 });
	        }
	      }.bind(this));

	      var local = _.omit(options, 'projection', 'layout');
	      this.options.set(local);
	    },

	    remove: function remove() {
	      this.layout.remove();
	      Backbone.View.prototype.remove.apply(this, arguments);
	    },

	    set: function set() {
	      this.options.set.apply(this.options, _.toArray(arguments));
	    },

	    render: function render(options) {
	      options = options || {};

	      this.layout.render();

	      if (options.fetch) {
	        this.projection.update({ deep: true });
	      }

	      return this;
	    },

	    rerender: function rerender() {
	      this.layout.rerender();
	    },

	    getSelection: function getSelection() {
	      return this.projection.get('row.check.list') || [];
	    },

	    monitorViewportChange: function monitorViewportChange(timeout, interval) {
	      this.layout.monitorViewportChange(timeout, interval);
	    }

	  });

	  function selectContainer(userContainer) {
	    if (userContainer && window !== userContainer && ElementContainer.isValidContainer(userContainer)) {
	      return new ElementContainer({ el: userContainer });
	    }

	    return new WindowContainer();
	  }

	  return GridView;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(8)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, Backbone) {
	  return Backbone.Model.extend({
	    defaults: {
	      layout: undefined,
	      projection: undefined
	    }
	  });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(7), __webpack_require__(61)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, $, ContainerBase) {
	  var WindowContainer = ContainerBase.extend({
	    constructor: function constructor(options) {
	      options = _.extend({}, options, { el: window });
	      ContainerBase.prototype.constructor.apply(this, [options].concat(_.rest(arguments)));
	    },

	    offset: function offset(element) {
	      return $(element).offset();
	    }
	  });

	  return WindowContainer;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(7), __webpack_require__(8)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, $, Backbone) {
	  var ContainerBase = Backbone.View.extend({
	    events: {
	      scroll: 'onScroll',
	      resize: 'onResize'
	    },

	    onScroll: function onScroll(e) {
	      this.trigger('scroll:container', e);
	    },

	    onResize: function onResize(e) {
	      this.trigger('resize:container', e);
	    },

	    offset: function offset() /* element, scrollTop, scrollLeft */{
	      throw new Error("Offset function not implemented");
	    }
	  });

	  return ContainerBase;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(7), __webpack_require__(61)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, $, ContainerBase) {
	  var ElementContainer = ContainerBase.extend({
	    offset: function offset(element) {
	      var position = $(element).position();

	      return {
	        top: position.top + this.$el.scrollTop(),
	        left: position.left + this.$el.scrollLeft()
	      };
	    }
	  });

	  ElementContainer.isValidContainer = function (userContainer) {
	    return ['absolute', 'relative', 'fixed'].indexOf($(userContainer).css('position')) >= 0;
	  };

	  return ElementContainer;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _underscore = __webpack_require__(3);

	var _underscore2 = _interopRequireDefault(_underscore);

	var _dataSource = __webpack_require__(64);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/**
	 * @typedef DataSourceConfig
	 * @type {DataSource|BuiltinDataSourceConfig}
	 */

	/**
	 * @typedef BuiltinDataSourceConfig
	 * @type {Object}
	 * @property {string} type
	 *    The builtin data source type, available values are 'odata', 'js-data'
	 *    and 'memory'.
	 * @property {string?} primaryKey
	 *    The primaryKey for the data source. Required by 'odata' and 'memory'
	 *    data sources.
	 * @property {JSDataResource?} entity
	 *    The JSDataResource representing the entity set. Required by 'js-data'
	 *    data source.
	 * @property {string?} url
	 *    The URL for the entity set. Required by 'odata' data source.
	 * @property {Object[]?} data
	 *    The in-memory data set. Required by 'memory' data source.
	 *
	 */

	exports.default = function (definePlugin) {
	  return definePlugin('dataSource', ['config'], function (config) {
	    var dataSource = _underscore2.default.result(config, 'dataSource', {});

	    if (dataSource instanceof _dataSource.DataSource) {
	      return dataSource;
	    }

	    var type = dataSource.type,
	        primaryKey = dataSource.primaryKey;


	    if (type === 'memory') {
	      return new _dataSource.MemoryDataSource(dataSource.data, primaryKey);
	    }

	    if (type === 'odata') {
	      return new _dataSource.ODataDataSource(dataSource.url, primaryKey);
	    }

	    if (_underscore2.default.contains(['jsdata', 'js-data'], type)) {
	      return new _dataSource.JSDataDataSource(dataSource.entity, dataSource.options);
	    }

	    throw new Error('Unsupported data source type');
	  });
	};

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _base = __webpack_require__(65);

	Object.defineProperty(exports, 'DataSource', {
	  enumerable: true,
	  get: function get() {
	    return _base.DataSource;
	  }
	});

	var _odata = __webpack_require__(66);

	Object.defineProperty(exports, 'ODataDataSource', {
	  enumerable: true,
	  get: function get() {
	    return _odata.ODataDataSource;
	  }
	});

	var _jsData = __webpack_require__(67);

	Object.defineProperty(exports, 'JSDataDataSource', {
	  enumerable: true,
	  get: function get() {
	    return _jsData.JSDataDataSource;
	  }
	});

	var _memory = __webpack_require__(68);

	Object.defineProperty(exports, 'MemoryDataSource', {
	  enumerable: true,
	  get: function get() {
	    return _memory.MemoryDataSource;
	  }
	});

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DataSource = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _underscore = __webpack_require__(3);

	var _underscore2 = _interopRequireDefault(_underscore);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var defaultPrimaryKey = '__primary_key__';

	/**
	 * The base class for all data sources.
	 * @class DataSource
	 * @param {string} [primaryKey='__primary_key__']
	 *    The primary key of the entity set.
	 */

	var DataSource = exports.DataSource = function () {
	  function DataSource() {
	    var primaryKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultPrimaryKey;

	    _classCallCheck(this, DataSource);

	    this._primaryKey = primaryKey;
	  }

	  /**
	   * The primary key of the data source.
	   * @type {string}
	   */


	  _createClass(DataSource, [{
	    key: 'query',


	    /**
	     * Query the data source with given parameters
	     * @param {object} params - The query parameters
	     */
	    value: function query(params) {
	      return {
	        items: [],
	        totalCount: 0
	      };
	    }

	    /**
	     * The order-by configuration for the data source.
	     * @typedef OrderByConfig
	     * @type {OrderByItem|OrderByItem[]}
	     */

	    /**
	     * A [key: string, direction: number] pair.
	     * @typedef NormalizedOrderByPair
	     * @type {array}
	     */

	    /**
	     * Normalize the orderby parameter for data source.
	     * @param {OrderByConfig} orderBy
	     * @return {NormalizedOrderByPair[]}
	     */

	  }, {
	    key: 'normalizeOrderBy',
	    value: function normalizeOrderBy() {
	      var _this = this;

	      var orderBy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];


	      /**
	       * A single order-by item with key and direction.
	       * @typedef OrderByItem
	       * @type {OrderByObject|OrderByPair}
	       */
	      return _underscore2.default.reduce(_underscore2.default.isArray(orderBy) ? orderBy : [orderBy], function (memo, item) {
	        var key = null;
	        var direction = null;
	        var dirString = null;

	        /**
	         * A [key: OrderByKey, direction: number] pair.
	         * @typedef OrderByPair
	         * @type {array}
	         */
	        if (_underscore2.default.isArray(item)) {
	          key = item[0];
	          direction = item[1];
	        }

	        /**
	         * @typedef OrderByObject
	         * @type {object}
	         * @property {OrderByKey} key - The key off the order by item
	         * @property {number} direction - The direction of the order by item, positive
	         * for ascending, non-positive for descending
	         */
	        if (_underscore2.default.isObject(item)) {
	          key = item.key;
	          direction = item.direction;
	        }

	        if (!_underscore2.default.isNumber(direction)) {
	          throw new Error('Invalid direction option for orderBy');
	        }

	        if (!direction) {
	          return memo;
	        }

	        /**
	         * Represents an order by key
	         *  * When it's a string, it's the key path of the sorting value.
	         *  * When it's a callback, it takes a direction, and return a normalized
	         *    order config.
	         * @typedef OrderByKey
	         * @type {string|OrderByCallback}
	         */
	        if (_underscore2.default.isFunction(key)) {
	          /**
	           * @callback OrderByCallback
	           * @param {number} direction - The direction of the order by item
	           * @return {OrderByConfig}
	           */
	          return memo.concat(_this.normalizeOrderBy(key(direction)));
	        }

	        if (_underscore2.default.isString(key)) {
	          memo.push([key, direction]);
	          return memo;
	        }

	        throw new Error('Invalid key option for orderBy');
	      }, []);
	    }
	  }, {
	    key: 'primaryKey',
	    get: function get() {
	      return this._primaryKey;
	    }
	  }]);

	  return DataSource;
	}();

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ODataDataSource = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

	var _underscore = __webpack_require__(3);

	var _underscore2 = _interopRequireDefault(_underscore);

	var _jquery = __webpack_require__(7);

	var _jquery2 = _interopRequireDefault(_jquery);

	var _bluebird = __webpack_require__(33);

	var _bluebird2 = _interopRequireDefault(_bluebird);

	var _base = __webpack_require__(65);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	function translateOrderBy(dataSource, orderByParams) {
	  return _underscore2.default.chain(dataSource.normalizeOrderBy(orderByParams)).map(function (_ref) {
	    var _ref2 = _slicedToArray(_ref, 2),
	        key = _ref2[0],
	        direction = _ref2[1];

	    return key + ' ' + (direction > 0 ? 'asc' : 'desc');
	  }).join(',').value();
	}

	function translateParams(dataSource, params) {
	  return _underscore2.default.chain(params).omit('skip', 'take', 'filter', 'orderby').extend(_underscore2.default.pick({
	    $skip: params.skip,
	    $top: params.take,
	    $filter: params.filter,
	    $orderby: translateOrderBy(dataSource, params.orderby),
	    $count: true
	  }, Boolean)).value();
	}

	/**
	 * Data source from an OData service.
	 * @class ODataDataSource
	 * @param {string} url
	 *    The root URL of the OData entity set.
	 * @param {string} primaryKey
	 *    The primary key of the entity set.
	 */

	var ODataDataSource = exports.ODataDataSource = function (_DataSource) {
	  _inherits(ODataDataSource, _DataSource);

	  function ODataDataSource(url, primaryKey) {
	    _classCallCheck(this, ODataDataSource);

	    var _this = _possibleConstructorReturn(this, (ODataDataSource.__proto__ || Object.getPrototypeOf(ODataDataSource)).call(this, primaryKey));

	    _this._url = url;
	    return _this;
	  }

	  _createClass(ODataDataSource, [{
	    key: 'query',
	    value: function query(params) {
	      var _this2 = this;

	      return new _bluebird2.default(function (resolve, reject) {
	        _jquery2.default.getJSON(_this2._url, translateParams(_this2, params)).success(resolve).fail(function (jqXHR, textStatus, errorThrown) {
	          reject(new Error(errorThrown));
	        });
	      }).then(function (data) {
	        return {
	          items: data.value || [],
	          totalCount: data['@odata.count'] || 0
	        };
	      });
	    }
	  }, {
	    key: 'url',
	    get: function get() {
	      return this._url;
	    }
	  }]);

	  return ODataDataSource;
	}(_base.DataSource);

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.JSDataDataSource = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

	var _underscore = __webpack_require__(3);

	var _underscore2 = _interopRequireDefault(_underscore);

	var _base = __webpack_require__(65);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	function translateOrderBy(dataSource, orderByParams) {
	  var orderBy = _underscore2.default.chain(dataSource.normalizeOrderBy(orderByParams)).map(function (_ref) {
	    var _ref2 = _slicedToArray(_ref, 2),
	        key = _ref2[0],
	        direction = _ref2[1];

	    return [key, direction > 0 ? 'ASC' : 'DESC'];
	  }).value();

	  return _underscore2.default.isEmpty(orderBy) ? null : orderBy;
	}

	function translateParams(dataSource, params) {
	  return _underscore2.default.chain(params).omit('skip', 'take', 'filter', 'orderby').extend(_underscore2.default.pick({
	    offset: params.skip,
	    limit: params.take,
	    where: params.filter,
	    orderBy: translateOrderBy(dataSource, params.orderby)
	  }, Boolean)).value();
	}

	/**
	 * Data source from a JSData resource
	 * @class JSDataDataSource
	 * @param {JSDataResource} resource
	 *    The JSData resource representing the entity set.
	 * @param {Object} options
	 *    The query options. You can use it add JSData life cycle hooks.
	 */

	var JSDataDataSource = exports.JSDataDataSource = function (_DataSource) {
	  _inherits(JSDataDataSource, _DataSource);

	  function JSDataDataSource(resource) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	    _classCallCheck(this, JSDataDataSource);

	    var _this = _possibleConstructorReturn(this, (JSDataDataSource.__proto__ || Object.getPrototypeOf(JSDataDataSource)).call(this, resource.idAttribute));

	    _this._resource = resource;
	    _this._options = options;
	    return _this;
	  }

	  _createClass(JSDataDataSource, [{
	    key: 'query',
	    value: function query(params) {
	      var options = _underscore2.default.defaults({}, params.options, this._options);

	      return this._resource.findAll(translateParams(this, _underscore2.default.omit(params, 'options')), options).then(function (data) {
	        return {
	          items: data.slice(),
	          totalCount: data.totalCount || 0
	        };
	      });
	    }
	  }, {
	    key: 'resource',
	    get: function get() {
	      return this._resource;
	    }
	  }]);

	  return JSDataDataSource;
	}(_base.DataSource);

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MemoryDataSource = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _underscore = __webpack_require__(3);

	var _underscore2 = _interopRequireDefault(_underscore);

	var _base = __webpack_require__(65);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var truthy = _underscore2.default.constant(true);

	/**
	 * Data source from an in-memory array.
	 * @class MemoryDataSource
	 * @param {Object[]} data
	 *    The in-memory array for the data set.
	 * @param {string} primaryKey
	 *    The primary key of the data set.
	 */

	var MemoryDataSource = exports.MemoryDataSource = function (_DataSource) {
	  _inherits(MemoryDataSource, _DataSource);

	  function MemoryDataSource(data, primaryKey) {
	    _classCallCheck(this, MemoryDataSource);

	    var _this = _possibleConstructorReturn(this, (MemoryDataSource.__proto__ || Object.getPrototypeOf(MemoryDataSource)).call(this, primaryKey));

	    _this.data = data;

	    // This caches the query result without skip and take
	    _this._cache = {
	      seed: _this.data,
	      query: null,
	      data: _this.data
	    };
	    return _this;
	  }

	  /**
	   * The cached items respecting the sorting and filtering,
	   * ignoring the skip and take.
	   * @type {Object[]}
	   */


	  _createClass(MemoryDataSource, [{
	    key: 'query',
	    value: function query(params) {
	      var _ref = params || {},
	          _ref$skip = _ref.skip,
	          skip = _ref$skip === undefined ? 0 : _ref$skip,
	          _ref$take = _ref.take,
	          take = _ref$take === undefined ? this.data.length - skip : _ref$take,
	          _ref$filter = _ref.filter,
	          filter = _ref$filter === undefined ? truthy : _ref$filter,
	          _ref$orderby = _ref.orderby,
	          orderby = _ref$orderby === undefined ? [] : _ref$orderby;

	      if (this._cache.seed !== this.data || !_underscore2.default.isEqual(this._cache.query, { filter: filter, orderby: orderby })) {
	        var _ref2 = _underscore2.default.first(orderby) || {},
	            key = _ref2.key,
	            direction = _ref2.direction;

	        var sortIteratee = null;

	        if (_underscore2.default.isFunction(key)) {
	          sortIteratee = key;
	        } else if (_underscore2.default.isString(key)) {
	          var segs = key.split(/[\.\/]/);
	          sortIteratee = function sortIteratee(item) {
	            return _underscore2.default.reduce(segs, function (memo, seg) {
	              return _underscore2.default.result(memo, seg);
	            }, item);
	          };
	        }

	        var data = _underscore2.default.filter(this.data, filter);

	        if (sortIteratee) {
	          data = _underscore2.default.sortBy(data, sortIteratee);

	          if (direction < 0) {
	            data.reverse();
	          }
	        }

	        this._cache = {
	          seed: this.data,
	          query: { filter: filter, orderby: orderby },
	          data: data
	        };
	      }

	      return {
	        totalCount: this._cache.data.length,
	        items: this._cache.data.slice(skip, skip + take)
	      };
	    }
	  }, {
	    key: 'cachedItems',
	    get: function get() {
	      return this._cache.data;
	    }
	  }]);

	  return MemoryDataSource;
	}(_base.DataSource);

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _underscore = __webpack_require__(3);

	var _underscore2 = _interopRequireDefault(_underscore);

	var _gridView = __webpack_require__(70);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var CONSTRUCTOR_OPTIONS = ['el', 'scrolling', 'tableClasses', 'tableAttributes'];
	var NONE_PROJECTION_OPTIONS = CONSTRUCTOR_OPTIONS.concat(['plugins']);

	/**
	 * @typedef GridViewConfig
	 * @type {Object}
	 * @property {string} name
	 *    Name of the grid
	 * @property {string|HTMLElement|jQuery} el
	 *    The root element of the grid view.
	 * @property {ScrollingConfig} scrolling
	 *    The scrolling behavior configuratoin.
	 * @property {strings[]} tableClasses
	 *    An array of classes to be applied to `TABLE` elements.
	 * @property {object} tableAttributes
	 *    An object of attributes to be applied to `TABLE` elements.
	 * @property {Object.<string,Object>} plugins
	 *    The plugin configurations. The keys are the plugin names, and the values
	 *    are the configuation objects.
	 * @property {RowsConfig} rows
	 *    The structure of the head/body/foot rows.
	 * @property {ColumnConfig[]} columns
	 *    Array of the columns configurations.
	 * @property {DataSourceConfig} dataSource
	 *    The data source configurations. Tells the grid how to fetch data.
	 * @property {QueryConfig} query
	 *    The query parameters for data fetch.
	 * @property {SelectionConfig} selection
	 *    Config the behavior for row selection.
	 * @property {SortableHeaderConfig} sortableHeader
	 *    Config the state and visual of the click-to-sort column headers.
	 * @property {external:BackboneViewEventHash} events
	 *    Customized event hash in form of `Backbone.View#events`.
	 *    It can be set to handle
	 *    * The DOM events inside the `GridView`.
	 *    * The `GridView` events, e.g. {@link GridView#willUpdate},
	 *      {@link GridView#didUpdate}.
	 */

	exports.default = function (definePlugin) {
	  return definePlugin('gridView', ['config', 'dataSource'], function (config, dataSource) {
	    var options = _underscore2.default.chain(config).pick(CONSTRUCTOR_OPTIONS).extend({ dataSource: dataSource }).value();
	    var gridView = new _gridView.GridView(options);

	    gridView.set(_underscore2.default.omit(config, NONE_PROJECTION_OPTIONS));

	    return gridView;
	  });
	};

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GridView = undefined;

	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _underscore = __webpack_require__(3);

	var _underscore2 = _interopRequireDefault(_underscore);

	var _jquery = __webpack_require__(7);

	var _jquery2 = _interopRequireDefault(_jquery);

	var _backbone = __webpack_require__(8);

	var _backbone2 = _interopRequireDefault(_backbone);

	var _bluebird = __webpack_require__(33);

	var _bluebird2 = _interopRequireDefault(_bluebird);

	var _projection = __webpack_require__(71);

	var _layout = __webpack_require__(91);

	var _dataSource = __webpack_require__(64);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function defaultsDeep(dest, src) {
	  if (_underscore2.default.isObject(dest) && !_underscore2.default.isArray(dest)) {
	    _underscore2.default.defaults(dest, src);
	    _underscore2.default.each(src, function (value, key) {
	      if (dest[key] !== value) {
	        defaultsDeep(dest[key], value);
	      }
	    });
	  }
	  return dest;
	}

	function nextTick() {
	  return new _bluebird2.default(function (resolve) {
	    return window.setTimeout(resolve, 0);
	  });
	}

	var ProjectionChain = function () {
	  function ProjectionChain(model) {
	    _classCallCheck(this, ProjectionChain);

	    this.model = model;
	    this.projections = [];
	    this.state = null;
	    this.input = null;
	  }

	  /*
	   * When updating, execute each function in projections successively
	   */


	  _createClass(ProjectionChain, [{
	    key: 'update',
	    value: function update(input, changes) {
	      var _this = this;

	      var force = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

	      var updated = force || input !== this.input;

	      this.input = input;

	      return _underscore2.default.reduce(this.projections, function (_ref, proj) {
	        var updated = _ref.updated,
	            p$state = _ref.p$state;
	        var name = proj.name,
	            handler = proj.handler,
	            p$output = proj.p$output;

	        var result = {};

	        if (updated || !p$output || _underscore2.default.has(changes, name)) {
	          result.updated = true;
	          result.p$state = proj.p$output = p$state.then(function (state) {
	            return handler(state, _this.model.get(name), _this.model.attributes);
	          });
	        } else {
	          result.updated = false;
	          result.p$state = p$output;
	        }

	        return result;
	      }, {
	        updated: updated,
	        p$state: _bluebird2.default.resolve(input)
	      }).p$state.tap(function (state) {
	        _this.state = state;
	      });
	    }

	    /*
	     * Add projection functions to model.projections
	     */

	  }, {
	    key: 'pipe',
	    value: function pipe() {
	      var _this2 = this;

	      for (var _len = arguments.length, projs = Array(_len), _key = 0; _key < _len; _key++) {
	        projs[_key] = arguments[_key];
	      }

	      _underscore2.default.chain(projs).flatten().each(function (proj) {
	        var config = _this2.model.get(proj.name) || proj.defaults;

	        _this2.projections.push(proj);
	        _this2.model.set(proj.name, proj.normalize(config));
	      }).value();
	      return this;
	    }
	  }]);

	  return ProjectionChain;
	}();

	/**
	 * Class of a projection grid view
	 * @class GridView
	 * @extends Backbone.View
	 * @param {Object} options
	 *    The constructor options.
	 * @param {string[]} [options.tableClasses=[]]
	 * @param {object} [options.tableAttributes={aria-label: 'table'}]
	 *    The classes for the TABLE elements (content table and sticky/fixed header)
	 * @param {ScrollingConfig} [options.scrolling={virtualized: false, header: 'static'}]
	 *    The scrolling related configurations
	 */


	var GridView = exports.GridView = function (_Backbone$View) {
	  _inherits(GridView, _Backbone$View);

	  function GridView() {
	    _classCallCheck(this, GridView);

	    return _possibleConstructorReturn(this, (GridView.__proto__ || Object.getPrototypeOf(GridView)).apply(this, arguments));
	  }

	  _createClass(GridView, [{
	    key: 'initialize',
	    value: function initialize(_ref2) {
	      var _this4 = this;

	      var scrolling = _ref2.scrolling,
	          tableClasses = _ref2.tableClasses,
	          tableAttributes = _ref2.tableAttributes,
	          dataSource = _ref2.dataSource;

	      this._tableView = new _layout.TableView({
	        el: this.$el,
	        scrolling: scrolling,
	        classes: tableClasses,
	        attributes: tableAttributes
	      });
	      this.model = new _backbone2.default.Model();

	      this._dataSource = dataSource;

	      var projections = this._projections = {};

	      this._registerProjection = function (proj) {
	        var name = proj.name;

	        if (_underscore2.default.has(projections, ['name'])) {
	          throw new Error('Duplication projectons');
	        }

	        /**
	         * @callback ProjectionHandler
	         * @param {DataChainState|StructureChainState|ContentChainState} state
	         *    The input state.
	         * @param {Object} config
	         *    The projection configuration object.
	         * @return {DataChainState|StructureChainState|ContentChainState|Promise}
	         *    The output state or the `Promise` of the output state.
	         */

	        /**
	         * @typedef ProjectionDefinition
	         * @type {Object}
	         * @property {string} name - name of the projection
	         * @property {ProjectionHandler} handler
	         *    The callback to transform the state
	         * @property {Object} defaults
	         *    The default configuration of the projection
	         * @property {function} normalize
	         *    The callback to normalize the projection configurations.
	         */
	        projections[name] = {
	          name: name,
	          handler: (_underscore2.default.isFunction(proj) ? proj : proj.handler).bind(_this4),
	          defaults: proj.defaults,
	          normalize: (proj.normalize || _underscore2.default.identity).bind(_this4)
	        };

	        return projections[name];
	      };

	      /**
	       * @typedef DataChainState
	       * @type {Object}
	       * @property {string} uniqueId
	       *    The unique id for the set of data items. It changes each time new
	       *    query is made to the server.
	       * @property {string} primaryKey
	       *    The primary key of the data items.
	       * @property {(Object[]|FakeArray)} items
	       *    An array or a fake array of data items.
	       * @property {number} totalCount
	       *    The total item count on the server.
	       * @property {Object.<string, Object>} itemIndex
	       *    The items indexed by primary key.
	       * @property {external:BackboneViewEventHash} events
	       *    The event has in form of `Backbone.View#events`. Any projection can
	       *    response to the DOM events by adding its own event handlers.
	       */
	      this._chainData = new ProjectionChain(this.model);

	      /**
	       * It extends the {@link DataChainState} with extra properties.
	       * @typedef StructureChainState
	       * @type {DataChainState}
	       * @property {ColumnConfig[]} columns
	       *    The array of column configurations.
	       * @property {RowConfig[]} headRows
	       *    The row configurations for `THEAD`.
	       * @property {RowConfig[]} bodyRows
	       *    The row configurations for `TBODY`.
	       * @property {RowConfig[]} footRows
	       *    The row configurations for `TFOOT`.
	       */
	      this._chainStructure = new ProjectionChain(this.model);

	      /**
	       * It extends the {@link StructureChainState} with extra properties, and
	       * overrides some of the properties.
	       * @typedef ContentChainState
	       * @type {StructureChainState}
	       * @property {ColumnGroup} columnGroup
	       *    The column group object, represents the compiled column hierarchy.
	       * @property {ColContent[]} cols
	       *    The content for `COL` elements in `COLGROUP`.
	       * @property {RowContent} headRows
	       *    The content for rows in `THEAD`.
	       * @property {RowContent} bodyRows
	       *    The content for rows in `TBODY`.
	       * @property {RowContent} footRows
	       *    The content for rows in `TFOOT`.
	       */
	      this._chainContent = new ProjectionChain(this.model);

	      this.pipeDataProjections(_projection.query, _projection.buffer, _projection.itemIndex);
	      this.pipeStructureProjections([_projection.columns, _projection.rows, _projection.selection, _projection.rangeSelection]);
	      this.pipeContentProjections([_projection.columnGroup, _projection.cells, _projection.sortableHeader, _projection.events]);

	      var patchEvents = function patchEvents(state) {
	        return _underscore2.default.extend(state, {
	          events: _underscore2.default.mapObject(state.events, function (handler) {
	            return handler.bind(_this4);
	          })
	        });
	      };
	      var refreshState = {
	        changes: null,
	        force: false,
	        promise: null
	      };

	      this._isRendered = false;
	      /**
	       * Refresh the GridView
	       * @function refresh
	       * @memberof GridView
	       * @instance
	       * @param {boolean} [force=false]
	       *    True for force refresh ignoring the cached states.
	       */
	      var refresh = function refresh() {
	        var changes = refreshState.changes;
	        var force = refreshState.force;

	        refreshState.changes = null;
	        refreshState.force = false;

	        /**
	         * The `GridView` will update its configuration and redraw.
	         * @event GridView#willUpdate
	         */
	        _this4.trigger('willUpdate', changes);

	        // Don't refresh before the view is rendered
	        if (!_this4._isRendered) {
	          _this4.trigger('didUpdate', changes);
	          return _bluebird2.default.resolve();
	        }

	        return _underscore2.default.reduce([_this4._chainData, _this4._chainStructure, _this4._chainContent], function (memo, chain) {
	          return chain.update(memo, changes, force);
	        }, null).then(patchEvents).then(function (state) {
	          return new _bluebird2.default(function (resolve) {
	            _this4._tableView.set(state, resolve);
	          });
	        }).then(nextTick).catch(function (error) {
	          if (error) {
	            console.warn(error.stack || error);
	          }
	        }).finally(function () {
	          /**
	           * The `GridView` did update its configuration and redraw.
	           * @event GridView#didUpdate
	           */
	          refreshState.promise = null;
	          _this4.trigger('didUpdate', changes);
	        });
	      };

	      var scheduleUpdate = this.refresh = function (force) {
	        refreshState.force = force || refreshState.force;
	        if (refreshState.changes) {
	          _underscore2.default.extend(refreshState.changes, _this4.model.changedAttributes());
	        } else {
	          refreshState.changes = _this4.model.changedAttributes();

	          if (refreshState.promise) {
	            refreshState.promise = refreshState.promise.then(function () {
	              return refresh();
	            }).finally();
	          } else {
	            refreshState.promise = nextTick().then(function () {
	              return refresh();
	            });
	          }
	        }
	      };

	      this.model.on('change', function () {
	        return scheduleUpdate(false);
	      });

	      _underscore2.default.each([
	      /**
	       * The `GridView` will redraw the DOM. This event may trigger frequently
	       * when virtualization is enabled.
	       * @event GridView#willRedraw
	       */
	      'willRedraw',

	      /**
	       * The `GridView` did redraw the DOM. This event may trigger frequently
	       * when virtualization is enabled.
	       * @event GridView#didRedraw
	       */
	      'didRedraw'], function (event) {
	        _this4._tableView.on(event, function () {
	          for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	            args[_key2] = arguments[_key2];
	          }

	          _this4.trigger.apply(_this4, [event].concat(args));
	        });
	      });

	      this.on('all', function (event) {
	        for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	          args[_key3 - 1] = arguments[_key3];
	        }

	        var events = _underscore2.default.chain(_this4._chainContent).result('state').result('events').value();
	        var handler = events && events[event];

	        if (_underscore2.default.isFunction(handler)) {
	          handler.apply(undefined, args);
	        }
	      });
	    }

	    /**
	     * Pipe a projection to procceed the grid data
	     * @param {...ProjectionDefinition} projs - A list of projection definitions
	     * @return {GridView} - This grid view
	     */

	  }, {
	    key: 'pipeDataProjections',
	    value: function pipeDataProjections() {
	      for (var _len4 = arguments.length, projs = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	        projs[_key4] = arguments[_key4];
	      }

	      this._chainData.pipe(_underscore2.default.map(_underscore2.default.flatten(projs), this._registerProjection));
	      return this;
	    }

	    /**
	     * Pipe a projection to procceed the grid structure
	     * @param {...ProjectionDefinition} projs - A list of projection definitions
	     * @return {GridView} - This grid view
	     */

	  }, {
	    key: 'pipeStructureProjections',
	    value: function pipeStructureProjections() {
	      for (var _len5 = arguments.length, projs = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	        projs[_key5] = arguments[_key5];
	      }

	      this._chainStructure.pipe(_underscore2.default.map(_underscore2.default.flatten(projs), this._registerProjection));
	      return this;
	    }

	    /**
	     * Pipe a projection to procceed the grid visual content
	     * @param {...ProjectionDefinition} projs - A list of projection definitions
	     * @return {GridView} - This grid view
	     */

	  }, {
	    key: 'pipeContentProjections',
	    value: function pipeContentProjections() {
	      for (var _len6 = arguments.length, projs = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
	        projs[_key6] = arguments[_key6];
	      }

	      this._chainContent.pipe(_underscore2.default.map(_underscore2.default.flatten(projs), this._registerProjection));
	      return this;
	    }

	    /**
	     * Change the grid(projection) configuratons
	     * @param {Object.<string, Object>} config
	     *    A hash of configurations to change. The keys are projection names while
	     *    the values are the projection configurations
	     * @param {function} [callback]
	     *    A callback to notify the update is completed
	     * @return {GridView}
	     *    This grid view.
	     */

	  }, {
	    key: 'set',
	    value: function set() {
	      var _this5 = this;

	      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _underscore2.default.noop;

	      // backward compatibility
	      if (_underscore2.default.has(config, 'dataSource') && !(config.dataSource instanceof _dataSource.DataSource)) {
	        var dataSource = config.dataSource;

	        config.query = _underscore2.default.defaults({}, config.query, _underscore2.default.pick(dataSource, ['skip', 'take', 'orderby', 'filter', 'options', 'query']));

	        if (dataSource.type === 'memory' && dataSource.data !== this._dataSource.data) {
	          this._dataSource.data = dataSource.data;
	          this.refresh(true);
	        }
	        delete config.dataSource;
	      }

	      this.model.set(_underscore2.default.mapObject(config, function (value, key) {
	        var projection = _this5._projections[key];

	        return projection ? projection.normalize(value) : value;
	      }));
	      this.once('didUpdate', callback);
	      return this;
	    }

	    /**
	     * Read the grid(projection)_configuration
	     * @param {string} name - name of the projection
	     * @return {object}
	     */

	  }, {
	    key: 'get',
	    value: function get(name) {
	      // backward compatibility
	      if (name === 'dataSource') {
	        var result = _underscore2.default.defaults({}, this.model.get('dataSource'), this.model.get('query'));

	        if (this._dataSource instanceof _dataSource.MemoryDataSource) {
	          result.type = 'memory';
	          result.data = this._dataSource.data;
	        } else if (this._dataSource instanceof _dataSource.JSDataDataSource) {
	          result.type = 'js-data';
	          result.entity = this._dataSource.resource;
	        } else if (this._dataSource instanceof _dataSource.ODataDataSource) {
	          result.type = 'odata';
	          result.url = this._dataSource.url;
	        }

	        return result;
	      }
	      return this.model.get(name);
	    }

	    /**
	     * Patch the grid(projection) configurations.
	     * It's similar to {@link GridView#set}, but instead of replacing the
	     * projection configurations, `patch` do deep object merge.
	     * @param {Object.<string, Object>} config
	     *    A hash of configurations to change. The keys are projection names
	     *    while the values are the projection configurations
	     * @param {function} callback
	     *    A callback to notify the update is completed
	     * @return {GridView}
	     *    This grid view.
	     */

	  }, {
	    key: 'patch',
	    value: function patch() {
	      var _this6 = this;

	      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _underscore2.default.noop;

	      this.set(_underscore2.default.reduce(_underscore2.default.keys(state), function (memo, key) {
	        var value = state[key];
	        var valueCur = _this6.get(key);

	        memo[key] = defaultsDeep(value, valueCur);
	        return memo;
	      }, {}), callback);
	    }

	    /**
	     * Render the grid view.
	     * @param {function} [callback]
	     *    A callback to notify the render is completed.
	     * @return {GridView}
	     *    This grid view.
	     */

	  }, {
	    key: 'render',
	    value: function render(callback) {
	      var _this7 = this;

	      this._tableView.render(function () {
	        _this7._isRendered = true;
	        _this7.refresh(true);
	        _this7.once('didRedraw', callback);
	      });
	      return this;
	    }

	    /**
	     * Destroy and detach the view from DOM.
	     */

	  }, {
	    key: 'remove',
	    value: function remove() {
	      this._tableView.remove();
	      _get(GridView.prototype.__proto__ || Object.getPrototypeOf(GridView.prototype), 'remove', this).call(this);
	    }

	    /* Helper functions */

	    /**
	     * The data source of the grid
	     * @type {DataSource}
	     */

	  }, {
	    key: 'query',


	    /**
	     * Make query to the data source
	     * @param {object} params - The query parameters
	     * @return {QueryResult}
	     */
	    value: function query(params) {
	      return this._dataSource.query(params);
	    }

	    /**
	     * The array data items.
	     * @type {Object[]}
	     */

	  }, {
	    key: 'getItemCount',


	    // Backward compatibility
	    value: function getItemCount() {
	      return this.totalCountRows;
	    }

	    /**
	     * Query the data item with its primary key.
	     * @param {string} key - the primary key.
	     * @return {Object}
	     */

	  }, {
	    key: 'itemWithKey',
	    value: function itemWithKey(key) {
	      return _underscore2.default.chain(this._chainData.state).result('itemIndex').result(key, null).value();
	    }

	    /**
	     * Get the primary key from a DOM element in a certain row.
	     * @param {HTMLElement|jQuery|string} el
	     *    The DOM element. It can be an `HTMLElement`, a jQuery object or a
	     *    jQuery selector.
	     * @return {string} - The primary key for the row.
	     */

	  }, {
	    key: 'keyOfElement',
	    value: function keyOfElement(el) {
	      var $tr = (0, _jquery2.default)(el).closest('tr', this.$el);

	      if ($tr.length > 0) {
	        return $tr.attr('data-key') || null;
	      }

	      return null;
	    }

	    /**
	     * Get the data item from a DOM element in a certain row.
	     * @param {HTMLElement|jQuery|string} el
	     *    The DOM element. It can be an `HTMLElement`, a jQuery object or a
	     *    jQuery selector.
	     * @return {Object}
	     */

	  }, {
	    key: 'itemOfElement',
	    value: function itemOfElement(el) {
	      return this.itemWithKey(this.keyOfElement(el));
	    }

	    /**
	     * Get the data item with its index in the items array.
	     * @param {number} index - The index of the item.
	     * @return {Object}
	     */

	  }, {
	    key: 'itemAt',
	    value: function itemAt(index) {
	      return _underscore2.default.result(this._chainData.state, 'items', []).slice(index, index + 1)[0];
	    }

	    /**
	     * Given an element in the data rows, get the index of the corresponding
	     * data item.
	     *
	     * __NOTE__: It's not recommended to use this API to find the data item for
	     * a given element. It could be incorrect if there're custom projections
	     * changes the TR sequence of TBODY. Insteadly, you should use
	     * {@link GridView#keyOfElement}.
	     *
	     * @param {HTMLElement|jQuery|string} el
	     *    The DOM element. It can be an `HTMLElement`, a jQuery object or a
	     *    jQuery selector.
	     * @return {number} - The index of the data row.
	     */

	  }, {
	    key: 'indexOfElement',
	    value: function indexOfElement(el) {
	      return this._tableView.indexOfElement(el);
	    }

	    /**
	     * Get the primary keys of the selected items.
	     * @return {string[]} - An array of the selected keys.
	     */

	  }, {
	    key: 'selectedKeys',
	    value: function selectedKeys() {
	      return _underscore2.default.result(this.get('selection'), 'selected', []);
	    }

	    /**
	     * Get the selected items.
	     * @return {Object[]} - An array of the selected data items.
	     */

	  }, {
	    key: 'selectedItems',
	    value: function selectedItems() {
	      var itemIndex = _underscore2.default.result(this._chainData.state, 'itemIndex', {});

	      return _underscore2.default.chain(this.selectedKeys()).map(function (key) {
	        return _underscore2.default.result(itemIndex, key);
	      }).compact().value();
	    }

	    /**
	     * Select a row with the given primary key.
	     * @param {string} key - The primary key for the row.
	     */

	  }, {
	    key: 'selectRow',
	    value: function selectRow(key) {
	      (0, _projection.setSelectRow)(this, key, true);
	    }

	    /**
	     * Deselect a row with the given primary key.
	     * @param {string} key - The primary key for the row.
	     */

	  }, {
	    key: 'deselectRow',
	    value: function deselectRow(key) {
	      (0, _projection.setSelectRow)(this, key, false);
	    }

	    /**
	     * Select all the selectable items.
	     */

	  }, {
	    key: 'selectAll',
	    value: function selectAll() {
	      (0, _projection.setSelectAll)(this, true);
	    }

	    /**
	     * Deselect all the selectable items.
	     */

	  }, {
	    key: 'deselectAll',
	    value: function deselectAll() {
	      (0, _projection.setSelectAll)(this, false);
	    }

	    /**
	     * Get the finalized column configuration with a given column name.
	     * @param {string} name - The name of the column.
	     * @return {ExtendedColumnConfig}
	     */

	  }, {
	    key: 'columnWithName',
	    value: function columnWithName(name) {
	      var columnGroup = _underscore2.default.result(this._chainContent.state, 'columnGroup');
	      return columnGroup ? columnGroup.columnWithName(name) : null;
	    }

	    /**
	     * Get the row configurations for `THEAD`
	     * @return {RowConfig[]}
	     */

	  }, {
	    key: 'getHeadRows',
	    value: function getHeadRows() {
	      return _underscore2.default.result(this.get('rows'), 'headRows', ['column-header-rows']);
	    }

	    /**
	     * @callback SetRowsCallback
	     * @param {RowConfig[]} rows - The current row configurations.
	     * @return {RowConfig[]} - The new row configurations.
	     */

	    /**
	     * Set the row configurations for `THEAD`
	     * @param {RowConfig[]|SetRowsCallback} value
	     *    The new header rows or a function to transform the header rows.
	     */

	  }, {
	    key: 'setHeadRows',
	    value: function setHeadRows(value) {
	      var headRows = _underscore2.default.isFunction(value) ? value(this.getHeadRows()) : value;
	      this.patch({ rows: { headRows: headRows } });
	    }

	    /**
	     * Prepend a set header rows
	     * @param {RowConfig[]} rows - The rows to prepend
	     */

	  }, {
	    key: 'prependHeadRows',
	    value: function prependHeadRows(rows) {
	      this.setHeadRows(function (headRows) {
	        return rows.concat(headRows);
	      });
	    }

	    /**
	     * Append a set header rows
	     * @param {RowConfig[]} rows - The rows to append
	     */

	  }, {
	    key: 'appendHeadRows',
	    value: function appendHeadRows(rows) {
	      this.setHeadRows(function (headRows) {
	        return headRows.concat(rows);
	      });
	    }

	    /**
	     * Get the row configurations for `TBODY`
	     * @return {RowConfig[]}
	     */

	  }, {
	    key: 'getBodyRows',
	    value: function getBodyRows() {
	      return _underscore2.default.result(this.get('rows'), 'bodyRows', ['data-rows']);
	    }

	    /**
	     * Set the row configurations for `TBODY`
	     * @param {RowConfig[]|SetRowsCallback} value
	     *    The new body rows or a function to transform the body rows.
	     */

	  }, {
	    key: 'setBodyRows',
	    value: function setBodyRows(value) {
	      var bodyRows = _underscore2.default.isFunction(value) ? value(this.getBodyRows()) : value;
	      this.patch({ rows: { bodyRows: bodyRows } });
	    }

	    /**
	     * Prepend a set body rows
	     * @param {RowConfig[]} rows - The rows to prepend
	     */

	  }, {
	    key: 'prependBodyRows',
	    value: function prependBodyRows(rows) {
	      this.setBodyRows(function (bodyRows) {
	        return rows.concat(bodyRows);
	      });
	    }

	    /**
	     * Append a set body rows
	     * @param {RowConfig[]} rows - The rows to append
	     */

	  }, {
	    key: 'appendBodyRows',
	    value: function appendBodyRows(rows) {
	      this.setBodyRows(function (bodyRows) {
	        return bodyRows.concat(rows);
	      });
	    }

	    /**
	     * Get the row configurations for `TFOOT`
	     * @return {RowConfig[]}
	     */

	  }, {
	    key: 'getFootRows',
	    value: function getFootRows() {
	      return _underscore2.default.result(this.get('rows'), 'footRows', []);
	    }

	    /**
	     * Set the row configurations for `TFOOT`
	     * @param {RowConfig[]|SetRowsCallback} value
	     *    The new footer rows or a function to transform the footer rows.
	     */

	  }, {
	    key: 'setFootRows',
	    value: function setFootRows(value) {
	      var footRows = _underscore2.default.isFunction(value) ? value(this.getFootRows()) : value;
	      this.patch({ rows: { footRows: footRows } });
	    }

	    /**
	     * Prepend a set footer rows
	     * @param {RowConfig[]} rows - The rows to prepend
	     */

	  }, {
	    key: 'prependFootRows',
	    value: function prependFootRows(rows) {
	      this.setFootRows(function (footRows) {
	        return rows.concat(footRows);
	      });
	    }

	    /**
	     * Append a set footer rows
	     * @param {RowConfig[]} rows - The rows to append
	     */

	  }, {
	    key: 'appendFootRows',
	    value: function appendFootRows(rows) {
	      this.setFootRows(function (footRows) {
	        return footRows.concat(rows);
	      });
	    }

	    /**
	     * Monitor the viewport change during a certain period and adjust the sticky
	     * headers if necessary.
	     * @param {number} [timeout=1000]
	     *    The period of monitoring in milliseconds
	     * @param {number} [interval=100]
	     *    The interval of sampling in milliseconds
	     */

	  }, {
	    key: 'monitorViewportChange',
	    value: function monitorViewportChange() {
	      var _this8 = this;

	      var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;
	      var interval = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

	      var rect = this.el.getBoundingClientRect();
	      var keys = ['left', 'top', 'width', 'height'];
	      var id = window.setInterval(function () {
	        var rectNew = _this8.el.getBoundingClientRect();

	        if (_underscore2.default.some(keys, function (key) {
	          return Math.abs(rectNew[key] - rect[key]) > 0.5;
	        })) {
	          _this8._tableView.trigger('didChangeBound');
	        }
	      }, interval);

	      window.setTimeout(function () {
	        return window.clearInterval(id);
	      }, timeout);
	    }
	  }, {
	    key: 'dataSource',
	    get: function get() {
	      return this._dataSource;
	    }

	    /**
	     * A object implements a minimal interface of array to lazy fetch items.
	     * We use this structure a lot in projections, so that we don't need to
	     * procceed all the rows when virtualization is on.
	     * @typedef FakeArray
	     * @type {Object}
	     * @property {function} slice
	     *    a callback to get a slice of the items. It has the same signature as
	     *    `Array.slice()`.
	     * @property {number} length
	     *    length of the array
	     */

	    /**
	     * The data items. It's a fake array of original model.
	     * @type {(Object[]|FakeArray)}
	     */

	  }, {
	    key: 'items',
	    get: function get() {
	      return _underscore2.default.result(this._chainData.state, 'items', []);
	    }
	  }, {
	    key: 'itemArray',
	    get: function get() {
	      return this.items.slice();
	    }

	    /**
	     * The count of data rows.
	     * @type {number}
	     */

	  }, {
	    key: 'countRows',
	    get: function get() {
	      return this.items.length;
	    }

	    /**
	     * The primary key of data items.
	     * @type {string}
	     */

	  }, {
	    key: 'primaryKey',
	    get: function get() {
	      return this._dataSource.primaryKey;
	    }

	    /**
	     * The total count of data items. This represents the server side state.
	     * @type {number}
	     */

	  }, {
	    key: 'totalCountRows',
	    get: function get() {
	      return _underscore2.default.result(this._chainData.state, 'totalCount', 0);
	    }
	  }]);

	  return GridView;
	}(_backbone2.default.View);

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _query = __webpack_require__(72);

	Object.defineProperty(exports, 'query', {
	  enumerable: true,
	  get: function get() {
	    return _query.query;
	  }
	});

	var _buffer = __webpack_require__(73);

	Object.defineProperty(exports, 'buffer', {
	  enumerable: true,
	  get: function get() {
	    return _buffer.buffer;
	  }
	});

	var _itemIndex = __webpack_require__(74);

	Object.defineProperty(exports, 'itemIndex', {
	  enumerable: true,
	  get: function get() {
	    return _itemIndex.itemIndex;
	  }
	});

	var _selection = __webpack_require__(75);

	Object.defineProperty(exports, 'selection', {
	  enumerable: true,
	  get: function get() {
	    return _selection.selection;
	  }
	});
	Object.defineProperty(exports, 'setSelectAll', {
	  enumerable: true,
	  get: function get() {
	    return _selection.setSelectAll;
	  }
	});
	Object.defineProperty(exports, 'setSelectRow', {
	  enumerable: true,
	  get: function get() {
	    return _selection.setSelectRow;
	  }
	});

	var _rangeSelection = __webpack_require__(81);

	Object.defineProperty(exports, 'rangeSelection', {
	  enumerable: true,
	  get: function get() {
	    return _rangeSelection.rangeSelection;
	  }
	});

	var _columns = __webpack_require__(82);

	Object.defineProperty(exports, 'columns', {
	  enumerable: true,
	  get: function get() {
	    return _columns.columns;
	  }
	});

	var _rows = __webpack_require__(83);

	Object.defineProperty(exports, 'rows', {
	  enumerable: true,
	  get: function get() {
	    return _rows.rows;
	  }
	});

	var _columnGroup = __webpack_require__(85);

	Object.defineProperty(exports, 'columnGroup', {
	  enumerable: true,
	  get: function get() {
	    return _columnGroup.columnGroup;
	  }
	});

	var _cells = __webpack_require__(87);

	Object.defineProperty(exports, 'cells', {
	  enumerable: true,
	  get: function get() {
	    return _cells.cells;
	  }
	});

	var _sortableHeader = __webpack_require__(88);

	Object.defineProperty(exports, 'sortableHeader', {
	  enumerable: true,
	  get: function get() {
	    return _sortableHeader.sortableHeader;
	  }
	});

	var _events = __webpack_require__(90);

	Object.defineProperty(exports, 'events', {
	  enumerable: true,
	  get: function get() {
	    return _events.events;
	  }
	});

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.query = undefined;

	var _underscore = __webpack_require__(3);

	var _underscore2 = _interopRequireDefault(_underscore);

	var _bluebird = __webpack_require__(33);

	var _bluebird2 = _interopRequireDefault(_bluebird);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/**
	 * The data source configurations.
	 * @typedef QueryConfig
	 * @type {Object}
	 * @property {OrderByConfig} orderby
	 *    The sorting parameter.
	 * @property {Object} filter
	 *    The filter object in MangoDB format.
	 * @property {number} skip
	 *    The number of item to skip from the query result.
	 * @property {number} take
	 *    The number of item to take from the query result.
	 */

	/**
	 * Fetching data from the data source
	 * @param {DataChainState} state
	 * @param {QueryConfig} params
	 *    The data source configurations.
	 * @return {DataChainState}
	 */
	function queryProjectionHandler(state, params) {
	  var _this = this;

	  var primaryKey = this.primaryKey;

	  /**
	   * The `GridView` will reload data from the data source.
	   * @event GridView#willReload
	   */
	  this.trigger('willReload');

	  return _bluebird2.default.resolve(this.query(params)).catch(function (error) {
	    return {
	      totalCount: 0,
	      items: [],
	      error: error || new Error('Failed to load grid data')
	    };
	  }).then(function (_ref) {
	    var totalCount = _ref.totalCount,
	        items = _ref.items,
	        error = _ref.error;

	    /**
	     * The `GridView` did reload data from the data source.
	     * This event take 2 parameters
	     * 1. succeeded (Boolean), true if the data fetch succeeded
	     * 2. data|rejection (Object)
	     *    * If the data fetch succeeded, pass the fetched data in form of
	     *      `{ totalCount, items }`. Where `totalCount` is the server side total
	     *      item count, and the items is the array of data items with current
	     *      query condition
	     *    * If the data fetch failed, pass the rejection object, which is
	     *      usually an `Error` object from the data source
	     * @event GridView#didReload
	     */
	    if (error) {
	      _this.trigger('didReload', false, error);
	    } else {
	      _this.trigger('didReload', true, { totalCount: totalCount, items: items });
	    }

	    return {
	      uniqueId: _underscore2.default.uniqueId('grid-data-'),
	      items: items,
	      primaryKey: primaryKey,
	      totalCount: totalCount
	    };
	  });
	}

	var query = exports.query = {
	  name: 'query',
	  handler: queryProjectionHandler,
	  defaults: {}
	};

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.buffer = undefined;

	var _underscore = __webpack_require__(3);

	var _underscore2 = _interopRequireDefault(_underscore);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function updateItemState(gridView, item, state) {
	  var buffer = gridView.get('buffer');
	  var changed = {};
	  var key = _underscore2.default.result(item, gridView.primaryKey);

	  changed[key] = {
	    item: item,
	    state: state
	  };
	  _underscore2.default.defaults(changed, buffer.changed);

	  gridView.set({
	    buffer: _underscore2.default.defaults({ changed: changed }, buffer)
	  });
	}

	var buffer = exports.buffer = {
	  name: 'buffer',
	  handler: function handler(state, buffer) {
	    var _this = this;

	    var primaryKey = state.primaryKey,
	        uniqueId = state.uniqueId,
	        update = state.update;


	    if (buffer.uniqueId !== uniqueId) {
	      buffer.uniqueId = uniqueId;
	      buffer.changed = {};
	    }

	    var items = {
	      length: state.items.length,
	      slice: function slice() {
	        var begin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	        var end = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : state.items.length;

	        return state.items.slice(begin, end).map(function (item) {
	          var key = item[primaryKey];

	          if (_underscore2.default.has(buffer.changed, key)) {
	            return buffer.changed[key].item;
	          }
	          return item;
	        });
	      }
	    };

	    var onCommit = function onCommit(item) {
	      if (item) {
	        updateItemState(_this, item, 'committed');
	      }
	    };

	    var onEdit = function onEdit(item) {
	      if (item) {
	        updateItemState(_this, item, 'changed');
	        if (_underscore2.default.isFunction(update)) {
	          update(item).then(onCommit);
	        }
	      }
	    };

	    var events = _underscore2.default.defaults({ didEdit: onEdit }, state.events);

	    return _underscore2.default.defaults({ items: items, events: events }, state);
	  },

	  defaults: {}
	};

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.itemIndex = undefined;

	var _underscore = __webpack_require__(3);

	var _underscore2 = _interopRequireDefault(_underscore);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var itemIndex = exports.itemIndex = {
	  name: 'itemIndex',
	  handler: function handler(state) {
	    var items = state.items,
	        primaryKey = state.primaryKey;

	    var itemIndex = {};

	    _underscore2.default.each(items.slice(), function (item) {
	      if (!_underscore2.default.has(item, primaryKey)) {
	        item[primaryKey] = _underscore2.default.uniqueId('grid-item-');
	      }
	      itemIndex[item[primaryKey]] = item;
	    });

	    return _underscore2.default.defaults({ itemIndex: itemIndex }, state);
	  },

	  defaults: {}
	};

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.selection = undefined;
	exports.setSelectAll = setSelectAll;
	exports.setSelectRow = setSelectRow;

	var _underscore = __webpack_require__(3);

	var _underscore2 = _interopRequireDefault(_underscore);

	var _singleSelectionResolver = __webpack_require__(76);

	var _multipleSelectionResolver = __webpack_require__(78);

	var _selectionHead = __webpack_require__(79);

	var _selectionHead2 = _interopRequireDefault(_selectionHead);

	var _selectionBody = __webpack_require__(80);

	var _selectionBody2 = _interopRequireDefault(_selectionBody);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function updateSelection(gridView, selection) {
	  gridView.trigger('willSelect', selection.selected);
	  gridView.set({ selection: selection }, function () {
	    gridView.trigger('didSelect', selection.selected);
	  });
	}

	function setSelectAll(gridView, checked) {
	  var _gridView$get = gridView.get('selection'),
	      resolver = _gridView$get.resolver;

	  var selection = checked ? resolver.selectAll() : resolver.deselectAll();

	  updateSelection(gridView, selection);
	}

	function changeSelectAll(e) {
	  setSelectAll(this, e.target.checked);
	  e.preventDefault();
	}

	function setSelectRow(gridView, key, checked) {
	  var _gridView$get2 = gridView.get('selection'),
	      resolver = _gridView$get2.resolver;

	  var selection = checked ? resolver.selectRow(key) : resolver.deselectRow(key);

	  updateSelection(gridView, selection);
	}

	function changeSelectRow(e) {
	  var key = this.keyOfElement(e.target);

	  setSelectRow(this, key, e.target.checked);
	  e.preventDefault();
	}

	/**
	 * Add selection box to rows
	 * @param {StructureChainState} state
	 *    The input state.
	 * @param {boolean|SelectionConfig} selection
	 *    The selection configuration. It can be
	 *    * A boolean to indicate whether the grid has the selection column.
	 *    * A detailed {@link SelectionConfig} object.
	 */
	function selectionProjectionHandler(state, _ref) {
	  var _this = this;

	  var enabled = _ref.enabled,
	      resolver = _ref.resolver,
	      _ref$a11y = _ref.a11y;
	  _ref$a11y = _ref$a11y === undefined ? {} : _ref$a11y;
	  var _ref$a11y$selectAllLa = _ref$a11y.selectAllLabel,
	      selectAllLabel = _ref$a11y$selectAllLa === undefined ? 'Select All' : _ref$a11y$selectAllLa,
	      _ref$a11y$deselectAll = _ref$a11y.deselectAllLabel,
	      deselectAllLabel = _ref$a11y$deselectAll === undefined ? 'Deselect All' : _ref$a11y$deselectAll,
	      _ref$a11y$selectOneLa = _ref$a11y.selectOneLabel,
	      selectOneLabel = _ref$a11y$selectOneLa === undefined ? null : _ref$a11y$selectOneLa,
	      _ref$a11y$deselectOne = _ref$a11y.deselectOneLabel,
	      deselectOneLabel = _ref$a11y$deselectOne === undefined ? null : _ref$a11y$deselectOne;

	  if (!enabled) {
	    return state;
	  }

	  var _resolver$updateItems = resolver.updateItems(state.items),
	      selected = _resolver$updateItems.selected,
	      single = _resolver$updateItems.single,
	      colClasses = _resolver$updateItems.colClasses,
	      headClasses = _resolver$updateItems.headClasses,
	      bodyClasses = _resolver$updateItems.bodyClasses,
	      footClasses = _resolver$updateItems.footClasses,
	      selectable = _resolver$updateItems.selectable;

	  var selectedIndex = _underscore2.default.reduce(selected, function (memo, key) {
	    memo[key] = true;
	    return memo;
	  }, {});
	  var primaryKey = state.primaryKey;
	  var selectedAll = false;
	  var partSelected = false;

	  /**
	   * Callback to decide whether a row is selectable.
	   * @callback SelectableCallback
	   * @param {Object} item
	   *    The data item of the row.
	   * @return {boolean}
	   */
	  if (!single) {
	    var selectableCount = _underscore2.default.filter(state.items.slice(), selectable).length;
	    var selectedCount = _underscore2.default.filter(selected, function (key) {
	      return selectable(_this.itemWithKey(key));
	    }).length;

	    selectedAll = selectableCount !== 0 && selectedCount === selectableCount;
	    partSelected = selectedCount > 0 && selectedCount < selectableCount;
	  }

	  var columns = [{
	    name: 'selection',
	    html: (0, _selectionHead2.default)({
	      single: single,
	      checked: selectedAll,
	      partSelected: partSelected,
	      checkAllLabel: selectedAll ? deselectAllLabel : selectAllLabel
	    }),
	    template: _selectionBody2.default,
	    property: function property(item) {
	      return {
	        single: single,
	        selectable: selectable(item),
	        checked: selectedIndex[item[primaryKey]],
	        ariaLabel: selectedIndex[item[primaryKey]] ? deselectOneLabel : selectOneLabel,
	        labelbyId: selectOneLabel ? undefined : item[primaryKey]
	      };
	    },
	    sortable: false,
	    isResizable: false,
	    colClasses: colClasses,
	    headClasses: headClasses,
	    bodyClasses: bodyClasses,
	    footClasses: footClasses
	  }].concat(state.columns);

	  var bodyRows = _underscore2.default.map(state.bodyRows, function (row) {
	    if (row && row.type === 'data' && row.item && selectable(row.item)) {
	      var selectedClassArray = selectedIndex[row.item[primaryKey]] ? ['row-selected'] : [];

	      return _underscore2.default.defaults({
	        attributes: {
	          id: row.item[primaryKey]
	        },
	        classes: _underscore2.default.union(selectedClassArray, row.classes)
	      }, _underscore2.default.isObject(row) ? row : {});
	    }

	    return row;
	  });

	  var events = _underscore2.default.defaults({
	    'change th input.select-all': changeSelectAll,
	    'change td input.select-row': changeSelectRow
	  }, state.events);

	  return _underscore2.default.defaults({ columns: columns, events: events, bodyRows: bodyRows }, state);
	}

	/**
	 * Normalize the selection config
	 * @param {boolean|SelectionConfig} selection
	 *    The selection configuration.
	 */
	function normalizeSelectionConfig(selection) {
	  var _this2 = this;

	  if (!selection) {
	    return { enabled: false };
	  }

	  /**
	   * @typedef SelectionConfig
	   * @type {Object}
	   * @property {boolean} enabled
	   *    Whether the selection feature is enabled.
	   * @property {boolean} single
	   *    True if only 1 row can be selected at the same time.
	   * @property {string[]} selected
	   *    The primary key of rows being selected.
	   * @property {SelectableCallback} selectable
	   *    A callback to decide whether a row is selectable.
	   * @property {ClassesConfig} colClasses
	   *    The classes of the 'COL' element for the selection column.
	   * @property {ClassesConfig} headClasses
	   *    The classes of the 'TH' element in 'THEAD' of the selection column.
	   * @property {ClassesConfig} bodyClasses
	   *    The classes of the 'TD' elements in 'TBODY' of the selection column.
	   * @property {ClassesConfig} footClasses
	   *    The classes of the 'TD' elements in 'TFOOT' of the selection column.
	   */
	  var config = _underscore2.default.defaults({}, _underscore2.default.isObject(selection) ? selection : {}, {
	    enabled: true,
	    single: false,
	    selected: [],
	    selectable: function selectable(item) {
	      return _underscore2.default.has(item, _this2.primaryKey);
	    },
	    colClasses: [],
	    headClasses: [],
	    bodyClasses: [],
	    footClasses: []
	  });

	  if (!_underscore2.default.isFunction(config.Resolver)) {
	    config.Resolver = config.single ? _singleSelectionResolver.SingleSelectionResolver : _multipleSelectionResolver.MultipleSelectionResolver;
	  }

	  if (!(config.resolver instanceof config.Resolver)) {
	    config.resolver = new config.Resolver(this);
	  }

	  return config;
	}

	var selection = exports.selection = {
	  name: 'selection',
	  handler: selectionProjectionHandler,
	  normalize: normalizeSelectionConfig,
	  defaults: false
	};

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SingleSelectionResolver = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _selectionResolver = __webpack_require__(77);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var SingleSelectionResolver = exports.SingleSelectionResolver = function (_SelectionResolver) {
	  _inherits(SingleSelectionResolver, _SelectionResolver);

	  function SingleSelectionResolver() {
	    _classCallCheck(this, SingleSelectionResolver);

	    return _possibleConstructorReturn(this, (SingleSelectionResolver.__proto__ || Object.getPrototypeOf(SingleSelectionResolver)).apply(this, arguments));
	  }

	  _createClass(SingleSelectionResolver, [{
	    key: 'selectRow',
	    value: function selectRow(key) {
	      return this.patch({ selected: [key.toString()] });
	    }
	  }]);

	  return SingleSelectionResolver;
	}(_selectionResolver.SelectionResolver);

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SelectionResolver = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _underscore = __webpack_require__(3);

	var _underscore2 = _interopRequireDefault(_underscore);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var SelectionResolver = exports.SelectionResolver = function () {
	  function SelectionResolver(gridView) {
	    _classCallCheck(this, SelectionResolver);

	    this.gridView = gridView;
	  }

	  _createClass(SelectionResolver, [{
	    key: 'updateItems',
	    value: function updateItems() {
	      return this.patch({});
	    }
	  }, {
	    key: 'selectRow',
	    value: function selectRow() {
	      throw new Error('Not Supported');
	    }
	  }, {
	    key: 'deselectRow',
	    value: function deselectRow() {
	      throw new Error('Not Supported');
	    }
	  }, {
	    key: 'selectAll',
	    value: function selectAll() {
	      throw new Error('Not Supported');
	    }
	  }, {
	    key: 'deselectAll',
	    value: function deselectAll() {
	      throw new Error('Not Supported');
	    }
	  }, {
	    key: 'patch',
	    value: function patch(options) {
	      var selectionCur = this.gridView.get('selection');
	      var selection = _underscore2.default.isFunction(options) ? options(selectionCur) : options;

	      return _underscore2.default.defaults(selection, selectionCur);
	    }
	  }]);

	  return SelectionResolver;
	}();

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MultipleSelectionResolver = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _underscore = __webpack_require__(3);

	var _underscore2 = _interopRequireDefault(_underscore);

	var _selectionResolver = __webpack_require__(77);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var MultipleSelectionResolver = exports.MultipleSelectionResolver = function (_SelectionResolver) {
	  _inherits(MultipleSelectionResolver, _SelectionResolver);

	  function MultipleSelectionResolver() {
	    _classCallCheck(this, MultipleSelectionResolver);

	    return _possibleConstructorReturn(this, (MultipleSelectionResolver.__proto__ || Object.getPrototypeOf(MultipleSelectionResolver)).apply(this, arguments));
	  }

	  _createClass(MultipleSelectionResolver, [{
	    key: 'selectRow',
	    value: function selectRow(key) {
	      return this.patch(function (_ref) {
	        var selected = _ref.selected;
	        return {
	          selected: _underscore2.default.union(selected, [key.toString()])
	        };
	      });
	    }
	  }, {
	    key: 'deselectRow',
	    value: function deselectRow(key) {
	      return this.patch(function (_ref2) {
	        var selected = _ref2.selected;
	        return {
	          selected: _underscore2.default.without(selected, key.toString())
	        };
	      });
	    }

	    // Select all selectalbe items

	  }, {
	    key: 'selectAll',
	    value: function selectAll() {
	      var _this2 = this;

	      return this.patch(function (_ref3) {
	        var selectable = _ref3.selectable,
	            selected = _ref3.selected;

	        var patch = {};

	        patch.selected = _underscore2.default.chain(_this2.gridView.items.slice()).filter(selectable).map(_underscore2.default.property(_this2.gridView.primaryKey)).map(String).union(selected).value();

	        return patch;
	      });
	    }

	    // Deselect all selectable items

	  }, {
	    key: 'deselectAll',
	    value: function deselectAll() {
	      var _this3 = this;

	      return this.patch(function (_ref4) {
	        var selectable = _ref4.selectable,
	            selected = _ref4.selected;

	        var patch = {};

	        patch.selected = _underscore2.default.filter(selected, function (key) {
	          var item = _this3.gridView.itemWithKey(key);

	          return !(item && selectable(item));
	        });

	        return patch;
	      });
	    }
	  }]);

	  return MultipleSelectionResolver;
	}(_selectionResolver.SelectionResolver);

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(10);

	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	;var locals_for_with = (locals || {});(function (checkAllLabel, checked, partSelected, single) {
	if ( single)
	{
	buf.push("<span></span>");
	}
	else
	{
	buf.push("<input type=\"checkbox\"" + (jade.attr("checked", checked, true, true)) + (jade.attr("aria-label", checkAllLabel, true, true)) + (jade.cls(['select-all',partSelected ? 'part-selected' : undefined], [null,true])) + ">");
	}}.call(this,"checkAllLabel" in locals_for_with?locals_for_with.checkAllLabel:typeof checkAllLabel!=="undefined"?checkAllLabel:undefined,"checked" in locals_for_with?locals_for_with.checked:typeof checked!=="undefined"?checked:undefined,"partSelected" in locals_for_with?locals_for_with.partSelected:typeof partSelected!=="undefined"?partSelected:undefined,"single" in locals_for_with?locals_for_with.single:typeof single!=="undefined"?single:undefined));;return buf.join("");
	}

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(10);

	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	;var locals_for_with = (locals || {});(function (value) {
	if ( value.selectable)
	{
	if ( value.single)
	{
	buf.push("<input type=\"radio\"" + (jade.attr("checked", value.checked, true, true)) + (jade.attr("aria-label", value.ariaLabel, true, true)) + (jade.attr("aria-labelledby", value.labelbyId, true, true)) + " class=\"select-row\">");
	}
	else
	{
	buf.push("<input type=\"checkbox\"" + (jade.attr("checked", value.checked, true, true)) + (jade.attr("aria-label", value.ariaLabel, true, true)) + (jade.attr("aria-labelledby", value.labelbyId, true, true)) + " class=\"select-row\">");
	}
	}
	else
	{
	buf.push("<span class=\"unselectable\"></span>");
	}}.call(this,"value" in locals_for_with?locals_for_with.value:typeof value!=="undefined"?value:undefined));;return buf.join("");
	}

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.rangeSelection = undefined;

	var _underscore = __webpack_require__(3);

	var _underscore2 = _interopRequireDefault(_underscore);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function changeSelectRow(e) {
	  var key = this.keyOfElement(e.target);
	  var selection = this.get('selection');
	  var rangeSelection = this.get('rangeSelection');

	  if (!e.shiftKey || selection.disableShiftKey) {
	    rangeSelection.preSelect = key;
	    return;
	  }

	  var selected = selection.selected;
	  var selectable = selection.selectable;
	  var preSelect = rangeSelection.preSelect;
	  var preShiftSelect = rangeSelection.preShiftSelect;
	  var allKey = _underscore2.default.chain(this.items.slice()).filter(selectable).map(_underscore2.default.property(this.primaryKey)).map(String).value();
	  var preIndex = allKey.indexOf(preSelect);
	  var curIndex = allKey.indexOf(key);
	  var selectObj = _underscore2.default.indexBy(selected);

	  if (preShiftSelect) {
	    var preShiftIndex = allKey.indexOf(preShiftSelect);

	    _underscore2.default.each(allKey.slice(Math.min(preIndex, preShiftIndex), Math.max(preIndex, preShiftIndex) + 1), function (key) {
	      delete selectObj[key];
	    });
	  }

	  _underscore2.default.each(allKey.slice(Math.min(preIndex, curIndex), Math.max(preIndex, curIndex) + 1), function (key) {
	    selectObj[key] = key;
	  });

	  rangeSelection.preShiftSelect = key;
	  this.set({
	    selection: _underscore2.default.defaults({ selected: _underscore2.default.keys(selectObj) }, selection)
	  });
	}

	function changeSelectAll() {
	  var rangeSelection = this.get('rangeSelection');

	  rangeSelection.preSelect = null;
	  rangeSelection.preShiftSelect = null;
	}

	function selectionProjectionHandler(state, config, model) {
	  if (model.selection.single) {
	    return state;
	  }

	  var events = _underscore2.default.defaults({
	    'click th input.select-all': changeSelectAll,
	    'click td input.select-row': changeSelectRow
	  }, state.events);

	  return _underscore2.default.defaults({ events: events }, state);
	}

	var rangeSelection = exports.rangeSelection = {
	  name: 'rangeSelection',
	  handler: selectionProjectionHandler,
	  defaults: {
	    preSelect: null,
	    preShiftSelect: null
	  }
	};

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.columns = undefined;

	var _underscore = __webpack_require__(3);

	var _underscore2 = _interopRequireDefault(_underscore);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/**
	 * @typedef ColumnConfig
	 * @type {Object}
	 * @property {string} name
	 *    Name of the column.
	 * @property {string} title
	 *    The localized column title. The `name` will be used if `title` is omitted.
	 * @property {string} html
	 *    The HTML string to be rendered in the column header. The `title` string
	 *    will be rendered in the column header if `html` is omitted.
	 * @property {(string|PropertyCallback|PropertyConfig)} property
	 *    The data property of the column. It defines how to get/set values with
	 *    a data item. If it's omitted, will use the column `name` as the key path.
	 *    It could be
	 *
	 *    * A key path string. E.g. 'Foo/Bar'.
	 *    * A {@link PropertyCallback} function
	 *    * A {@link PropertyConfig} object
	 *
	 * @property {CellTemplate} template
	 *    The template to render a cell for the column.
	 *
	 * @property {(boolean|number|OrderByKey)} sortable
	 *    The ordering configuration. If it's omitted, the column is unsortable.
	 *    It could be
	 *
	 *    * A boolean simply say the column is sortable or not.
	 *    * A number, positive for ascending first, otherwise descending first.
	 *    * A string, the key path of the sorting values.
	 *    * A {@link PropertyGetter} to get the sorting values from data items.
	 *      Only available for memory data source.
	 *    * A detailed {@link SortableConfig} object.
	 *
	 * @property {ClassesConfig} colClasses
	 *    The classes for the `COL` element in `COLGROUP`.
	 * @property {ClassesConfig} headClasses
	 *    The classes for the `TH` element in `THEAD`.
	 * @property {ClassesConfig} bodyClasses
	 *    The classes for the `TD` elements in `TBODY`.
	 * @property {ClassesConfig} footClasses
	 *    The classes for the `TD` elements in `TFOOT`.
	 * @property {ClassesConfig} colAttributes
	 *    The attributes for the `COL` element in `COLGROUP`.
	 * @property {AttributesConfig} headAttributes
	 *    The attributes for the `TH` elements in `THEAD`.
	 * @property {AttributesConfig} bodyAttributes
	 *    The attributes for the `TD` elements in `TBODY`.
	 * @property {AttributesConfig} footAttributes
	 *    The attributes for the `TD` elements in `TFOOT`.
	 * @property {ColumnConfig[]} columns
	 *    The children columns.
	 */

	/**
	 * Columns projection handling columns configuration
	 * @param {Object} state
	 * @param {(object[]|FakeArray)} [state.items]
	 *    Original data items from data source.
	 * @param {ColumnConfig[]} [columns]
	 *    Columns configuration defined by user. If omitted, all columns in original
	 *    data will be shown.
	 */
	function columnsProjectionHandler(state, columns) {
	  return _underscore2.default.defaults({
	    columns: columns || _underscore2.default.chain(state.items.slice(0, 1)).first().keys().map(function (name) {
	      return {
	        name: name,
	        sortable: true
	      };
	    }).value()
	  }, state);
	}

	var columns = exports.columns = {
	  name: 'columns',
	  handler: columnsProjectionHandler,
	  defaults: null
	};

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.rows = undefined;

	var _underscore = __webpack_require__(3);

	var _underscore2 = _interopRequireDefault(_underscore);

	var _common = __webpack_require__(84);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var bufferStateClasses = {
	  changed: ['row-buffer-changed'],
	  committed: ['row-buffer-committed']
	};

	/**
	 * Configuration for a row. It can be an object or a special
	 * @typedef RowConfig
	 * @type {(string|Object)}
	 * @property {?string} type
	 *    Optional parameter to define the type of the row. Special values are
	 *    * `'data-rows'`. A row configuration which will be expanded into
	 *      multiple rows representing each of the data items.
	 *    * `'data'`. Indicating the row is expanded from the `'data-rows'`.
	 *
	 * @property {?ClassesConfig} classes
	 *    The classes of the `TR` element.
	 * @property {?AttributesConfig} attributes
	 *    The attributes of the `TR` element.
	 * @property {?Object} item
	 *    The data item for the row.
	 * @property {?string} html
	 *    The HTML string rendered in a cell taking the entire row.
	 * @property {?Backbone.View} view
	 *    The Backbone View take the place of the entire row. This is is only for
	 *    the header and footer rows.
	 */

	/**
	 * The configuration for rows projection. When defining header rows, it can be
	 * a special string `'column-header-rows'`, representing all the column header
	 * rows.
	 * @typedef RowsConfig
	 * @type {(string|Object)}
	 * @property {RowConfig[]} headRows
	 *    Row configurations for `THEAD`. It can take a special string value
	 *    `column-header-rows`, which will be expanded into the column headers.
	 * @property {RowConfig[]} bodyRows
	 *    Row configurations for `TBODY`. It can take a special row with type
	 *    `data-rows`. This row will be expanded, one for each data item.
	 * @property {RowConfig[]} footRows - Row configurations for `TFOOT`.
	 */

	/**
	 * Handling bodyRows and adding headRows, bodyRows, footRows to state
	 * @param {StructureChainState} state - The input state.
	 * @param {RowsConfig} options - The configuration for rows projection.
	 * @return {StructureChainState}
	 */
	function rowsProjectionHandler(state) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$headRows = _ref.headRows,
	      headRows = _ref$headRows === undefined ? ['column-header-rows'] : _ref$headRows,
	      _ref$footRows = _ref.footRows,
	      footRows = _ref$footRows === undefined ? [] : _ref$footRows,
	      _ref$bodyRows = _ref.bodyRows,
	      bodyRows = _ref$bodyRows === undefined ? ['data-rows'] : _ref$bodyRows;

	  var primaryKey = state.primaryKey;
	  var changed = this.get('buffer').changed || {};

	  // TODO [wewei], use Fake items for better performance.
	  var items = state.items.slice(0, state.items.length);

	  return _underscore2.default.defaults({
	    headRows: _underscore2.default.map(headRows, function (row) {
	      return _underscore2.default.isObject(row) ? _underscore2.default.defaults({
	        classes: (0, _common.normalizeClasses)(row.classes, row),
	        attributes: (0, _common.normalizeAttributes)(row.attributes, row)
	      }, row) : row;
	    }),

	    bodyRows: _underscore2.default.reduce(bodyRows, function (memo, row) {
	      if (row === 'data-rows' || row.type === 'data-rows') {
	        _underscore2.default.each(items, function (item) {
	          var key = item[primaryKey];
	          var bufferState = _underscore2.default.chain(changed).result(key).result('state').value();
	          var classes = _underscore2.default.union((0, _common.normalizeClasses)(row.classes, item), _underscore2.default.result(bufferStateClasses, bufferState, []));
	          var attributes = (0, _common.normalizeAttributes)(row.attributes, item);

	          memo.push({ item: item, classes: classes, type: 'data', attributes: attributes });
	        });
	      } else if (row.view) {
	        throw new Error('Body row cannot have subviews');
	      } else {
	        memo.push(row);
	      }

	      return memo;
	    }, []),

	    footRows: _underscore2.default.map(footRows, function (row) {
	      return _underscore2.default.isObject(row) ? _underscore2.default.defaults({
	        classes: (0, _common.normalizeClasses)(row.classes, row),
	        attributes: (0, _common.normalizeAttributes)(row.attributes, row)
	      }, row) : row;
	    })
	  }, state);
	}

	var rows = exports.rows = {
	  name: 'rows',
	  handler: rowsProjectionHandler,
	  defaluts: {}
	};

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

	exports.normalizeClasses = normalizeClasses;
	exports.normalizeAttributes = normalizeAttributes;

	var _underscore = __webpack_require__(3);

	var _underscore2 = _interopRequireDefault(_underscore);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/**
	 * The classes configuration. It could be
	 *    * A array of class strings
	 *    * A space separated classes string
	 *    * A hash from class names to {@link ClassPredicate}
	 * @typedef ClassesConfig
	 * @type {(string[]|string|Object.<string, ClassPredicate>)}
	 */

	/**
	 * Normalize the classes configuration
	 * @param {ClassesConfig} classes
	 *    The classes configuration.
	 * @param {Object} context
	 *    The context for the classes. It could be
	 *    * A {@link ColumnConfig} for a column's headClasses/colClasses
	 *    * A {@link RowConfig} for a column or row's bodyClasses/footClasses
	 *    * An object representing the data item for data rows in the body
	 *
	 * @return {string[]}
	 *    The normalized classes configuration.
	 */
	function normalizeClasses(classes, context) {
	  if (_underscore2.default.isArray(classes)) {
	    return classes;
	  } else if (_underscore2.default.isString(classes)) {
	    return classes.split(/\s+/);
	  } else if (_underscore2.default.isFunction(classes)) {
	    return classes(context);
	  } else if (_underscore2.default.isObject(classes)) {
	    return _underscore2.default.chain(classes).pairs().filter(function (_ref) {
	      var _ref2 = _slicedToArray(_ref, 2),
	          value = _ref2[1];

	      /**
	       * A boolean or a callback to decide whether or not a class is applied.
	       * When it's a function, it takes the context and return a boolean.
	       * @typedef ClassPredicate
	       * @type {(boolean|ClassPredicateCallback)}
	       */
	      var isFunc = _underscore2.default.isFunction(value);

	      /**
	       * @callback ClassPredicateCallback
	       * @param {Object} context
	       *    Refer to the `context` of {@link normalizeClasses}.
	       * @return {boolean}
	       *    Whether or not the class is applied.
	       */
	      return isFunc && value(context) || !isFunc && Boolean(value);
	    }).map(function (_ref3) {
	      var _ref4 = _slicedToArray(_ref3, 1),
	          key = _ref4[0];

	      return key;
	    }).value();
	  }
	  return [];
	}

	/**
	 * Normalize the attributes configuration
	 * @param {AttributesConfig} attributes
	 *    The attributes configuration.
	 * @param {Object} context
	 *    The context for the classes. It could be
	 *    * A {@link ColumnConfig} for a column's headAttributes/colAttributes
	 *    * A {@link RowConfig} for a column or row's bodyAttributes/footAttributes
	 *    * An object representing the data item for data rows in the body
	 * @return {Object.<string, string>}
	 *    The normalized attributes configuration.
	 */
	function normalizeAttributes(attributes, context) {
	  if (_underscore2.default.isFunction(attributes)) {
	    return normalizeAttributes(attributes(context));
	  }

	  if (_underscore2.default.isObject(attributes)) {
	    return _underscore2.default.mapObject(attributes, function (value) {
	      return _underscore2.default.isFunction(value) ? value(context) : value;
	    });
	  }

	  return {};
	}

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.columnGroup = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _underscore = __webpack_require__(3);

	var _underscore2 = _interopRequireDefault(_underscore);

	var _common = __webpack_require__(84);

	var _defaultCell = __webpack_require__(86);

	var _defaultCell2 = _interopRequireDefault(_defaultCell);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function stringProperty(property) {
	  var segs = property.split('/');

	  return {
	    key: property,
	    get: function get(item) {
	      return _underscore2.default.reduce(segs, function (memo, key) {
	        return (memo || {})[key];
	      }, item);
	    },
	    set: function set(item, value) {
	      return _underscore2.default.reduce(segs, function (memo, seg, index) {
	        if (index < segs.length - 1) {
	          if (!_underscore2.default.isObject(memo[seg])) {
	            memo[seg] = {};
	          }
	        } else {
	          memo[seg] = value;
	        }
	      }, item);
	    }
	  };
	}

	/**
	 * @typedef PropertyConfig
	 * @type {Object}
	 * @property {PropertyGetter} get - The getter function.
	 * @property {PropertySetter} set - The setter function.
	 */

	/**
	 * @callback PropertyGetter
	 * @param {Object} item - The data item.
	 * @return {} - The value for the property.
	 */

	/**
	 * @callback PropertySetter
	 * @param {Object} item - The data item.
	 * @param {} value - The value for the property.
	 */

	/**
	 * It behaves as a {@link PropertyGetter} when passed 1 argument, and behaves
	 * as a {@link PropertySetter} when passed 2 arguments.
	 * @callback PropertyCallback
	 * @param {Object} item - The data item.
	 * @param {} [value] - The new value for the property.
	 * @return {} - The value for the property.
	 */

	function normalizeProperty(property, column) {
	  if (!property) {
	    return stringProperty(column.name);
	  }

	  if (_underscore2.default.isString(property)) {
	    return stringProperty(property);
	  }

	  if (_underscore2.default.isFunction(property)) {
	    return {
	      get: property,
	      set: property
	    };
	  }

	  return property;
	}

	function normalizeDirection(direction) {
	  if (_underscore2.default.isArray(direction)) {
	    return direction;
	  }

	  if (_underscore2.default.isNumber(direction)) {
	    return direction > 0 ? [1, -1] : [-1, 1];
	  }

	  return [1, -1];
	}

	/**
	 * @typedef SortableConfig
	 * @type {Object}
	 * @property {string|PropertyGetter} key
	 *    The sort key. It could be
	 *    * A string, the key path of the sorting values.
	 *    * A {@link PropertyGetter} to get the sorting values from data items.
	 *      Only available for memory data source.
	 *
	 * @property {number|number[]} direction
	 *    The direction could be
	 *    * A number
	 *      A number indicating the order on first click. Positive for ascending,
	 *      otherwise descending.
	 *    * An array of numbers
	 *      Indicating the sequence of sorting orders.
	 *
	 * @property {SortableHeaderTemplate} template
	 *    A customized template to render the sortable column header.
	 */

	function normalizeSortable(sortable, column) {
	  var columnKey = column.property.key || column.property.get;

	  if (sortable === true) {
	    return {
	      key: columnKey,
	      direction: normalizeDirection(1)
	    };
	  }

	  if (_underscore2.default.isString(sortable) || _underscore2.default.isFunction(sortable)) {
	    return {
	      key: sortable,
	      direction: normalizeDirection(1)
	    };
	  }

	  if (_underscore2.default.isNumber(sortable) && sortable || _underscore2.default.isArray(sortable)) {
	    return {
	      key: columnKey,
	      direction: normalizeDirection(sortable)
	    };
	  }

	  if (_underscore2.default.isObject(sortable)) {
	    return {
	      key: sortable.key || columnKey,
	      direction: normalizeDirection(_underscore2.default.result(sortable, 'direction', 1))
	    };
	  }

	  return null;
	}

	/**
	 * The column group class.
	 *
	 * It takes columns configuration as input and generates headerRows, leafColumns,
	 * columnIndex and root(a tree-like column structure).
	 *
	 * @param {ColumnConfig[]} columns
	 *    The columns configuration
	 */

	var ColumnGroup = function () {
	  function ColumnGroup(columns) {
	    var _this = this;

	    _classCallCheck(this, ColumnGroup);

	    /**
	     * The column header rows
	     * @type {RowContent[]}
	     */
	    this.headerRows = [];

	    /**
	     * The leaf columns
	     * @type {ExtendedColumnConfig[]}
	     */
	    this.leafColumns = [];

	    /**
	     * The columns indexed by name
	     * @type {Object.<string,ExtendedColumnConfig>}
	     */
	    this.columnIndex = {};

	    /*
	     * Build tree-like columns structure using DFS
	     */
	    var buildColumn = function buildColumn(col) {
	      /**
	       * An extended internal representation of columns. It extends
	       * {@link ColumnConfig} with several extra properties.
	       * @typedef ExtendedColumnConfig
	       * @type ColumnConfig
	       * @property {ExtendedColumnConfig} parent
	       *    The parent column if there's a column hierarchy.
	       * @property {ExtendedColumnConfig[]} columns
	       *    The children columns.
	       * @property {CellContent} cell
	       *    The configuration of the header cell.
	       * @property {number} height
	       *    The rowspan of the header cell.
	       * @property {number} treeWidth
	       *    The colspan of the header cell. The tree width of the column
	       *    subtree in number of columns.
	       * @property {number} treeHeight
	       *    The height of the column subtree in number of rows.
	       */
	      var parent = col.parent,
	          columns = col.columns,
	          height = col.height,
	          name = col.name,
	          property = col.property,
	          sortable = col.sortable;


	      _this.columnIndex[name] = col;

	      col.property = normalizeProperty(property, col);
	      col.sortable = normalizeSortable(sortable, col);

	      if (!_underscore2.default.isFunction(col.template)) {
	        col.template = _defaultCell2.default;
	      }
	      col.height = _underscore2.default.isNumber(height) ? height : 1;
	      col.rowIndex = parent ? parent.rowIndex + parent.height : 0;
	      col.columns = _underscore2.default.map(columns, function (c) {
	        return buildColumn(_underscore2.default.extend({ parent: col }, c));
	      });
	      col.treeHeight = col.height;
	      col.treeWidth = 1;
	      if (_underscore2.default.isEmpty(col.columns)) {
	        _this.leafColumns.push(col);
	      } else {
	        col.treeHeight += _underscore2.default.chain(col.columns).map(_underscore2.default.property('treeHeight')).max().value();
	        col.treeWidth = _underscore2.default.chain(col.columns).map(_underscore2.default.property('treeWidth')).reduce(function (a, b) {
	          return a + b;
	        }, 0).value();
	      }

	      return col;
	    };

	    /*
	     * Build column header with DFS
	     */
	    var buildColumnHeader = function buildColumnHeader(col) {
	      if (col.parent) {
	        var colspan = col.treeWidth;
	        var rowspan = _underscore2.default.isEmpty(col.columns) ? _this.root.treeHeight - col.rowIndex : col.height;
	        var name = col.name;
	        var html = col.html || col.title || col.name;

	        while (_this.headerRows.length <= col.rowIndex) {
	          _this.headerRows.push({ cells: [], attributes: {} });
	        }

	        var classes = _underscore2.default.union((0, _common.normalizeClasses)(col.headClasses, col), ['column-header']);
	        if (_underscore2.default.isEmpty(col.columns)) {
	          classes.push('column-header-leaf');
	        }
	        var attributes = _underscore2.default.defaults({
	          colspan: colspan,
	          rowspan: rowspan,
	          'data-name': name
	        }, (0, _common.normalizeAttributes)(col.headAttributes, col));
	        col.cell = { html: html, name: name, classes: classes, attributes: attributes };
	        _this.headerRows[col.rowIndex].cells.push(col.cell);
	      }
	      _underscore2.default.each(col.columns, buildColumnHeader);
	    };

	    /**
	     * The root column
	     * @type {ExtendedColumnConfig}
	     */
	    this.root = buildColumn({
	      name: '__root__',
	      height: 0,
	      columns: columns
	    });

	    buildColumnHeader(this.root);
	  }

	  _createClass(ColumnGroup, [{
	    key: 'columnWithName',
	    value: function columnWithName(name) {
	      return this.columnIndex[name];
	    }
	  }, {
	    key: 'height',
	    get: function get() {
	      return this.root.treeHeight;
	    }
	  }, {
	    key: 'width',
	    get: function get() {
	      return this.root.treeWidth;
	    }
	  }]);

	  return ColumnGroup;
	}();

	function translateColumnGroup(columnGroup) {
	  return _underscore2.default.map(columnGroup.leafColumns, function (col) {
	    var colClasses = _underscore2.default.union((0, _common.normalizeClasses)(col.colClasses, col), ['col-' + col.name]);
	    var colAttributes = (0, _common.normalizeAttributes)(col.colAttributes, col);
	    /**
	     * The content of a `COL` element in `COLGROUP`.
	     * @typedef ColContent
	     * @type {Object}
	     * @property {string[]} classes
	     *    The classes of the `COL` element.
	     * @property {number|string} width
	     *    The CSS width for the column.
	     */
	    return {
	      attributes: colAttributes,
	      classes: colClasses,
	      width: _underscore2.default.isNumber(col.width) ? col.width + 'px' : col.width
	    };
	  });
	}

	/**
	 * Resolve grid structure from columns configuration and build the
	 * {@link ColumnGroup} object.
	 *
	 * @param {ContentChainState} state
	 *    The input content chain state.
	 * @return {ContentChainState}
	 */
	function columnGroupProjectionHandler(state) {
	  var columnGroup = new ColumnGroup(state.columns || []);
	  return _underscore2.default.defaults({
	    columnGroup: columnGroup,
	    cols: translateColumnGroup(columnGroup)
	  }, state);
	}

	var columnGroup = exports.columnGroup = {
	  name: 'columnGroup',
	  handler: columnGroupProjectionHandler,
	  defaults: {}
	};

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(10);

	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	;var locals_for_with = (locals || {});(function (value) {
	buf.push("<span>" + (jade.escape(null == (jade_interp = value) ? "" : jade_interp)) + "</span>");}.call(this,"value" in locals_for_with?locals_for_with.value:typeof value!=="undefined"?value:undefined));;return buf.join("");
	}

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.cells = undefined;

	var _underscore = __webpack_require__(3);

	var _underscore2 = _interopRequireDefault(_underscore);

	var _common = __webpack_require__(84);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/**
	 * Translate the {@link RowConfig} into {@link RowContent}
	 * @param {Object} options
	 * @param {ColumnGroup} options.columnGroup
	 *    The column group.
	 * @param {RowConfig} options.row
	 *    The {@link RowConfig} to translate.
	 * @param {string} rowType
	 *    Which group the row belongs to. It could be 'head', 'body' or 'foot'.
	 * @param {string} primaryKey
	 *    The primary key of the data items.
	 * @return {RowContent}
	 */
	function translateRow(_ref) {
	  var columnGroup = _ref.columnGroup,
	      row = _ref.row,
	      rowType = _ref.rowType,
	      primaryKey = _ref.primaryKey;

	  var patch = {};

	  if (_underscore2.default.has(row, 'html')) {
	    patch.cells = [{
	      attributes: {
	        rowspan: 1,
	        colspan: columnGroup.width
	      },
	      html: row.html
	    }];
	  }
	  if (_underscore2.default.has(row, 'view')) {
	    patch.cells = [{
	      attributes: {
	        rowspan: 1,
	        colspan: columnGroup.width
	      },
	      view: row.view
	    }];
	  }
	  if (_underscore2.default.has(row, 'item')) {
	    patch.cells = _underscore2.default.map(columnGroup.leafColumns, function (col) {
	      var cellClasses = void 0,
	          cellAttributes = void 0;

	      if (rowType === 'foot') {
	        cellClasses = (0, _common.normalizeClasses)(col.footClasses, row);
	        cellAttributes = (0, _common.normalizeAttributes)(col.footAttributes, row);
	      } else if (rowType === 'body') {
	        cellClasses = (0, _common.normalizeClasses)(col.bodyClasses, row);
	        cellAttributes = (0, _common.normalizeAttributes)(col.bodyAttributes, row);
	      } else if (rowType === 'head') {
	        cellClasses = (0, _common.normalizeClasses)(col.headClasses, row);
	        cellAttributes = (0, _common.normalizeAttributes)(col.headAttributes, row);
	      }

	      /**
	       * The object represents a cell.
	       * @typedef CellContent
	       * @type {Object}
	       * @property {string[]} classes
	       *    The classes for the `TD`/`TH` element
	       * @property {Object.<string,string>} attributes
	       *    The HTML attributes for the `TD`/`TH` element.
	       * @property {string} html
	       *    The HTML string to be rendered inside the cell.
	       * @property {Backbone.View} view
	       *    The Backbone View to be filled into the cell. Unsupported for
	       *    the body cells.
	       */
	      var cell = { classes: cellClasses, attributes: cellAttributes };
	      cell.value = col.property.get(row.item);
	      cell.html = col.template(_underscore2.default.pick(cell, 'value'));

	      return cell;
	    });

	    patch.attributes = _underscore2.default.defaults({
	      'data-key': row.item[primaryKey]
	    }, row.attributes);
	  }

	  /**
	   * Extends the {@link RowConfig} with extra properties
	   * @typedef RowContent
	   * @type {RowConfig}
	   * @property {CellContent[]} cells
	   *    The cells in the row.
	   * @property {Object.<string,string>} attributes
	   *    The HTML attributes for the `TR` element.
	   */
	  return _underscore2.default.defaults(patch, row, { attributes: {} });
	}

	/**
	 * Fill the headRows, bodyRows and footRows with cells.
	 * @param {ContentChainState} state
	 *    All data, configurations and events needed in grid cells.
	 * @return {ContentChainState}
	 */
	function cellsProjectionHandler(state) {
	  var columnGroup = state.columnGroup;
	  var primaryKey = this.primaryKey;

	  var headRows = _underscore2.default.reduce(state.headRows, function (memo, row) {
	    if (row === 'column-header-rows') {
	      return memo.concat(columnGroup.headerRows);
	    }
	    memo.push(translateRow({
	      columnGroup: columnGroup,
	      row: row,
	      rowType: 'head',
	      primaryKey: primaryKey
	    }));
	    return memo;
	  }, []);

	  var bodyRows = {
	    length: state.bodyRows.length,
	    slice: function slice() {
	      var begin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	      var end = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : state.bodyRows.length;

	      return state.bodyRows.slice(begin, end).map(function (row) {
	        return translateRow({
	          columnGroup: columnGroup,
	          row: row,
	          rowType: 'body',
	          primaryKey: primaryKey
	        });
	      });
	    }
	  };

	  var footRows = _underscore2.default.map(state.footRows, function (row) {
	    return translateRow({
	      columnGroup: columnGroup,
	      row: row,
	      rowType: 'foot',
	      primaryKey: primaryKey
	    });
	  });

	  return _underscore2.default.defaults({
	    headRows: headRows,
	    bodyRows: bodyRows,
	    footRows: footRows
	  }, state);
	}

	var cells = exports.cells = {
	  name: 'cells',
	  handler: cellsProjectionHandler,
	  defaults: {}
	};

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.sortableHeader = undefined;

	var _underscore = __webpack_require__(3);

	var _underscore2 = _interopRequireDefault(_underscore);

	var _sortableHeader = __webpack_require__(89);

	var _sortableHeader2 = _interopRequireDefault(_sortableHeader);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	// Reorder column data referring to 'column.sortable'.
	// 'column.sortable' takes four types of values: boolean, number, string and function.
	function reorder(e) {
	  var name = this.$(e.target).closest('th').attr('data-name');
	  var sortable = this.columnWithName(name).sortable;

	  if (sortable) {
	    var sortableHeaderCur = this.get('sortableHeader') || {};
	    var directionIndex = sortableHeaderCur.directionIndex;

	    if (sortableHeaderCur.name === name) {
	      directionIndex = (directionIndex + 1) % sortable.direction.length;
	    } else {
	      directionIndex = 0;
	    }

	    var direction = sortable.direction[directionIndex];

	    this.patch({
	      query: {
	        orderby: direction ? [{
	          key: sortable.key,
	          direction: direction
	        }] : []
	      },
	      sortableHeader: { name: name, directionIndex: directionIndex }
	    });
	  }
	}

	/**
	 * Add click event to sortable column and wrap sortable column's head with a template
	 * @param {ContentChainState} state
	 *    The input state.
	 * @param {SortableHeaderConfig} options
	 *    The sortable header configurations.
	 */
	function sortableHeaderProjectionHandler(state) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      name = _ref.name,
	      directionIndex = _ref.directionIndex,
	      _ref$template = _ref.template,
	      template = _ref$template === undefined ? _sortableHeader2.default : _ref$template;

	  /**
	   * @typedef SortableHeaderConfig
	   * @type {Object}
	   * @property {string} name
	   *    The name of the ordered column.
	   * @property {number} directionIndex
	   *    The index of direction in the direction sequence.
	   * @property {?SortableHeaderTemplate} template
	   *    The template to render the sortable column headers.
	   */
	  var patch = {};
	  var leafColumns = state.columnGroup.leafColumns;
	  var leafColumnIndex = _underscore2.default.reduce(leafColumns, function (memo, col) {
	    memo[col.name] = col;
	    return memo;
	  }, {});

	  patch.headRows = _underscore2.default.map(state.headRows, function (row) {
	    var cells = _underscore2.default.map(row.cells, function (cell) {
	      var patchCell = {};
	      var column = leafColumnIndex[cell.name];

	      if (column && column.sortable) {
	        patchCell.classes = cell.classes.concat(['clickable', 'column-header-sortable']);

	        var decorationTemplate = column.sortable.template || template;
	        var direction = column.name === name ? column.sortable.direction[directionIndex] : 0;
	        var ariaSort = direction > 0 ? 'ascending' : direction < 0 ? 'descending' : 'none';

	        patchCell.attributes = _underscore2.default.defaults({ 'aria-sort': ariaSort, 'tabindex': 0 }, cell.attributes);

	        /**
	         * @callback SortableHeaderTemplate
	         * @param {Object} locals
	         * @param {string} locals.html
	         *    The original HTML string for the column header.
	         * @param {number} locals.direction
	         *    The sort state.
	         *    * Positive value for ascending.
	         *    * Negative value for descending.
	         *    * 0 for not sorted.
	         */
	        patchCell.html = decorationTemplate({
	          html: cell.html,
	          direction: direction
	        });
	      }

	      return _underscore2.default.defaults(patchCell, cell);
	    });

	    return _underscore2.default.defaults({ cells: cells }, row);
	  });

	  patch.events = _underscore2.default.defaults({
	    'click th.column-header-sortable': reorder
	  }, state.events);

	  return _underscore2.default.defaults(patch, state);
	}

	var sortableHeader = exports.sortableHeader = {
	  name: 'sortableHeader',
	  handler: sortableHeaderProjectionHandler,
	  defaults: {}
	};

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(10);

	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	;var locals_for_with = (locals || {});(function (direction, html) {
	if ( direction < 0)
	{
	buf.push("<span class=\"sort-indicator glyphicon glyphicon-arrow-down\"></span>");
	}
	else if ( direction > 0)
	{
	buf.push("<span class=\"sort-indicator glyphicon glyphicon-arrow-up\"></span>");
	}
	buf.push(null == (jade_interp = html) ? "" : jade_interp);}.call(this,"direction" in locals_for_with?locals_for_with.direction:typeof direction!=="undefined"?direction:undefined,"html" in locals_for_with?locals_for_with.html:typeof html!=="undefined"?html:undefined));;return buf.join("");
	}

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.events = undefined;

	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

	var _underscore = __webpack_require__(3);

	var _underscore2 = _interopRequireDefault(_underscore);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

	function sequence() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }

	  var callbacks = _underscore2.default.filter(args, _underscore2.default.isFunction);
	  return function () {
	    var _this = this;

	    for (var _len2 = arguments.length, argsInner = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      argsInner[_key2] = arguments[_key2];
	    }

	    _underscore2.default.each(callbacks, function (cb) {
	      return cb.apply(_this, argsInner);
	    });
	  };
	}

	/**
	 * @external BackboneViewEventHash
	 * @see {@link http://backbonejs.org/#View-events}
	 */

	/**
	 * Merge the customized events with the projection injected events.
	 * @param {ContentChainState} state
	 *    The input state.
	 * @param {external:BackboneViewEventHash} eventsOptions
	 *    The customized events in form of `Backbone.View#events`.
	 */
	function eventsProjectionHandler(state, eventsOptions) {
	  var pairs = _underscore2.default.pairs(state.events).concat(_underscore2.default.pairs(eventsOptions));
	  var events = _underscore2.default.reduce(pairs, function (memo, _ref) {
	    var _ref2 = _slicedToArray(_ref, 2),
	        key = _ref2[0],
	        handler = _ref2[1];

	    return _underscore2.default.extend(memo, _defineProperty({}, key, sequence(memo[key], handler)));
	  }, {});

	  return _underscore2.default.defaults({ events: events }, state);
	}

	var events = exports.events = {
	  name: 'events',
	  handler: eventsProjectionHandler,
	  defaults: {}
	};

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _tableView = __webpack_require__(92);

	Object.defineProperty(exports, 'TableView', {
	  enumerable: true,
	  get: function get() {
	    return _tableView.TableView;
	  }
	});

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TableView = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

	var _underscore = __webpack_require__(3);

	var _underscore2 = _interopRequireDefault(_underscore);

	var _backbone = __webpack_require__(8);

	var _backbone2 = _interopRequireDefault(_backbone);

	var _backboneVirtualizedListview = __webpack_require__(93);

	var _backboneVirtualizedListview2 = _interopRequireDefault(_backboneVirtualizedListview);

	var _headerFooterView = __webpack_require__(94);

	var _row = __webpack_require__(97);

	var _row2 = _interopRequireDefault(_row);

	var _tableFixed = __webpack_require__(98);

	var _tableFixed2 = _interopRequireDefault(_tableFixed);

	var _tableStatic = __webpack_require__(99);

	var _tableStatic2 = _interopRequireDefault(_tableStatic);

	var _tableSticky = __webpack_require__(100);

	var _tableSticky2 = _interopRequireDefault(_tableSticky);

	var _columnGroup = __webpack_require__(101);

	var _columnGroup2 = _interopRequireDefault(_columnGroup);

	var _escape = __webpack_require__(96);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var STATE_OPTIONS = ['cols', 'headRows', 'bodyRows', 'footRows', 'events'];
	var HEADER_TYPES = ['static', 'fixed', 'sticky'];
	var rowTemplateWithEscape = function rowTemplateWithEscape(row) {
	  return (0, _row2.default)(_underscore2.default.defaults({ escapeAttr: _escape.escapeAttr }, row));
	};

	/**
	 * Table view with virtualization support
	 * @class TableView
	 * @extends Backbone.View
	 * @param {Object} options
	 *  the constructor options
	 * @param {string[]} [options.classes=[]]
	 *  the classes for the TABLE elements (content table and sticky/fixed header)
	 * @param {ScrollingConfig} [options.scrolling={virtualized: false, header: 'static'}]
	 *  the scrolling related configurations
	 */

	var TableView = exports.TableView = function (_Backbone$View) {
	  _inherits(TableView, _Backbone$View);

	  function TableView() {
	    _classCallCheck(this, TableView);

	    return _possibleConstructorReturn(this, (TableView.__proto__ || Object.getPrototypeOf(TableView)).apply(this, arguments));
	  }

	  _createClass(TableView, [{
	    key: 'initialize',
	    value: function initialize(_ref) {
	      var _this2 = this;

	      var _ref$scrolling = _ref.scrolling,
	          scrolling = _ref$scrolling === undefined ? {} : _ref$scrolling,
	          _ref$classes = _ref.classes,
	          classes = _ref$classes === undefined ? [] : _ref$classes,
	          _ref$attributes = _ref.attributes,
	          attributes = _ref$attributes === undefined ? {} : _ref$attributes;

	      this._props = {
	        scrolling: this._normalizeScrollingConfig(scrolling),
	        classes: classes,
	        attributes: attributes
	      };

	      this._state = {
	        cols: [],
	        headRows: [],
	        bodyRows: [],
	        footRows: [],
	        events: {}
	      };

	      this._listView = new _backboneVirtualizedListview2.default({
	        el: this.$el,
	        virtualized: this._props.scrolling.virtualized,
	        viewport: this._props.scrolling.viewport
	      });

	      this._headerView = new _headerFooterView.HeaderView({ tableView: this });
	      this._footerView = new _headerFooterView.FooterView({ tableView: this });

	      _underscore2.default.each(['willRedraw', 'didRedraw'], function (event) {
	        _this2._listView.on(event, function () {
	          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	          }

	          _this2.trigger.apply(_this2, [event].concat(args));
	        });
	      });
	    }
	  }, {
	    key: '_normalizeHeaderConfig',
	    value: function _normalizeHeaderConfig(config) {
	      var header = {};

	      if (_underscore2.default.isString(config)) {
	        header.type = config;
	      } else if (_underscore2.default.isFunction(config) || _underscore2.default.isFinite(config)) {
	        header.type = 'sticky';
	        header.offset = config;
	      } else if (_underscore2.default.isObject(config) && _underscore2.default.isString(config.type)) {
	        _underscore2.default.extend(header, _underscore2.default.pick(config, 'type', 'offset', 'attributes'));
	      }

	      if (!_underscore2.default.contains(HEADER_TYPES, header.type)) {
	        header.type = 'static';
	      }

	      if (header.type === 'sticky' && !_underscore2.default.isFinite(_underscore2.default.result(header, 'offset'))) {
	        header.offset = 0;
	      }

	      return header;
	    }

	    /**
	     * @typedef ScrollingConfig
	     * @type {Object}
	     *
	     * @property {boolean} virtualized
	     *  flag for virtualization.
	     *
	     * @property {(string|HTMLElement|jQuery|window)} viewport
	     *  the scrolling viewport. If omit, the table view will auto detect the
	     *  closest ancestor of the $el with 'overflowY' style being 'auto' or
	     *  'scroll'. Use the window viewport if found none.
	     *
	     *  NOTE: the viewport takes no effect when using fixed header. Tables with
	     *  fixed header render its viewport inside, as the container of the body
	     *  and footer.
	     *
	     * @property {(string|HeaderConfig)} header
	     *  the header scrolling behavior configurations. It can be a string to
	     *  indicate the header type (`'static'`, `'sticky'` or `'fixed'`). Or an
	     *  detailed configuration object.
	     *
	     */

	    /**
	     * @typedef HeaderConfig
	     * @type {Object}
	     * @property {string} type
	     * the header type. It can have the following values
	     *
	     *  * `'static'`: static header, the normal case, the header is rendered to
	     *    the top of the grid.
	     *  * `'sticky'`: sticky header, the header will stick to the viewport with
	     *    a given offset.
	     *  * `'fixed'`: fixed header, the header will be outside the viewport. Only
	     *    the body and footer are scrollable.
	     *
	     * @property {number|function} offset
	     * special configuration for sticky header indicating its position. It's can
	     * be a number or a function returning a number, represents number of pixels
	     * below the viewport top.
	     */

	  }, {
	    key: '_normalizeScrollingConfig',
	    value: function _normalizeScrollingConfig(_ref2) {
	      var viewport = _ref2.viewport,
	          _ref2$virtualized = _ref2.virtualized,
	          virtualized = _ref2$virtualized === undefined ? false : _ref2$virtualized,
	          _ref2$header = _ref2.header,
	          header = _ref2$header === undefined ? 'static' : _ref2$header;

	      var scrolling = { viewport: viewport, virtualized: virtualized };

	      scrolling.header = this._normalizeHeaderConfig(header);

	      if (scrolling.header.type === 'fixed') {
	        scrolling.viewport = '.viewport';
	      }

	      return scrolling;
	    }
	  }, {
	    key: 'set',
	    value: function set() {
	      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _underscore2.default.noop;

	      var isSet = function isSet(key) {
	        return !_underscore2.default.isUndefined(state[key]);
	      };
	      var listState = {};

	      _underscore2.default.extend(this._state, _underscore2.default.pick(state, STATE_OPTIONS));

	      if (isSet('bodyRows')) {
	        var bodyRows = this._state.bodyRows;

	        listState.items = {
	          length: bodyRows.length,
	          slice: function slice(start, stop) {
	            return _underscore2.default.map(bodyRows.slice(start, stop), function (row) {
	              return { row: row };
	            });
	          }
	        };
	      }

	      if (isSet('events')) {
	        listState.events = state.events;
	      }

	      this._renderColumnGroup();

	      if (this._headerView) {
	        this._headerView.redraw();
	      }

	      if (this._footerView) {
	        this._footerView.redraw();
	      }

	      this._listView.set(listState, callback);

	      return this;
	    }
	  }, {
	    key: '_renderColumnGroup',
	    value: function _renderColumnGroup() {
	      this.$colgroup = this.$('colgroup.column-group');
	      this.$colgroup.html((0, _columnGroup2.default)(_underscore2.default.defaults({ escapeAttr: _escape.escapeAttr }, this._state)));
	    }
	  }, {
	    key: '_renderHeader',
	    value: function _renderHeader() {
	      this._headerView.setElement(this.$('thead.header'));
	      this._headerView.render();
	    }
	  }, {
	    key: '_renderFooter',
	    value: function _renderFooter() {
	      this._footerView.setElement(this.$('tfoot.footer'));
	      this._footerView.render();
	    }

	    /**
	     * This is simulating `{ position: sticky }`, but it's still far from perfect.
	     *
	     * 1. For window viewport
	     *    * Use `{ postion: fixed }`
	     *    * Adjust the width and the horizontal location on the fly
	     *    * Put an dummy filler into the content flow to take the place of header
	     *
	     * The issues are
	     *    * If the subviews in header changes, they have to notify the grid
	     *    manually to update the filler's size
	     *    * The header doesn't follow the table tightly on horizontal scroll, as
	     *    the `scroll` event is triggered after repaint for most browsers
	     *
	     * 2. For element viewport
	     *    * Use `{ position: relative }`
	     *    * Adjust the vertical location on the fly
	     *
	     * The issues are
	     *    * The header doesn't follow the table tightly on vertical scroll, as
	     *    the `scroll` event is triggered after repaint for most browsers. The
	     *    sticky header could be very jumpy on IE and Edge.
	     *
	     * We wish all browsers support `{ position: sticky }` in a not too far
	     * future. So that we can have a perfect solution with native support.
	     *
	     */

	  }, {
	    key: '_hookUpStickyHeader',
	    value: function _hookUpStickyHeader(listView) {
	      var _this3 = this;

	      var viewport = listView.viewport;
	      var isWindow = viewport.$el.get(0) === window;
	      var $tableContainer = this.$('.table-container');
	      var $stickyHeader = this.$('.sticky-header');
	      var $stickyHeaderFiller = this.$('.sticky-header-filler');
	      var $table = this.$('.sticky-header-filler + table');
	      var viewportSize = { width: 0, height: 0 };

	      var adjustStickyHeader = function adjustStickyHeader() {
	        if (!_this3.$el.is(':visible')) {
	          return;
	        }

	        var metricsVP = listView.viewport.getMetrics();
	        var topVP = metricsVP.outer.top;
	        var offset = _underscore2.default.result(_this3._props.scrolling.header, 'offset', 0);
	        var rectContainer = document.body.contains($tableContainer.get(0)) ? $tableContainer.get(0).getBoundingClientRect() : { top: 0, left: 0 };
	        var topCur = rectContainer.top;

	        if (isWindow) {
	          var sticky = topCur < topVP + offset;
	          $stickyHeaderFiller.css({
	            display: sticky ? 'block' : 'none',
	            height: sticky ? $stickyHeader.height() : ''
	          });

	          var style = {
	            position: sticky ? 'fixed' : 'static',
	            top: sticky ? topVP + offset : '',
	            left: sticky ? rectContainer.left : ''
	          };

	          var deltaWidth = Math.abs(metricsVP.outer.width - viewportSize.width);
	          var deltaHeight = Math.abs(metricsVP.outer.height - viewportSize.height);
	          var resize = deltaWidth >= 1 || deltaHeight >= 1;

	          if (resize) {
	            // Update the viewportSize
	            viewportSize.width = metricsVP.outer.width;
	            viewportSize.height = metricsVP.outer.height;

	            // Let the content table layout freely, then sync the width to sticky header
	            $stickyHeader.css({ 'width': 'auto', 'min-width': 0 });
	            $table.css({ 'width': 'auto', 'min-width': 0 });
	            var width = $tableContainer.width();
	            style.width = width;
	            style['min-width'] = width;
	            $table.css({ width: width, 'min-width': width });
	          }

	          $stickyHeader.css(style);
	        } else {
	          $stickyHeaderFiller.css({
	            display: 'none'
	          });
	          $stickyHeader.css({
	            position: 'relative',
	            top: Math.min(Math.max(topVP + offset - topCur, 0), $table.height())
	          });
	        }
	      };
	      listView.viewport.on('resize', function () {
	        return _this3.trigger('didChangeBound');
	      });
	      listView.viewport.on('scroll', function () {
	        return _this3.trigger('didChangeBound');
	      });

	      this.on('didChangeBound', adjustStickyHeader);
	      listView.on('didRedraw', adjustStickyHeader);
	    }
	  }, {
	    key: '_renderStatic',
	    value: function _renderStatic(callback) {
	      var _this4 = this;

	      this._listView.set({
	        model: {
	          classes: this._props.classes,
	          dataTableAttributes: this._props.attributes
	        },
	        listTemplate: _tableStatic2.default,
	        itemTemplate: rowTemplateWithEscape
	      }).render(function () {
	        _this4._renderColumnGroup();
	        _this4._renderHeader();
	        _this4._renderFooter();
	        callback();
	      });
	    }
	  }, {
	    key: '_renderFixed',
	    value: function _renderFixed(callback) {
	      var _this5 = this;

	      this._listView.set({
	        model: {
	          classes: this._props.classes,
	          headerAttributes: _underscore2.default.result(this._props.scrolling.header, 'attributes', {}),
	          dataTableAttributes: this._props.attributes
	        },
	        listTemplate: _tableFixed2.default,
	        itemTemplate: rowTemplateWithEscape
	      }).render(function () {
	        _this5._renderColumnGroup();
	        _this5._renderHeader();
	        _this5._renderFooter();
	        callback();
	      });

	      this._listView.on('didRedraw', function () {
	        var widthViewport = _this5.$('.viewport').get(0).clientWidth;
	        var widthContainer = _this5.el.clientWidth;
	        var widthScrollbar = widthContainer - widthViewport;
	        var widthTable = _this5.$('.viewport > table').get(0).offsetWidth;

	        _this5.$el.width(widthTable + widthScrollbar);
	        _this5.$('.fixed-header').width(widthTable);
	      });
	    }
	  }, {
	    key: '_renderSticky',
	    value: function _renderSticky(callback) {
	      var _this6 = this;

	      this._listView.set({
	        model: {
	          classes: this._props.classes,
	          headerAttributes: _underscore2.default.result(this._props.scrolling.header, 'attributes', {}),
	          dataTableAttributes: this._props.attributes
	        },
	        listTemplate: _tableSticky2.default,
	        itemTemplate: rowTemplateWithEscape
	      }).render(function () {
	        _this6._renderColumnGroup();
	        _this6._renderHeader();
	        _this6._hookUpStickyHeader(_this6._listView);
	        _this6._renderFooter();
	        callback();
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _underscore2.default.noop;

	      var header = this._props.scrolling.header;

	      switch (header.type) {
	        default:
	        case 'static':
	          this._renderStatic(callback);
	          break;
	        case 'fixed':
	          this._renderFixed(callback);
	          break;
	        case 'sticky':
	          this._renderSticky(callback);
	          break;
	      }

	      return this;
	    }
	  }, {
	    key: 'remove',
	    value: function remove() {
	      if (this._headerView) {
	        this._headerView.remove();
	      }

	      if (this._listView) {
	        this._listView.remove();
	      }

	      if (this._footerView) {
	        this._footerView.remove();
	      }

	      _get(TableView.prototype.__proto__ || Object.getPrototypeOf(TableView.prototype), 'remove', this).call(this);
	    }
	  }, {
	    key: 'scrollToItem',
	    value: function scrollToItem() {
	      var _listView;

	      (_listView = this._listView).scrollToItem.apply(_listView, arguments);
	    }
	  }, {
	    key: 'indexOfElement',
	    value: function indexOfElement(el) {
	      var $elTr = this._listView.$(el).closest('tr', this._listView.$container);
	      if ($elTr.length > 0) {
	        return $elTr.index() + this._listView.indexFirst - 1;
	      }
	      return null;
	    }
	  }, {
	    key: 'headerType',
	    get: function get() {
	      return this._props.scrolling.header.type;
	    }
	  }]);

	  return TableView;
	}(_backbone2.default.View);

/***/ }),
/* 93 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_93__;

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FooterView = exports.HeaderView = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _underscore = __webpack_require__(3);

	var _underscore2 = _interopRequireDefault(_underscore);

	var _backbone = __webpack_require__(8);

	var _backbone2 = _interopRequireDefault(_backbone);

	var _headerFooter = __webpack_require__(95);

	var _headerFooter2 = _interopRequireDefault(_headerFooter);

	var _escape = __webpack_require__(96);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var subviewClass = function subviewClass(i) {
	  return 'header-subview-' + i;
	};
	var subviewSelector = function subviewSelector(i) {
	  return '.' + subviewClass(i);
	};

	var HeaderFooterView = function (_Backbone$View) {
	  _inherits(HeaderFooterView, _Backbone$View);

	  function HeaderFooterView() {
	    _classCallCheck(this, HeaderFooterView);

	    return _possibleConstructorReturn(this, (HeaderFooterView.__proto__ || Object.getPrototypeOf(HeaderFooterView)).apply(this, arguments));
	  }

	  _createClass(HeaderFooterView, [{
	    key: 'initialize',
	    value: function initialize(_ref) {
	      var tableView = _ref.tableView,
	          group = _ref.group;

	      this.tableView = tableView;
	      this.group = group;
	      this.subviews = [];
	    }
	  }, {
	    key: 'redraw',
	    value: function redraw() {
	      var _this2 = this;

	      _underscore2.default.each(this.subviews, function (subview) {
	        return subview.$el.detach();
	      });
	      this.subviews = [];
	      this.$el.html(this.template({
	        rows: _underscore2.default.map(this.rows, function (row) {
	          var cells = _underscore2.default.map(row.cells, function (cell) {
	            if (cell.view) {
	              var classes = _underscore2.default.union(cell.classes, [subviewClass(_this2.subviews.length)]);
	              _this2.subviews.push(cell.view);
	              return _underscore2.default.defaults({ classes: classes }, cell);
	            }
	            return cell;
	          });

	          return _underscore2.default.defaults({ cells: cells }, row);
	        }),

	        group: this.group
	      }));

	      _underscore2.default.each(this.subviews, function (subview, i) {
	        subview.$el.appendTo(_this2.$(subviewSelector(i)));
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      this.redraw();
	      return this;
	    }
	  }]);

	  return HeaderFooterView;
	}(_backbone2.default.View);

	var HeaderView = exports.HeaderView = function (_HeaderFooterView) {
	  _inherits(HeaderView, _HeaderFooterView);

	  function HeaderView() {
	    _classCallCheck(this, HeaderView);

	    return _possibleConstructorReturn(this, (HeaderView.__proto__ || Object.getPrototypeOf(HeaderView)).apply(this, arguments));
	  }

	  _createClass(HeaderView, [{
	    key: 'template',
	    value: function template(model) {
	      return (0, _headerFooter2.default)(_underscore2.default.defaults({ group: 'head', escapeAttr: _escape.escapeAttr }, model));
	    }
	  }, {
	    key: 'rows',
	    get: function get() {
	      return this.tableView._state.headRows;
	    }
	  }]);

	  return HeaderView;
	}(HeaderFooterView);

	var FooterView = exports.FooterView = function (_HeaderFooterView2) {
	  _inherits(FooterView, _HeaderFooterView2);

	  function FooterView() {
	    _classCallCheck(this, FooterView);

	    return _possibleConstructorReturn(this, (FooterView.__proto__ || Object.getPrototypeOf(FooterView)).apply(this, arguments));
	  }

	  _createClass(FooterView, [{
	    key: 'template',
	    value: function template(model) {
	      return (0, _headerFooter2.default)(_underscore2.default.defaults({ group: 'foot', escapeAttr: _escape.escapeAttr }, model));
	    }
	  }, {
	    key: 'rows',
	    get: function get() {
	      return this.tableView._state.footRows;
	    }
	  }]);

	  return FooterView;
	}(HeaderFooterView);

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(10);

	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	;var locals_for_with = (locals || {});(function (escapeAttr, group, rows) {
	jade_mixins["mixinHeadCell"] = jade_interp = function(cell, escapeAttr){
	var block = (this && this.block), attributes = (this && this.attributes) || {};
	var attr = escapeAttr(cell.attributes)
	buf.push("<th" + (jade.attrs(jade.merge([{"class": (jade_interp = [true], jade.joinClasses([cell.classes].map(jade.joinClasses).map(function (cls, i) {   return jade_interp[i] ? jade.escape(cls) : cls })))},attr]), true)) + ">");
	if ( (cell.html))
	{
	buf.push(null == (jade_interp = cell.html) ? "" : jade_interp);
	}
	else
	{
	buf.push(jade.escape(null == (jade_interp = cell.value) ? "" : jade_interp));
	}
	buf.push("</th>");
	};
	jade_mixins["mixinCell"] = jade_interp = function(cell, escapeAttr){
	var block = (this && this.block), attributes = (this && this.attributes) || {};
	var attr = escapeAttr(cell.attributes)
	buf.push("<td" + (jade.attrs(jade.merge([{"class": (jade_interp = [true], jade.joinClasses([cell.classes].map(jade.joinClasses).map(function (cls, i) {   return jade_interp[i] ? jade.escape(cls) : cls })))},attr]), true)) + ">");
	if ( (cell.html))
	{
	buf.push(null == (jade_interp = cell.html) ? "" : jade_interp);
	}
	else
	{
	buf.push(jade.escape(null == (jade_interp = cell.value) ? "" : jade_interp));
	}
	buf.push("</td>");
	};
	jade_mixins["mixinRow"] = jade_interp = function(row, group, escapeAttr){
	var block = (this && this.block), attributes = (this && this.attributes) || {};
	var attr = escapeAttr(row.attributes)
	buf.push("<tr" + (jade.attrs(jade.merge([{"class": (jade_interp = [true], jade.joinClasses([row.classes].map(jade.joinClasses).map(function (cls, i) {   return jade_interp[i] ? jade.escape(cls) : cls })))},attr]), true)) + ">");
	// iterate row.cells || []
	;(function(){
	  var $$obj = row.cells || [];
	  if ('number' == typeof $$obj.length) {

	    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
	      var cell = $$obj[$index];

	switch (group){
	case 'head':
	jade_mixins["mixinHeadCell"](cell, escapeAttr);
	  break;
	case 'body':
	case 'foot':
	jade_mixins["mixinCell"](cell, escapeAttr);
	  break;
	}
	    }

	  } else {
	    var $$l = 0;
	    for (var $index in $$obj) {
	      $$l++;      var cell = $$obj[$index];

	switch (group){
	case 'head':
	jade_mixins["mixinHeadCell"](cell, escapeAttr);
	  break;
	case 'body':
	case 'foot':
	jade_mixins["mixinCell"](cell, escapeAttr);
	  break;
	}
	    }

	  }
	}).call(this);

	buf.push("</tr>");
	};
	jade_mixins["mixinRows"] = jade_interp = function(rows, group, escapeAttr){
	var block = (this && this.block), attributes = (this && this.attributes) || {};
	// iterate rows || []
	;(function(){
	  var $$obj = rows || [];
	  if ('number' == typeof $$obj.length) {

	    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
	      var row = $$obj[$index];

	jade_mixins["mixinRow"](row, group, escapeAttr);
	    }

	  } else {
	    var $$l = 0;
	    for (var $index in $$obj) {
	      $$l++;      var row = $$obj[$index];

	jade_mixins["mixinRow"](row, group, escapeAttr);
	    }

	  }
	}).call(this);

	};
	jade_mixins["mixinRows"](rows, group, escapeAttr);}.call(this,"escapeAttr" in locals_for_with?locals_for_with.escapeAttr:typeof escapeAttr!=="undefined"?escapeAttr:undefined,"group" in locals_for_with?locals_for_with.group:typeof group!=="undefined"?group:undefined,"rows" in locals_for_with?locals_for_with.rows:typeof rows!=="undefined"?rows:undefined));;return buf.join("");
	}

/***/ }),
/* 96 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	exports.escapeAttr = escapeAttr;
	var pugMatch = /["&<>]/;

	function pugEscape(_html) {
	  var html = String(_html);
	  var regexResult = pugMatch.exec(html);
	  if (!regexResult) {
	    return _html;
	  }

	  var result = '';
	  var i = void 0,
	      lastIndex = void 0,
	      escape = void 0;
	  for (i = regexResult.index, lastIndex = 0; i < html.length; i++) {
	    switch (html.charCodeAt(i)) {
	      case 34:
	        escape = '&quot;';break;
	      case 38:
	        escape = '&amp;';break;
	      case 60:
	        escape = '&lt;';break;
	      case 62:
	        escape = '&gt;';break;
	      default:
	        continue;
	    }
	    if (lastIndex !== i) {
	      result += html.substring(lastIndex, i);
	    }
	    lastIndex = i + 1;
	    result += escape;
	  }
	  if (lastIndex !== i) {
	    return result + html.substring(lastIndex, i);
	  }

	  return result;
	}

	function escapeAttr(attr) {
	  if (Array.isArray(attr)) {
	    return attr.map(function (val) {
	      return escapeAttr(val);
	    });
	  } else if ((typeof attr === 'undefined' ? 'undefined' : _typeof(attr)) === 'object') {
	    return Object.keys(attr).reduce(function (memo, key) {
	      memo[key] = escapeAttr(attr[key]);
	      return memo;
	    }, {});
	  } else if (typeof attr === 'string') {
	    return pugEscape(attr);
	  }
	  return attr;
	}

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(10);

	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	;var locals_for_with = (locals || {});(function (escapeAttr, row) {
	jade_mixins["mixinHeadCell"] = jade_interp = function(cell, escapeAttr){
	var block = (this && this.block), attributes = (this && this.attributes) || {};
	var attr = escapeAttr(cell.attributes)
	buf.push("<th" + (jade.attrs(jade.merge([{"class": (jade_interp = [true], jade.joinClasses([cell.classes].map(jade.joinClasses).map(function (cls, i) {   return jade_interp[i] ? jade.escape(cls) : cls })))},attr]), true)) + ">");
	if ( (cell.html))
	{
	buf.push(null == (jade_interp = cell.html) ? "" : jade_interp);
	}
	else
	{
	buf.push(jade.escape(null == (jade_interp = cell.value) ? "" : jade_interp));
	}
	buf.push("</th>");
	};
	jade_mixins["mixinCell"] = jade_interp = function(cell, escapeAttr){
	var block = (this && this.block), attributes = (this && this.attributes) || {};
	var attr = escapeAttr(cell.attributes)
	buf.push("<td" + (jade.attrs(jade.merge([{"class": (jade_interp = [true], jade.joinClasses([cell.classes].map(jade.joinClasses).map(function (cls, i) {   return jade_interp[i] ? jade.escape(cls) : cls })))},attr]), true)) + ">");
	if ( (cell.html))
	{
	buf.push(null == (jade_interp = cell.html) ? "" : jade_interp);
	}
	else
	{
	buf.push(jade.escape(null == (jade_interp = cell.value) ? "" : jade_interp));
	}
	buf.push("</td>");
	};
	jade_mixins["mixinRow"] = jade_interp = function(row, group, escapeAttr){
	var block = (this && this.block), attributes = (this && this.attributes) || {};
	var attr = escapeAttr(row.attributes)
	buf.push("<tr" + (jade.attrs(jade.merge([{"class": (jade_interp = [true], jade.joinClasses([row.classes].map(jade.joinClasses).map(function (cls, i) {   return jade_interp[i] ? jade.escape(cls) : cls })))},attr]), true)) + ">");
	// iterate row.cells || []
	;(function(){
	  var $$obj = row.cells || [];
	  if ('number' == typeof $$obj.length) {

	    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
	      var cell = $$obj[$index];

	switch (group){
	case 'head':
	jade_mixins["mixinHeadCell"](cell, escapeAttr);
	  break;
	case 'body':
	case 'foot':
	jade_mixins["mixinCell"](cell, escapeAttr);
	  break;
	}
	    }

	  } else {
	    var $$l = 0;
	    for (var $index in $$obj) {
	      $$l++;      var cell = $$obj[$index];

	switch (group){
	case 'head':
	jade_mixins["mixinHeadCell"](cell, escapeAttr);
	  break;
	case 'body':
	case 'foot':
	jade_mixins["mixinCell"](cell, escapeAttr);
	  break;
	}
	    }

	  }
	}).call(this);

	buf.push("</tr>");
	};











	jade_mixins["mixinRow"](row, 'body', escapeAttr);}.call(this,"escapeAttr" in locals_for_with?locals_for_with.escapeAttr:typeof escapeAttr!=="undefined"?escapeAttr:undefined,"row" in locals_for_with?locals_for_with.row:typeof row!=="undefined"?row:undefined));;return buf.join("");
	}

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(10);

	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	;var locals_for_with = (locals || {});(function (classes, dataTableAttributes, headerAttributes) {
	var tableStyle = {
	  'border-collapse': 'collapse',
	  'margin': 0,
	  'table-layout': 'fixed',
	};

	buf.push("<div class=\"table-container\"><div class=\"fixed-header\"><table" + (jade.attrs(jade.merge([{"style": jade.escape(jade.style(tableStyle)),"role": "grid","class": (jade_interp = [null,true], jade.joinClasses(['fixed-header',classes].map(jade.joinClasses).map(function (cls, i) {   return jade_interp[i] ? jade.escape(cls) : cls })))},headerAttributes]), true)) + "><colgroup class=\"column-group\"></colgroup><thead class=\"header\"></thead></table></div><div class=\"viewport\"><table" + (jade.attrs(jade.merge([{"style": jade.escape(jade.style(tableStyle)),"role": "grid","class": (jade_interp = [null,true], jade.joinClasses(['data-table',classes].map(jade.joinClasses).map(function (cls, i) {   return jade_interp[i] ? jade.escape(cls) : cls })))},dataTableAttributes]), true)) + "><colgroup class=\"column-group\"></colgroup><tbody><tr role=\"presentation\" class=\"top-filler\"></tr><tr role=\"presentation\" class=\"bottom-filler\"></tr></tbody><tfoot class=\"footer\"></tfoot></table></div></div>");}.call(this,"classes" in locals_for_with?locals_for_with.classes:typeof classes!=="undefined"?classes:undefined,"dataTableAttributes" in locals_for_with?locals_for_with.dataTableAttributes:typeof dataTableAttributes!=="undefined"?dataTableAttributes:undefined,"headerAttributes" in locals_for_with?locals_for_with.headerAttributes:typeof headerAttributes!=="undefined"?headerAttributes:undefined));;return buf.join("");
	}

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(10);

	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	;var locals_for_with = (locals || {});(function (classes, dataTableAttributes) {
	var tableStyle = {
	  'border-collapse': 'collapse',
	  'margin': 0,
	};

	buf.push("<div class=\"table-container\"><table" + (jade.attrs(jade.merge([{"style": jade.escape(jade.style(tableStyle)),"role": "grid","class": (jade_interp = [null,true], jade.joinClasses(['data-table',classes].map(jade.joinClasses).map(function (cls, i) {   return jade_interp[i] ? jade.escape(cls) : cls })))},dataTableAttributes]), true)) + "><colgroup class=\"column-group\"></colgroup><thead class=\"header\"></thead><tbody> <tr role=\"presentation\" class=\"top-filler\"></tr><tr role=\"presentation\" class=\"bottom-filler\"></tr></tbody><tfoot class=\"footer\"></tfoot></table></div>");}.call(this,"classes" in locals_for_with?locals_for_with.classes:typeof classes!=="undefined"?classes:undefined,"dataTableAttributes" in locals_for_with?locals_for_with.dataTableAttributes:typeof dataTableAttributes!=="undefined"?dataTableAttributes:undefined));;return buf.join("");
	}

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(10);

	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	;var locals_for_with = (locals || {});(function (classes, dataTableAttributes, headerAttributes) {
	var tableStyle = {
	  'border-collapse': 'collapse',
	  'margin': 0,
	  'table-layout': 'fixed',
	};

	buf.push("<div class=\"table-container\"><table" + (jade.attrs(jade.merge([{"style": jade.escape(jade.style(tableStyle)),"role": "grid","class": (jade_interp = [null,true], jade.joinClasses(['sticky-header',classes].map(jade.joinClasses).map(function (cls, i) {   return jade_interp[i] ? jade.escape(cls) : cls })))},headerAttributes]), true)) + "><colgroup class=\"column-group\"></colgroup><thead class=\"header\"></thead></table><div class=\"sticky-header-filler\"></div><table" + (jade.attrs(jade.merge([{"style": jade.escape(jade.style(tableStyle)),"role": "grid","class": (jade_interp = [null,true], jade.joinClasses(['data-table',classes].map(jade.joinClasses).map(function (cls, i) {   return jade_interp[i] ? jade.escape(cls) : cls })))},dataTableAttributes]), true)) + "><colgroup class=\"column-group\"></colgroup><tbody><tr role=\"presentation\" class=\"top-filler\"></tr><tr role=\"presentation\" class=\"bottom-filler\"></tr></tbody><tfoot class=\"footer\"></tfoot></table></div>");}.call(this,"classes" in locals_for_with?locals_for_with.classes:typeof classes!=="undefined"?classes:undefined,"dataTableAttributes" in locals_for_with?locals_for_with.dataTableAttributes:typeof dataTableAttributes!=="undefined"?dataTableAttributes:undefined,"headerAttributes" in locals_for_with?locals_for_with.headerAttributes:typeof headerAttributes!=="undefined"?headerAttributes:undefined));;return buf.join("");
	}

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	var jade = __webpack_require__(10);

	module.exports = function template(locals) {
	var buf = [];
	var jade_mixins = {};
	var jade_interp;
	;var locals_for_with = (locals || {});(function (cols, escapeAttr, undefined) {
	// iterate cols || []
	;(function(){
	  var $$obj = cols || [];
	  if ('number' == typeof $$obj.length) {

	    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
	      var col = $$obj[$index];

	var columnStyle = col.width ? 'width: ' + col.width + ';' : null;
	var attr = escapeAttr(col.attributes);
	buf.push("<col" + (jade.attrs(jade.merge([{"style": jade.escape(jade.style(columnStyle)),"class": (jade_interp = [true], jade.joinClasses([col.classes].map(jade.joinClasses).map(function (cls, i) {   return jade_interp[i] ? jade.escape(cls) : cls })))},attr]), true)) + ">");
	    }

	  } else {
	    var $$l = 0;
	    for (var $index in $$obj) {
	      $$l++;      var col = $$obj[$index];

	var columnStyle = col.width ? 'width: ' + col.width + ';' : null;
	var attr = escapeAttr(col.attributes);
	buf.push("<col" + (jade.attrs(jade.merge([{"style": jade.escape(jade.style(columnStyle)),"class": (jade_interp = [true], jade.joinClasses([col.classes].map(jade.joinClasses).map(function (cls, i) {   return jade_interp[i] ? jade.escape(cls) : cls })))},attr]), true)) + ">");
	    }

	  }
	}).call(this);
	}.call(this,"cols" in locals_for_with?locals_for_with.cols:typeof cols!=="undefined"?cols:undefined,"escapeAttr" in locals_for_with?locals_for_with.escapeAttr:typeof escapeAttr!=="undefined"?escapeAttr:undefined,"undefined" in locals_for_with?locals_for_with.undefined: false?undefined:undefined));;return buf.join("");
	}

/***/ }),
/* 102 */
/***/ (function(module, exports) {

	module.exports = {"requirejs":{"config":{"paths":{"@bingads-webui-component-legacy/grid/examples":"@bingads-webui-component-legacy/grid/examples"}}},"name":"projection-grid","description":"Client side grid control in JavaScript using pipe and filter patterns.","keywords":[],"author":{"name":"Ahmed Kamel"},"main":"dist/projection-grid.js","version":"0.1.21","files":["dist"],"scripts":{"test":"gulp test","prepublish":"gulp prepublish"},"license":"MIT","devDependencies":{"babel-core":"^6.7.7","babel-loader":"^6.2.4","babel-polyfill":"^6.16.0","babel-preset-es2015":"^6.6.0","backbone":"^1.3.2","backbone-virtualized-listview":"~0.6.3","bluebird":"^3.5.1","bootstrap":"^3.3.6","bootstrap-webpack":"0.0.5","chai":"^3.5.0","coveralls":"^2.11.11","css-loader":"^0.23.1","del":"^2.2.0","eslint":"^2.5.1","eslint-config-xo":"^0.12.0","eslint-config-xo-space":"^0.11.0","exports-loader":"^0.6.3","extract-text-webpack-plugin":"^1.0.1","fast-binary-indexed-tree":"~1.0.0","file-loader":"^0.8.5","gulp":"^3.9.1","gulp-democase":"0.0.1","gulp-eslint":"^2.0.0","gulp-exclude-gitignore":"^1.0.0","gulp-jsdoc3":"^0.3.0","gulp-util":"^3.0.7","gulp-webdriver":"^2.0.1","imports-loader":"^0.6.5","isparta-loader":"^2.0.0","istanbul-instrumenter-loader":"^0.2.0","jade":"^1.11.0","jade-loader":"^0.8.0","jquery":"^2.2.2","js-data":"^2.9.0","js-data-http":"^2.2.2","json-loader":"^0.5.4","karma":"^1.3.0","karma-chrome-launcher":"^2.0.0","karma-coverage":"^1.1.1","karma-coverage-es6":"^0.2.7","karma-junit-reporter":"^1.1.0","karma-mocha":"^1.2.0","karma-mocha-reporter":"^2.2.0","karma-phantomjs-launcher":"^1.0.2","karma-sinon":"^1.0.5","karma-sourcemap-loader":"^0.3.7","karma-webpack":"^1.8.0","knockout":"^3.4.0","less":"^2.6.1","less-loader":"^2.2.3","lodash":"^4.6.1","mocha":"^2.4.5","node-static":"^0.7.7","pagination-control":"~0.1.0","phantomjs-prebuilt":"^2.1.7","requirejs":"^2.2.0","resolve":"^1.1.7","sinon":"^1.17.6","sinon-chai":"^2.8.0","source-map-loader":"^0.1.5","style-loader":"^0.13.1","underscore":"^1.8.3","url-loader":"^0.5.7","wdio-dot-reporter":"0.0.5","wdio-junit-reporter":"0.0.2","wdio-mocha-framework":"^0.5.9","webdriverio":"^4.0.5","webpack":"^1.12.14","webpack-stream":"^3.1.0"},"peerDependencies":{"backbone":"^1.3.2","backbone-virtualized-listview":"~0.6.2","bluebird":"^3.3.4","fast-binary-indexed-tree":"~1.0.0","jquery":"^2.2.2","js-data":"^2.9.0","knockout":"^3.4.0","underscore":"^1.8.3"}}

/***/ })
/******/ ])
});
;
